/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
export type Maybe<T> = T;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** BigInt field */
  BigInt: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  /** 64-bit signed integer. */
  Long: { input: any; output: any; }
  /** Represents NULL values */
  Void: { input: any; output: any; }
};

export type AccumulatedDeviceSyncStatusResponseType = {
  __typename?: 'AccumulatedDeviceSyncStatusResponseType';
  details: Array<DeviceSyncStatusResponseType>;
  previousSyncStatus: DeviceSyncStatusEnum;
  syncTimestamp?: Maybe<Scalars['DateTime']['output']>;
  targetSyncStatus: DeviceSyncStatusEnum;
};

export type AddressSuggestionType = {
  __typename?: 'AddressSuggestionType';
  label: Scalars['String']['output'];
  location: LocationType;
  placeId?: Maybe<Scalars['String']['output']>;
};

export enum ArchEnum {
  Amd64 = 'AMD64',
  Arm = 'ARM',
  Arm64 = 'ARM64',
  I386 = 'I386'
}

export enum ArtifactStatus {
  NotFound = 'NOT_FOUND',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export type ArtifactsResponseType = {
  __typename?: 'ArtifactsResponseType';
  message?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ArtifactStatus>;
};

export type AssetBaseResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type AssetLinkFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  destinationType?: InputMaybe<StringFilterInput>;
  sourceType?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type AssetLinkResponseType = {
  __typename?: 'AssetLinkResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  /** The destination ID of the asset link. This is the ID of the asset (resource) to which the link is created. */
  destinationId: Scalars['String']['output'];
  /** The destination type of the asset link. This is the type of the asset (resource) to which the link is created. */
  destinationType: AssetTypeEnum;
  lock?: Maybe<LockResponseType>;
  /** The meta data for the asset link. The type is dependent on the asset types to link. */
  metaData: AssetMetaData;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** The source ID of the asset link. This is the ID of the asset (resource) from which the link is created. */
  sourceId: Scalars['String']['output'];
  /** The source type of the asset link. This is the type of the asset (resource) from which the link is created. */
  sourceType: AssetTypeEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type AssetMetaData = DeviceToDeviceLinkMetaDataType | DeviceToGatewayLinkMetaDataType | DocumentToAssetLinkMetaDataType | ProjectToDeviceLinkMetaDataType | ProjectToProjectLinkMetaDataType | TagToAssetLinkMetaDataType;

export type AssetMetaDataCombinedInput = {
  assetVersionId?: InputMaybe<Scalars['String']['input']>;
  /** Specific version ID of the destination project. */
  destinationVersionId?: InputMaybe<Scalars['String']['input']>;
  /** The IP address of the device within the project. */
  deviceIpAddress?: InputMaybe<Scalars['String']['input']>;
  /** The name of the device within the project. */
  deviceName?: InputMaybe<Scalars['String']['input']>;
  /** The subnet mask of the device within the project. */
  deviceSubnet?: InputMaybe<Scalars['String']['input']>;
  /** The type of the device within the project. */
  deviceType?: InputMaybe<Scalars['String']['input']>;
  /** The interface used for the link between the two devices. */
  interface?: InputMaybe<Scalars['String']['input']>;
  /** A flag indicating if this is the primary gateway for the device. */
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  /** The protocol used for the link between the two devices. */
  protocol?: InputMaybe<Scalars['String']['input']>;
  /** Specific version ID of the source project. */
  sourceVersionId?: InputMaybe<Scalars['String']['input']>;
  /** Version ID of the target project for the linked device. */
  targetProjectVersionId?: InputMaybe<Scalars['String']['input']>;
};

export enum AssetTypeEnum {
  Device = 'DEVICE',
  Document = 'DOCUMENT',
  DocumentVersion = 'DOCUMENT_VERSION',
  Gateway = 'GATEWAY',
  License = 'LICENSE',
  Pipeline = 'PIPELINE',
  Project = 'PROJECT',
  ProjectVersion = 'PROJECT_VERSION',
  ResourceGroup = 'RESOURCE_GROUP',
  Secret = 'SECRET',
  SecretVersion = 'SECRET_VERSION',
  Tag = 'TAG',
  Vault = 'VAULT',
  Workstation = 'WORKSTATION'
}

export enum AuditLogCategory {
  Authentication = 'AUTHENTICATION',
  DataFlow = 'DATA_FLOW',
  Permissions = 'PERMISSIONS',
  Security = 'SECURITY',
  Users = 'USERS'
}

export type AuditLogCsvExportTriggerResponseType = {
  __typename?: 'AuditLogCsvExportTriggerResponseType';
  channel: Scalars['String']['output'];
  message: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
};

export enum AuditLogEventTypeSource {
  AuditLogsCsvExportRequested = 'AUDIT_LOGS_CSV_EXPORT_REQUESTED',
  DeploymentJobCanceled = 'DEPLOYMENT_JOB_CANCELED',
  DeploymentJobCreated = 'DEPLOYMENT_JOB_CREATED',
  DeploymentJobDeleted = 'DEPLOYMENT_JOB_DELETED',
  DeploymentJobFailed = 'DEPLOYMENT_JOB_FAILED',
  DeploymentJobProcessing = 'DEPLOYMENT_JOB_PROCESSING',
  DeploymentJobSkipped = 'DEPLOYMENT_JOB_SKIPPED',
  DeploymentJobSuccess = 'DEPLOYMENT_JOB_SUCCESS',
  DeploymentJobTimedOut = 'DEPLOYMENT_JOB_TIMED_OUT',
  DeviceBackupSettingsCreated = 'DEVICE_BACKUP_SETTINGS_CREATED',
  DeviceBackupSettingsDeleted = 'DEVICE_BACKUP_SETTINGS_DELETED',
  DeviceBackupSettingsUpdated = 'DEVICE_BACKUP_SETTINGS_UPDATED',
  DeviceCreated = 'DEVICE_CREATED',
  DeviceDeleted = 'DEVICE_DELETED',
  DeviceGatewayLinkCreated = 'DEVICE_GATEWAY_LINK_CREATED',
  DeviceGatewayLinkDeleted = 'DEVICE_GATEWAY_LINK_DELETED',
  DeviceGatewayLinkUpdated = 'DEVICE_GATEWAY_LINK_UPDATED',
  DevicePasswordUpdateJobCanceled = 'DEVICE_PASSWORD_UPDATE_JOB_CANCELED',
  DevicePasswordUpdateJobCreated = 'DEVICE_PASSWORD_UPDATE_JOB_CREATED',
  DevicePasswordUpdateJobDeleted = 'DEVICE_PASSWORD_UPDATE_JOB_DELETED',
  DevicePasswordUpdateJobFailed = 'DEVICE_PASSWORD_UPDATE_JOB_FAILED',
  DevicePasswordUpdateJobProcessing = 'DEVICE_PASSWORD_UPDATE_JOB_PROCESSING',
  DevicePasswordUpdateJobSkipped = 'DEVICE_PASSWORD_UPDATE_JOB_SKIPPED',
  DevicePasswordUpdateJobSuccess = 'DEVICE_PASSWORD_UPDATE_JOB_SUCCESS',
  DevicePasswordUpdateJobTimedOut = 'DEVICE_PASSWORD_UPDATE_JOB_TIMED_OUT',
  DeviceSnapshotJobCanceled = 'DEVICE_SNAPSHOT_JOB_CANCELED',
  DeviceSnapshotJobCreated = 'DEVICE_SNAPSHOT_JOB_CREATED',
  DeviceSnapshotJobDeleted = 'DEVICE_SNAPSHOT_JOB_DELETED',
  DeviceSnapshotJobFailed = 'DEVICE_SNAPSHOT_JOB_FAILED',
  DeviceSnapshotJobProcessing = 'DEVICE_SNAPSHOT_JOB_PROCESSING',
  DeviceSnapshotJobSkipped = 'DEVICE_SNAPSHOT_JOB_SKIPPED',
  DeviceSnapshotJobSuccess = 'DEVICE_SNAPSHOT_JOB_SUCCESS',
  DeviceSnapshotJobTimedOut = 'DEVICE_SNAPSHOT_JOB_TIMED_OUT',
  DeviceUpdated = 'DEVICE_UPDATED',
  DocumentCreated = 'DOCUMENT_CREATED',
  DocumentDeleted = 'DOCUMENT_DELETED',
  DocumentDeviceLinkCreated = 'DOCUMENT_DEVICE_LINK_CREATED',
  DocumentDeviceLinkDeleted = 'DOCUMENT_DEVICE_LINK_DELETED',
  DocumentDeviceLinkUpdated = 'DOCUMENT_DEVICE_LINK_UPDATED',
  DocumentGatewayLinkCreated = 'DOCUMENT_GATEWAY_LINK_CREATED',
  DocumentGatewayLinkDeleted = 'DOCUMENT_GATEWAY_LINK_DELETED',
  DocumentGatewayLinkUpdated = 'DOCUMENT_GATEWAY_LINK_UPDATED',
  DocumentProjectLinkCreated = 'DOCUMENT_PROJECT_LINK_CREATED',
  DocumentProjectLinkDeleted = 'DOCUMENT_PROJECT_LINK_DELETED',
  DocumentProjectLinkUpdated = 'DOCUMENT_PROJECT_LINK_UPDATED',
  DocumentUpdated = 'DOCUMENT_UPDATED',
  DocumentVersionCreated = 'DOCUMENT_VERSION_CREATED',
  DocumentVersionDeleted = 'DOCUMENT_VERSION_DELETED',
  DocumentVersionFileUploaded = 'DOCUMENT_VERSION_FILE_UPLOADED',
  DocumentVersionUpdated = 'DOCUMENT_VERSION_UPDATED',
  FailedLogin = 'FAILED_LOGIN',
  GatewayCreated = 'GATEWAY_CREATED',
  GatewayDeleted = 'GATEWAY_DELETED',
  GatewayUpdated = 'GATEWAY_UPDATED',
  GlobalBackupSettingsCreated = 'GLOBAL_BACKUP_SETTINGS_CREATED',
  GlobalBackupSettingsDeleted = 'GLOBAL_BACKUP_SETTINGS_DELETED',
  GlobalBackupSettingsUpdated = 'GLOBAL_BACKUP_SETTINGS_UPDATED',
  IdeaasSessionEnded = 'IDEAAS_SESSION_ENDED',
  IdeaasSessionStarted = 'IDEAAS_SESSION_STARTED',
  LicenseCreated = 'LICENSE_CREATED',
  LicenseDeleted = 'LICENSE_DELETED',
  LicenseUpdated = 'LICENSE_UPDATED',
  LicenseValidateJobCanceled = 'LICENSE_VALIDATE_JOB_CANCELED',
  LicenseValidateJobCreated = 'LICENSE_VALIDATE_JOB_CREATED',
  LicenseValidateJobDeleted = 'LICENSE_VALIDATE_JOB_DELETED',
  LicenseValidateJobFailed = 'LICENSE_VALIDATE_JOB_FAILED',
  LicenseValidateJobProcessing = 'LICENSE_VALIDATE_JOB_PROCESSING',
  LicenseValidateJobSkipped = 'LICENSE_VALIDATE_JOB_SKIPPED',
  LicenseValidateJobSuccess = 'LICENSE_VALIDATE_JOB_SUCCESS',
  LicenseValidateJobTimedOut = 'LICENSE_VALIDATE_JOB_TIMED_OUT',
  LockCreated = 'LOCK_CREATED',
  LockDeleted = 'LOCK_DELETED',
  LockUpdated = 'LOCK_UPDATED',
  PipelineCreated = 'PIPELINE_CREATED',
  PipelineDeleted = 'PIPELINE_DELETED',
  PipelineExecutionCreated = 'PIPELINE_EXECUTION_CREATED',
  PipelineExecutionDeleted = 'PIPELINE_EXECUTION_DELETED',
  PipelineExecutionFailed = 'PIPELINE_EXECUTION_FAILED',
  PipelineExecutionSuccess = 'PIPELINE_EXECUTION_SUCCESS',
  PipelineExecutionTimedOut = 'PIPELINE_EXECUTION_TIMED_OUT',
  PipelineExecutionWarning = 'PIPELINE_EXECUTION_WARNING',
  PipelineUpdated = 'PIPELINE_UPDATED',
  ProjectBackupJobCanceled = 'PROJECT_BACKUP_JOB_CANCELED',
  ProjectBackupJobCreated = 'PROJECT_BACKUP_JOB_CREATED',
  ProjectBackupJobDeleted = 'PROJECT_BACKUP_JOB_DELETED',
  ProjectBackupJobFailed = 'PROJECT_BACKUP_JOB_FAILED',
  ProjectBackupJobProcessing = 'PROJECT_BACKUP_JOB_PROCESSING',
  ProjectBackupJobSkipped = 'PROJECT_BACKUP_JOB_SKIPPED',
  ProjectBackupJobSuccess = 'PROJECT_BACKUP_JOB_SUCCESS',
  ProjectBackupJobTimedOut = 'PROJECT_BACKUP_JOB_TIMED_OUT',
  ProjectConvertJobCanceled = 'PROJECT_CONVERT_JOB_CANCELED',
  ProjectConvertJobCreated = 'PROJECT_CONVERT_JOB_CREATED',
  ProjectConvertJobDeleted = 'PROJECT_CONVERT_JOB_DELETED',
  ProjectConvertJobFailed = 'PROJECT_CONVERT_JOB_FAILED',
  ProjectConvertJobProcessing = 'PROJECT_CONVERT_JOB_PROCESSING',
  ProjectConvertJobSkipped = 'PROJECT_CONVERT_JOB_SKIPPED',
  ProjectConvertJobSuccess = 'PROJECT_CONVERT_JOB_SUCCESS',
  ProjectConvertJobTimedOut = 'PROJECT_CONVERT_JOB_TIMED_OUT',
  ProjectCreated = 'PROJECT_CREATED',
  ProjectDeleted = 'PROJECT_DELETED',
  ProjectDeviceLinkCreated = 'PROJECT_DEVICE_LINK_CREATED',
  ProjectDeviceLinkDeleted = 'PROJECT_DEVICE_LINK_DELETED',
  ProjectDeviceLinkUpdated = 'PROJECT_DEVICE_LINK_UPDATED',
  ProjectDeviceTargetVersionChanged = 'PROJECT_DEVICE_TARGET_VERSION_CHANGED',
  ProjectLibraryUpgradeJobCanceled = 'PROJECT_LIBRARY_UPGRADE_JOB_CANCELED',
  ProjectLibraryUpgradeJobCreated = 'PROJECT_LIBRARY_UPGRADE_JOB_CREATED',
  ProjectLibraryUpgradeJobDeleted = 'PROJECT_LIBRARY_UPGRADE_JOB_DELETED',
  ProjectLibraryUpgradeJobFailed = 'PROJECT_LIBRARY_UPGRADE_JOB_FAILED',
  ProjectLibraryUpgradeJobProcessing = 'PROJECT_LIBRARY_UPGRADE_JOB_PROCESSING',
  ProjectLibraryUpgradeJobSkipped = 'PROJECT_LIBRARY_UPGRADE_JOB_SKIPPED',
  ProjectLibraryUpgradeJobSuccess = 'PROJECT_LIBRARY_UPGRADE_JOB_SUCCESS',
  ProjectLibraryUpgradeJobTimedOut = 'PROJECT_LIBRARY_UPGRADE_JOB_TIMED_OUT',
  ProjectMergeJobCanceled = 'PROJECT_MERGE_JOB_CANCELED',
  ProjectMergeJobCreated = 'PROJECT_MERGE_JOB_CREATED',
  ProjectMergeJobDeleted = 'PROJECT_MERGE_JOB_DELETED',
  ProjectMergeJobFailed = 'PROJECT_MERGE_JOB_FAILED',
  ProjectMergeJobProcessing = 'PROJECT_MERGE_JOB_PROCESSING',
  ProjectMergeJobSkipped = 'PROJECT_MERGE_JOB_SKIPPED',
  ProjectMergeJobSuccess = 'PROJECT_MERGE_JOB_SUCCESS',
  ProjectMergeJobTimedOut = 'PROJECT_MERGE_JOB_TIMED_OUT',
  ProjectProjectLinkCreated = 'PROJECT_PROJECT_LINK_CREATED',
  ProjectProjectLinkDeleted = 'PROJECT_PROJECT_LINK_DELETED',
  ProjectProjectLinkUpdated = 'PROJECT_PROJECT_LINK_UPDATED',
  ProjectUpdated = 'PROJECT_UPDATED',
  ProjectUpdateOpcUaInterfaceJobCanceled = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_CANCELED',
  ProjectUpdateOpcUaInterfaceJobCreated = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_CREATED',
  ProjectUpdateOpcUaInterfaceJobDeleted = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_DELETED',
  ProjectUpdateOpcUaInterfaceJobFailed = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_FAILED',
  ProjectUpdateOpcUaInterfaceJobProcessing = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_PROCESSING',
  ProjectUpdateOpcUaInterfaceJobSkipped = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_SKIPPED',
  ProjectUpdateOpcUaInterfaceJobSuccess = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_SUCCESS',
  ProjectUpdateOpcUaInterfaceJobTimedOut = 'PROJECT_UPDATE_OPC_UA_INTERFACE_JOB_TIMED_OUT',
  ProjectVersionCreated = 'PROJECT_VERSION_CREATED',
  ProjectVersionDeleted = 'PROJECT_VERSION_DELETED',
  ProjectVersionFileUploaded = 'PROJECT_VERSION_FILE_UPLOADED',
  ProjectVersionUpdated = 'PROJECT_VERSION_UPDATED',
  ReadVariableListFromDeviceJobCanceled = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_CANCELED',
  ReadVariableListFromDeviceJobCreated = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_CREATED',
  ReadVariableListFromDeviceJobDeleted = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_DELETED',
  ReadVariableListFromDeviceJobFailed = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_FAILED',
  ReadVariableListFromDeviceJobProcessing = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_PROCESSING',
  ReadVariableListFromDeviceJobSkipped = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_SKIPPED',
  ReadVariableListFromDeviceJobSuccess = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_SUCCESS',
  ReadVariableListFromDeviceJobTimedOut = 'READ_VARIABLE_LIST_FROM_DEVICE_JOB_TIMED_OUT',
  ResourceGroupCreated = 'RESOURCE_GROUP_CREATED',
  ResourceGroupDeleted = 'RESOURCE_GROUP_DELETED',
  ResourceGroupUpdated = 'RESOURCE_GROUP_UPDATED',
  SecretCreated = 'SECRET_CREATED',
  SecretDeleted = 'SECRET_DELETED',
  SecretUpdated = 'SECRET_UPDATED',
  SecurityAnomaly = 'SECURITY_ANOMALY',
  SuccessfulLogin = 'SUCCESSFUL_LOGIN',
  TagCreated = 'TAG_CREATED',
  TagDeleted = 'TAG_DELETED',
  TagDeviceLinkCreated = 'TAG_DEVICE_LINK_CREATED',
  TagDeviceLinkDeleted = 'TAG_DEVICE_LINK_DELETED',
  TagDeviceLinkUpdated = 'TAG_DEVICE_LINK_UPDATED',
  TagDocumentLinkCreated = 'TAG_DOCUMENT_LINK_CREATED',
  TagDocumentLinkDeleted = 'TAG_DOCUMENT_LINK_DELETED',
  TagDocumentLinkUpdated = 'TAG_DOCUMENT_LINK_UPDATED',
  TagGatewayLinkCreated = 'TAG_GATEWAY_LINK_CREATED',
  TagGatewayLinkDeleted = 'TAG_GATEWAY_LINK_DELETED',
  TagGatewayLinkUpdated = 'TAG_GATEWAY_LINK_UPDATED',
  TagLicenseLinkCreated = 'TAG_LICENSE_LINK_CREATED',
  TagLicenseLinkDeleted = 'TAG_LICENSE_LINK_DELETED',
  TagLicenseLinkUpdated = 'TAG_LICENSE_LINK_UPDATED',
  TagPipelineLinkCreated = 'TAG_PIPELINE_LINK_CREATED',
  TagPipelineLinkDeleted = 'TAG_PIPELINE_LINK_DELETED',
  TagPipelineLinkUpdated = 'TAG_PIPELINE_LINK_UPDATED',
  TagProjectLinkCreated = 'TAG_PROJECT_LINK_CREATED',
  TagProjectLinkDeleted = 'TAG_PROJECT_LINK_DELETED',
  TagProjectLinkUpdated = 'TAG_PROJECT_LINK_UPDATED',
  TagUpdated = 'TAG_UPDATED',
  TagVaultLinkCreated = 'TAG_VAULT_LINK_CREATED',
  TagVaultLinkDeleted = 'TAG_VAULT_LINK_DELETED',
  TagVaultLinkUpdated = 'TAG_VAULT_LINK_UPDATED',
  TenantCreated = 'TENANT_CREATED',
  TenantDeleted = 'TENANT_DELETED',
  TenantSelected = 'TENANT_SELECTED',
  TenantUpdated = 'TENANT_UPDATED',
  UserConfirmed = 'USER_CONFIRMED',
  UserCreated = 'USER_CREATED',
  UserDeleted = 'USER_DELETED',
  UserGroupCreated = 'USER_GROUP_CREATED',
  UserGroupDeleted = 'USER_GROUP_DELETED',
  UserGroupUpdated = 'USER_GROUP_UPDATED',
  UserLogin = 'USER_LOGIN',
  UserRoleCreated = 'USER_ROLE_CREATED',
  UserRoleDeleted = 'USER_ROLE_DELETED',
  UserRoleUpdated = 'USER_ROLE_UPDATED',
  UserRoleUserLinkCreated = 'USER_ROLE_USER_LINK_CREATED',
  UserRoleUserLinkDeleted = 'USER_ROLE_USER_LINK_DELETED',
  UserRoleUserLinkUpdated = 'USER_ROLE_USER_LINK_UPDATED',
  UserSignOut = 'USER_SIGN_OUT',
  UserUpdated = 'USER_UPDATED',
  VaultCreated = 'VAULT_CREATED',
  VaultDeleted = 'VAULT_DELETED',
  VaultUpdated = 'VAULT_UPDATED',
  VscodeSessionEnded = 'VSCODE_SESSION_ENDED',
  VscodeSessionStarted = 'VSCODE_SESSION_STARTED',
  WriteVariableListToDeviceJobCanceled = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_CANCELED',
  WriteVariableListToDeviceJobCreated = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_CREATED',
  WriteVariableListToDeviceJobDeleted = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_DELETED',
  WriteVariableListToDeviceJobFailed = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_FAILED',
  WriteVariableListToDeviceJobProcessing = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_PROCESSING',
  WriteVariableListToDeviceJobSkipped = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_SKIPPED',
  WriteVariableListToDeviceJobSuccess = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_SUCCESS',
  WriteVariableListToDeviceJobTimedOut = 'WRITE_VARIABLE_LIST_TO_DEVICE_JOB_TIMED_OUT'
}

export type AuditLogFilterInput = {
  category?: InputMaybe<StringFilterInput>;
  creationUserId?: InputMaybe<StringFilterInput>;
  eventTimestamp?: InputMaybe<StringFilterInput>;
  eventType?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
};

export type AuditLogResponseType = {
  __typename?: 'AuditLogResponseType';
  auditLogId: Scalars['String']['output'];
  category?: Maybe<AuditLogCategory>;
  changes?: Maybe<Array<ChangeEntryType>>;
  changesMessage?: Maybe<Scalars['String']['output']>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  data: Scalars['JSON']['output'];
  detailType: Scalars['String']['output'];
  entityKey?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventTimestamp: Scalars['DateTime']['output'];
  eventType: AuditLogEventTypeSource;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userMessage?: Maybe<Scalars['String']['output']>;
};

export type AuthenticateTwoFactorAuthTokenInput = {
  challenge: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type AuthenticateTwoFactorAuthTokenResponseType = {
  __typename?: 'AuthenticateTwoFactorAuthTokenResponseType';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  sessionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type BaseResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export enum BillingBillingModeEnum {
  Expost = 'EXPOST',
  Upfront = 'UPFRONT'
}

export type BillingCancelSubscriptionInput = {
  metadata?: InputMaybe<Array<BillingMetadataItemInput>>;
  scheduledTs?: InputMaybe<Scalars['Int']['input']>;
  subscriptionVersion: Scalars['String']['input'];
};

export type BillingCreateSubscriptionInput = {
  entitlements?: InputMaybe<Array<BillingEntitlementInput>>;
  metadata?: InputMaybe<Array<BillingMetadataItemInput>>;
  planVersion: Scalars['String']['input'];
  scheduledTs?: InputMaybe<Scalars['Int']['input']>;
  schedulingPolicy?: BillingSubscriptionChangeSchedulingPolicyEnum;
  subscriptionVersion: Scalars['String']['input'];
  term?: InputMaybe<BillingTermInput>;
  tier: Scalars['String']['input'];
};

export type BillingEntitlement = {
  __typename?: 'BillingEntitlement';
  allFeatures: Array<BillingFeatureEnum>;
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  feature: BillingFeatureEnum;
  metadata: Array<BillingMetadataItem>;
  metering?: Maybe<BillingMeteringConfig>;
  provisionedUsage: BillingProvisionedUsage;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  singleton: Scalars['Boolean']['output'];
  usageType: BillingUsageTypeEnum;
};

export type BillingEntitlementInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  feature: BillingFeatureEnum;
  provisionedUsage?: InputMaybe<BillingProvisionedUsageInput>;
};

export type BillingEntitlementTermUsage = {
  __typename?: 'BillingEntitlementTermUsage';
  allFeatures: Array<BillingFeatureEnum>;
  carryover?: Maybe<Scalars['String']['output']>;
  confirmedUsage: Scalars['String']['output'];
  feature: BillingFeatureEnum;
  isCarryoverTemp?: Maybe<Scalars['Boolean']['output']>;
  period?: Maybe<BillingPeriodEnum>;
  periodExclusiveEndTs?: Maybe<Scalars['Int']['output']>;
  periodStartTs?: Maybe<Scalars['Int']['output']>;
  upfrontQuantity: Scalars['String']['output'];
};

export type BillingEntitlementUsageStatsInput = {
  feature: BillingFeatureEnum;
  maxReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  minReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  subscriptionVersion?: InputMaybe<Scalars['String']['input']>;
};

export type BillingExpostProvisionedUsage = {
  __typename?: 'BillingExpostProvisionedUsage';
  billing?: Maybe<BillingProvisionedUsageBillingConfig>;
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
};

export type BillingExpostProvisionedUsageInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BillingFeatureEnum {
  CreateAiCodeExplanation = 'CREATE_AI_CODE_EXPLANATION',
  CreateDevice = 'CREATE_DEVICE',
  CreateDocument = 'CREATE_DOCUMENT',
  CreateDocumentVersion = 'CREATE_DOCUMENT_VERSION',
  CreateProject = 'CREATE_PROJECT',
  CreateProjectVersion = 'CREATE_PROJECT_VERSION',
  Device = 'DEVICE',
  DeviceAgv = 'DEVICE_AGV',
  DeviceCnc = 'DEVICE_CNC',
  DeviceDrive = 'DEVICE_DRIVE',
  DeviceHmi = 'DEVICE_HMI',
  DeviceIndustrialSwitch = 'DEVICE_INDUSTRIAL_SWITCH',
  DeviceIpc = 'DEVICE_IPC',
  DeviceOther = 'DEVICE_OTHER',
  DevicePlc = 'DEVICE_PLC',
  DeviceRobot = 'DEVICE_ROBOT',
  DeviceScada = 'DEVICE_SCADA',
  Document = 'DOCUMENT',
  DocumentVersion = 'DOCUMENT_VERSION',
  EnterpriseAuth = 'ENTERPRISE_AUTH',
  EnterpriseSupport = 'ENTERPRISE_SUPPORT',
  Gateway = 'GATEWAY',
  LocalRunner = 'LOCAL_RUNNER',
  PocSupport = 'POC_SUPPORT',
  Project = 'PROJECT',
  ProjectVersion = 'PROJECT_VERSION',
  Rbac = 'RBAC',
  Recovery = 'RECOVERY',
  RunBackup = 'RUN_BACKUP',
  RunCompareProjectVersions = 'RUN_COMPARE_PROJECT_VERSIONS',
  RunConvertProject = 'RUN_CONVERT_PROJECT',
  RunDeployment = 'RUN_DEPLOYMENT',
  RunDevicePwRotation = 'RUN_DEVICE_PW_ROTATION',
  RunDeviceSnapshot = 'RUN_DEVICE_SNAPSHOT',
  RunDeviceSnapshotRestore = 'RUN_DEVICE_SNAPSHOT_RESTORE',
  RunFtpBackup = 'RUN_FTP_BACKUP',
  RunFtpRestore = 'RUN_FTP_RESTORE',
  RunMergeProjectVersions = 'RUN_MERGE_PROJECT_VERSIONS',
  RunProjectBackup = 'RUN_PROJECT_BACKUP',
  RunProjectDeployment = 'RUN_PROJECT_DEPLOYMENT',
  RunReadDeviceVarList = 'RUN_READ_DEVICE_VAR_LIST',
  RunSmbBackup = 'RUN_SMB_BACKUP',
  RunSmbRestore = 'RUN_SMB_RESTORE',
  RunUpdateDeviceFw = 'RUN_UPDATE_DEVICE_FW',
  RunUpdateProjectLibs = 'RUN_UPDATE_PROJECT_LIBS',
  RunUpdateProjectOpcUaInterface = 'RUN_UPDATE_PROJECT_OPC_UA_INTERFACE',
  RunValidateLicense = 'RUN_VALIDATE_LICENSE',
  RunWriteDeviceVarList = 'RUN_WRITE_DEVICE_VAR_LIST',
  Secret = 'SECRET',
  SecurityVault = 'SECURITY_VAULT',
  SsoUser = 'SSO_USER',
  StandardUser = 'STANDARD_USER',
  Storage = 'STORAGE',
  TenantSetup = 'TENANT_SETUP',
  TimeConnectivitySra = 'TIME_CONNECTIVITY_SRA',
  TimeIdeaas = 'TIME_IDEAAS',
  TimeIdeaasGraphics = 'TIME_IDEAAS_GRAPHICS',
  User = 'USER',
  VersionPro = 'VERSION_PRO'
}

export type BillingFeatureUsageStatsInput = {
  feature: BillingFeatureEnum;
  maxReferenceTs?: InputMaybe<Scalars['Int']['input']>;
  minReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingInvoiceItem = {
  __typename?: 'BillingInvoiceItem';
  allFeatures: Array<BillingFeatureEnum>;
  billableUnits: Scalars['String']['output'];
  billingMode: BillingBillingModeEnum;
  carryoverUnits?: Maybe<Scalars['String']['output']>;
  consumedUnits?: Maybe<Scalars['String']['output']>;
  feature: BillingFeatureEnum;
  isFinal: Scalars['Boolean']['output'];
  metadata: Array<BillingMetadataItem>;
  unit: Scalars['String']['output'];
  unitSize: Scalars['String']['output'];
  upfrontUnits?: Maybe<Scalars['String']['output']>;
};

export type BillingMetadataItem = {
  __typename?: 'BillingMetadataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BillingMetadataItemInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type BillingMeteringConfig = {
  __typename?: 'BillingMeteringConfig';
  scope?: Maybe<BillingScopeParams>;
};

export enum BillingOperationEnum {
  AdminCancelSubscription = 'ADMIN_CANCEL_SUBSCRIPTION',
  AdminConfigurePlan = 'ADMIN_CONFIGURE_PLAN',
  AdminSwitchPlan = 'ADMIN_SWITCH_PLAN',
  EntDisable = 'ENT_DISABLE',
  EntEnable = 'ENT_ENABLE',
  EntManageExpost = 'ENT_MANAGE_EXPOST',
  EntManageUpfront = 'ENT_MANAGE_UPFRONT',
  EntSetCarryoverWindow = 'ENT_SET_CARRYOVER_WINDOW',
  EntSetQuantity = 'ENT_SET_QUANTITY',
  EntSetScope = 'ENT_SET_SCOPE',
  MetReserveUsage = 'MET_RESERVE_USAGE',
  SubsCancel = 'SUBS_CANCEL',
  SubsCreate = 'SUBS_CREATE',
  SubsSwitchPlan = 'SUBS_SWITCH_PLAN',
  SubsUpdate = 'SUBS_UPDATE',
  TermDurationAny = 'TERM_DURATION_ANY',
  TermDurationMonths = 'TERM_DURATION_MONTHS',
  TermNoticePeriod = 'TERM_NOTICE_PERIOD',
  TermStartAny = 'TERM_START_ANY',
  TermStartMonth = 'TERM_START_MONTH'
}

export enum BillingPeriodEnum {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Plan = 'PLAN',
  Tenancy = 'TENANCY',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type BillingPlan = {
  __typename?: 'BillingPlan';
  entitlements: Array<BillingEntitlement>;
  planVersion: Scalars['String']['output'];
  term?: Maybe<BillingTerm>;
  tier: Scalars['String']['output'];
};

export type BillingPlanTierRanking = {
  __typename?: 'BillingPlanTierRanking';
  upsaleTiers: Array<Scalars['String']['output']>;
};

export type BillingPrice = {
  __typename?: 'BillingPrice';
  metadata: Array<BillingMetadataItem>;
};

export type BillingProportionalQuantity = {
  __typename?: 'BillingProportionalQuantity';
  coefficient: Scalars['String']['output'];
  dependerFeature: BillingFeatureEnum;
};

export type BillingProvisionedUsage = {
  __typename?: 'BillingProvisionedUsage';
  carryover?: Maybe<BillingProvisionedUsageCarryover>;
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  expost: BillingExpostProvisionedUsage;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  scope: BillingScopeParams;
  upfront: Array<BillingUpfrontProvisionedUsageItem>;
};

export type BillingProvisionedUsageBillingConfig = {
  __typename?: 'BillingProvisionedUsageBillingConfig';
  resellerPrice?: Maybe<BillingPrice>;
};

export type BillingProvisionedUsageCarryover = {
  __typename?: 'BillingProvisionedUsageCarryover';
  enabled: Scalars['Boolean']['output'];
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  window?: Maybe<Scalars['Int']['output']>;
};

export type BillingProvisionedUsageCarryoverInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  window?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingProvisionedUsageInput = {
  carryover?: InputMaybe<BillingProvisionedUsageCarryoverInput>;
  expost?: InputMaybe<BillingExpostProvisionedUsageInput>;
  scope?: InputMaybe<BillingScopeParamsInput>;
  upfront?: InputMaybe<Array<BillingUpfrontProvisionedUsageItemInput>>;
};

export type BillingResponse = {
  __typename?: 'BillingResponse';
  status: BillingResponseStatusEnum;
};

export enum BillingResponseStatusEnum {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type BillingRevokeScheduledSubscriptionChangeInput = {
  scheduledSubscriptionChangeKey: Scalars['String']['input'];
};

export type BillingScheduledPlanSwitch = {
  __typename?: 'BillingScheduledPlanSwitch';
  subscription: BillingSubscription;
};

export type BillingScheduledSubscriptionChange = {
  __typename?: 'BillingScheduledSubscriptionChange';
  cancellation?: Maybe<Scalars['Boolean']['output']>;
  changeTs: Scalars['Int']['output'];
  creation?: Maybe<BillingScheduledSubscriptionCreation>;
  entitlementUpdate?: Maybe<BillingScheduledSubscriptionEntitlementUpdate>;
  metadata?: Maybe<Array<BillingMetadataItem>>;
  planSwitch?: Maybe<BillingScheduledPlanSwitch>;
  scheduledSubscriptionChangeKey: Scalars['String']['output'];
  schedulingPolicy: BillingSubscriptionChangeSchedulingPolicyEnum;
  termUpdate?: Maybe<BillingScheduledSubscriptionTermUpdate>;
};

export type BillingScheduledSubscriptionCreation = {
  __typename?: 'BillingScheduledSubscriptionCreation';
  subscription: BillingSubscription;
};

export type BillingScheduledSubscriptionEntitlementUpdate = {
  __typename?: 'BillingScheduledSubscriptionEntitlementUpdate';
  entitlement: BillingEntitlement;
};

export type BillingScheduledSubscriptionTermUpdate = {
  __typename?: 'BillingScheduledSubscriptionTermUpdate';
  term: BillingTerm;
};

export enum BillingScopeKeyEnum {
  AiCodeExplanationId = 'AI_CODE_EXPLANATION_ID',
  BackupJobId = 'BACKUP_JOB_ID',
  ConnectionId = 'CONNECTION_ID',
  ConvertProjectJobId = 'CONVERT_PROJECT_JOB_ID',
  CreationUserId = 'CREATION_USER_ID',
  DeploymentJobId = 'DEPLOYMENT_JOB_ID',
  DeviceId = 'DEVICE_ID',
  DevicePwRotationJobId = 'DEVICE_PW_ROTATION_JOB_ID',
  DeviceSnapshotJobId = 'DEVICE_SNAPSHOT_JOB_ID',
  DeviceSnapshotRestoreJobId = 'DEVICE_SNAPSHOT_RESTORE_JOB_ID',
  DocumentId = 'DOCUMENT_ID',
  DocumentVersionId = 'DOCUMENT_VERSION_ID',
  FtpBackupJobId = 'FTP_BACKUP_JOB_ID',
  FtpRestoreJobId = 'FTP_RESTORE_JOB_ID',
  GatewayId = 'GATEWAY_ID',
  IdeaasGraphicsSessionId = 'IDEAAS_GRAPHICS_SESSION_ID',
  IdeaasSessionId = 'IDEAAS_SESSION_ID',
  MergeProjectVersionsJobId = 'MERGE_PROJECT_VERSIONS_JOB_ID',
  ProjectBackupJobId = 'PROJECT_BACKUP_JOB_ID',
  ProjectDeploymentJobId = 'PROJECT_DEPLOYMENT_JOB_ID',
  ProjectId = 'PROJECT_ID',
  ProjectVersionId = 'PROJECT_VERSION_ID',
  ReadDeviceVarListJobId = 'READ_DEVICE_VAR_LIST_JOB_ID',
  SecretId = 'SECRET_ID',
  SecurityVaultId = 'SECURITY_VAULT_ID',
  SmbBackupJobId = 'SMB_BACKUP_JOB_ID',
  SmbRestoreJobId = 'SMB_RESTORE_JOB_ID',
  StorageObjId = 'STORAGE_OBJ_ID',
  UpdateDeviceFwJobId = 'UPDATE_DEVICE_FW_JOB_ID',
  UpdateProjectLibsJobId = 'UPDATE_PROJECT_LIBS_JOB_ID',
  UpdateProjectOpcUaInterfaceJobId = 'UPDATE_PROJECT_OPC_UA_INTERFACE_JOB_ID',
  UserId = 'USER_ID',
  ValidateLicenseJobId = 'VALIDATE_LICENSE_JOB_ID',
  WriteDeviceVarListJobId = 'WRITE_DEVICE_VAR_LIST_JOB_ID'
}

export type BillingScopeParams = {
  __typename?: 'BillingScopeParams';
  period: BillingPeriodEnum;
  scopeKeys?: Maybe<Array<BillingScopeKeyEnum>>;
};

export type BillingScopeParamsInput = {
  period: BillingPeriodEnum;
  scopeKeys?: InputMaybe<Array<BillingScopeKeyEnum>>;
};

export type BillingSubscription = {
  __typename?: 'BillingSubscription';
  entitlements: Array<BillingEntitlement>;
  metadata: Array<BillingMetadataItem>;
  planVersion: Scalars['String']['output'];
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
  subscriptionVersion: Scalars['String']['output'];
  term: BillingTerm;
  tier: Scalars['String']['output'];
  tierRanking?: Maybe<BillingPlanTierRanking>;
};

export enum BillingSubscriptionChangeSchedulingPolicyEnum {
  Default = 'DEFAULT',
  TcAcceptFollowingMonth = 'TC_ACCEPT_FOLLOWING_MONTH'
}

export type BillingSubscriptionTermUsage = {
  __typename?: 'BillingSubscriptionTermUsage';
  entitlementUsages: Array<BillingEntitlementTermUsage>;
  subscriptionVersion: Scalars['String']['output'];
  termReferenceTs: Scalars['Int']['output'];
};

export type BillingSubscriptionTermUsageInput = {
  subscriptionVersion: Scalars['String']['input'];
  termReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingSwitchPlanInput = {
  entitlements?: InputMaybe<Array<BillingEntitlementInput>>;
  metadata?: InputMaybe<Array<BillingMetadataItemInput>>;
  planVersion: Scalars['String']['input'];
  scheduledTs?: InputMaybe<Scalars['Int']['input']>;
  schedulingPolicy?: BillingSubscriptionChangeSchedulingPolicyEnum;
  subscriptionVersion: Scalars['String']['input'];
  term?: InputMaybe<BillingTermInput>;
  tier: Scalars['String']['input'];
};

export type BillingTenantInvoiceData = {
  __typename?: 'BillingTenantInvoiceData';
  allItemMetadataKeys: Array<Scalars['String']['output']>;
  billingCycleExclusiveEndTs: Scalars['Int']['output'];
  billingCycleStartTs: Scalars['Int']['output'];
  items: Array<BillingInvoiceItem>;
  subscription: BillingSubscription;
};

export type BillingTenantInvoiceDataInput = {
  billingCycleReferenceTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingTerm = {
  __typename?: 'BillingTerm';
  cancellationTs?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<BillingTimeInterval>;
  expirationTs?: Maybe<Scalars['Int']['output']>;
  noticePeriod?: Maybe<BillingTimeInterval>;
  postExpirationMonthlyRecurring?: Maybe<Scalars['Boolean']['output']>;
  postExpirationNoticePeriod?: Maybe<BillingTimeInterval>;
  startTs?: Maybe<Scalars['Int']['output']>;
};

export type BillingTermInput = {
  duration?: InputMaybe<BillingTimeIntervalInput>;
  expirationTs?: InputMaybe<Scalars['Int']['input']>;
  noticePeriod?: InputMaybe<BillingTimeIntervalInput>;
  startTs?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingTimeInterval = {
  __typename?: 'BillingTimeInterval';
  days?: Maybe<Scalars['Int']['output']>;
  hours?: Maybe<Scalars['Int']['output']>;
  minutes?: Maybe<Scalars['Int']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  recurring?: Maybe<Scalars['Boolean']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type BillingTimeIntervalInput = {
  days?: InputMaybe<Scalars['Int']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  minutes?: InputMaybe<Scalars['Int']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  seconds?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type BillingUpdateSubscriptionInput = {
  entitlements?: InputMaybe<Array<BillingEntitlementInput>>;
  metadata?: InputMaybe<Array<BillingMetadataItemInput>>;
  scheduledTs?: InputMaybe<Scalars['Int']['input']>;
  subscriptionVersion: Scalars['String']['input'];
  term?: InputMaybe<BillingTermInput>;
};

export type BillingUpfrontProvisionedUsageItem = {
  __typename?: 'BillingUpfrontProvisionedUsageItem';
  billing?: Maybe<BillingProvisionedUsageBillingConfig>;
  endCustomerOps?: Maybe<Array<BillingOperationEnum>>;
  fixedQuantity?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['String']['output'];
  packageSize?: Maybe<Scalars['String']['output']>;
  proportionalQuantity?: Maybe<BillingProportionalQuantity>;
  resellerOps?: Maybe<Array<BillingOperationEnum>>;
};

export type BillingUpfrontProvisionedUsageItemInput = {
  fixedQuantity?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type BillingUsageStats = {
  __typename?: 'BillingUsageStats';
  data: BillingUsageStatsMeteredDataBillingUsageStatsLicensedData;
};

export type BillingUsageStatsFeatureValues = {
  __typename?: 'BillingUsageStatsFeatureValues';
  feature: BillingFeatureEnum;
  groupId?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export type BillingUsageStatsLicensedData = {
  __typename?: 'BillingUsageStatsLicensedData';
  featureValues: Array<BillingUsageStatsFeatureValues>;
  timestamps: Array<Scalars['String']['output']>;
  total?: Maybe<Array<BillingUsageStatsValues>>;
  upfront?: Maybe<Array<BillingUsageStatsValues>>;
};

export type BillingUsageStatsMeteredData = {
  __typename?: 'BillingUsageStatsMeteredData';
  carryover?: Maybe<BillingUsageStatsValues>;
  featureValues: Array<BillingUsageStatsFeatureValues>;
  period: BillingPeriodEnum;
  timestamps: Array<Scalars['String']['output']>;
  total?: Maybe<Array<BillingUsageStatsValues>>;
  upfront?: Maybe<Array<BillingUsageStatsValues>>;
};

export type BillingUsageStatsMeteredDataBillingUsageStatsLicensedData = BillingUsageStatsLicensedData | BillingUsageStatsMeteredData;

export type BillingUsageStatsValues = {
  __typename?: 'BillingUsageStatsValues';
  groupId?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
};

export enum BillingUsageTypeEnum {
  Licensed = 'LICENSED',
  Metered = 'METERED'
}

export type BooleanFilterInput = {
  doNotIgnoreNullable?: InputMaybe<Array<FilterOperatorEnum>>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkCreateDeviceBackupLifecycleSettingsInput = {
  /** List of device retention limit configurations */
  devices: Array<DeviceRetentionLimitInputType>;
};

export type BulkDeleteDeviceBackupLifecycleSettingsInput = {
  /** List of device IDs to delete settings for */
  deviceIds: Array<Scalars['String']['input']>;
};

export type BulkDeviceBackupLifecycleSettingsResponseType = {
  __typename?: 'BulkDeviceBackupLifecycleSettingsResponseType';
  /** Device IDs that failed to process */
  failedDeviceIds: Array<Scalars['String']['output']>;
  /** Successfully processed device settings */
  succeeded: Array<DeviceBackupLifecycleSettingsResponseType>;
};

export type ChangeEntryType = {
  __typename?: 'ChangeEntryType';
  added?: Maybe<Scalars['JSON']['output']>;
  changes?: Maybe<Scalars['JSON']['output']>;
  field: Scalars['String']['output'];
  identifier?: Maybe<Scalars['JSON']['output']>;
  item?: Maybe<Scalars['JSON']['output']>;
  removed?: Maybe<Scalars['JSON']['output']>;
  type: ChangeType;
};

export enum ChangeType {
  Added = 'ADDED',
  Modified = 'MODIFIED',
  Removed = 'REMOVED'
}

export type ChatMessageResponseType = {
  __typename?: 'ChatMessageResponseType';
  chatId: Scalars['String']['output'];
  choices?: Maybe<Array<ChoiceType>>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  isIdeaas: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  vendor?: Maybe<IdeaasVendor>;
};

export type ChatResponseType = {
  __typename?: 'ChatResponseType';
  chatId: Scalars['String']['output'];
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<ChatMessageResponseType>>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type ChoiceType = {
  __typename?: 'ChoiceType';
  answers: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
};

export type CompleteMultipartUploadInput = {
  fileName: Scalars['String']['input'];
  parts: Array<S3MultipartCompleteInfoInput>;
};

export type ConfirmUserInput = {
  confirmationCode: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type ConnectionConfigurationInput = {
  gatewayIpAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddress: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  subnetMask?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectionConfigurationType = {
  __typename?: 'ConnectionConfigurationType';
  gatewayIpAddress?: Maybe<Scalars['String']['output']>;
  ipAddress: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  subnetMask?: Maybe<Scalars['String']['output']>;
};

export type ConnectionConfigurationUpdateInput = {
  gatewayIpAddress?: InputMaybe<Scalars['String']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  subnetMask?: InputMaybe<Scalars['String']['input']>;
};

export enum ConnectionNodeStatus {
  Configuring = 'CONFIGURING',
  Connected = 'CONNECTED',
  Connecting = 'CONNECTING',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR',
  NotConfigured = 'NOT_CONFIGURED'
}

export enum ConnectionState {
  ConnectConfigured = 'CONNECT_CONFIGURED',
  ConnectRefused = 'CONNECT_REFUSED',
  ConnectRequested = 'CONNECT_REQUESTED',
  Deleted = 'DELETED',
  DisconnectConfigured = 'DISCONNECT_CONFIGURED',
  DisconnectRequested = 'DISCONNECT_REQUESTED',
  ServerReady = 'SERVER_READY',
  WaitingForServer = 'WAITING_FOR_SERVER'
}

export enum ConnectionStatusEnum {
  Cancelled = 'CANCELLED',
  Connected = 'CONNECTED',
  Connecting = 'CONNECTING',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR',
  Requested = 'REQUESTED'
}

export enum ConnectionStatusReasonEnum {
  NoCredits = 'NO_CREDITS',
  NoGateway = 'NO_GATEWAY',
  NoSslServer = 'NO_SSL_SERVER',
  NoSubscription = 'NO_SUBSCRIPTION',
  Unknown = 'UNKNOWN'
}

export enum ConnectionV2State {
  Configured = 'CONFIGURED',
  ErrNoGateway = 'ERR_NO_GATEWAY',
  ErrNoSslServer = 'ERR_NO_SSL_SERVER',
  Pending = 'PENDING',
  Requested = 'REQUESTED'
}

export type ConsoleConfigurationFilterInput = {
  readStatus?: InputMaybe<BooleanFilterInput>;
  recipientUserId?: InputMaybe<StringFilterInput>;
};

export type ConsoleNotificationResponseType = {
  __typename?: 'ConsoleNotificationResponseType';
  action: Scalars['String']['output'];
  consoleEndpoint?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  fallbackMessage?: Maybe<Scalars['String']['output']>;
  readStatus?: Maybe<Scalars['Boolean']['output']>;
  recipientUserId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type ContinueChatInput = {
  chatId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CreateAssetLinkInput = {
  /** The meta data for the asset link. The type is dependent on the asset types to link. */
  metaData?: InputMaybe<AssetMetaDataCombinedInput>;
};

export type CreateCustomFieldInput = {
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldType: CustomFieldType;
  helpText?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  label: Scalars['String']['input'];
  options?: Array<CustomFieldOptionInput>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: Scalars['Boolean']['input'];
  validation?: InputMaybe<CustomFieldValidationInput>;
};

export type CreateDeviceBackupLifecycleSettingsInput = {
  /** Device ID for which this retention limit applies */
  deviceId: Scalars['String']['input'];
  /** Number of backups to retain for this specific device before cleanup */
  retentionLimit: Scalars['Int']['input'];
};

export type CreateDeviceInput = {
  connectionConfiguration: ConnectionConfigurationInput;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceType?: DeviceTypeEnum;
  ftpConfiguration?: InputMaybe<FtpConfigurationInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ideConfigId: Scalars['String']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  secretId?: InputMaybe<Scalars['String']['input']>;
  smbConfiguration?: InputMaybe<SmbConfigurationInput>;
  vendorId: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  /** Commit message of the document to be uploaded. */
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  documentType: DocumentTypeEnum;
  /** File name of the document to be uploaded. */
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parts?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDocumentResponseType = {
  __typename?: 'CreateDocumentResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  documentType: DocumentTypeEnum;
  groupId?: Maybe<Scalars['String']['output']>;
  lastVersionNumber: Scalars['Int']['output'];
  linkMetaData?: Maybe<DocumentToAssetLinkMetaDataType>;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  uploadUrls: Array<S3MultipartUploadUrlType>;
  versionId: Scalars['String']['output'];
};

export type CreateDocumentVersionInput = {
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  parts?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateExplanationInput = {
  explanationId: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  language?: Language;
  meteringReservationId?: InputMaybe<Scalars['String']['input']>;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectTreeItemId?: InputMaybe<Scalars['String']['input']>;
  routineName?: InputMaybe<Scalars['String']['input']>;
  s3ObjectKey: Scalars['String']['input'];
  status?: ExplanationStatus;
  targetIndex?: InputMaybe<Scalars['Int']['input']>;
  targetS3ObjectKey?: InputMaybe<Scalars['String']['input']>;
  tokenAggregatorId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['String']['input'];
};

export type CreateFileDifferencesExplanationInput = {
  explanationId: Scalars['String']['input'];
  language?: Language;
  programName?: InputMaybe<Scalars['String']['input']>;
  projectTreeItemId: Scalars['String']['input'];
  routineName?: InputMaybe<Scalars['String']['input']>;
  s3ObjectKey: Scalars['String']['input'];
  status?: FileExplanationStatus;
  targetS3ObjectKey: Scalars['String']['input'];
  tokenAggregatorId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['String']['input'];
};

export type CreateFileExplanationInput = {
  explanationId: Scalars['String']['input'];
  language?: Language;
  programName?: InputMaybe<Scalars['String']['input']>;
  routineName?: InputMaybe<Scalars['String']['input']>;
  s3ObjectKey: Scalars['String']['input'];
  status?: FileExplanationStatus;
  tokenAggregatorId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['String']['input'];
};

export type CreateGatewayInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customLocation?: InputMaybe<LocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGlobalBackupLifecycleSettingsInput = {
  /** Default number of backups to retain per device before cleanup */
  globalRetentionLimit?: Scalars['Int']['input'];
};

export type CreateIntegrationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  integrationType: IntegrationTypeEnum;
  /** Integration configuration. The type is determined by the integration_type field. */
  metaData?: InputMaybe<GitHubIntegrationConfigInput>;
  name: Scalars['String']['input'];
  status?: IntegrationStatusEnum;
};

export type CreateJobInput = {
  artifactsAvailable?: Scalars['Boolean']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dlqPublishedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  featureOptions?: InputMaybe<Scalars['JSON']['input']>;
  finishedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  ideConfigId?: InputMaybe<Scalars['String']['input']>;
  jobType: FeatureEnum;
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  logGroup?: InputMaybe<Scalars['String']['input']>;
  logStream?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  meteringReservationId?: InputMaybe<Scalars['String']['input']>;
  pipelineConfigurationId?: InputMaybe<Scalars['String']['input']>;
  pipelineExecutionId?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceRegion?: InputMaybe<ServiceRegion>;
  source?: InputMaybe<JobSourceEnum>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  timeOut?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLicenseInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  containerId?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  family?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  firmCode?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ideConfigId?: InputMaybe<Scalars['String']['input']>;
  licenseServer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Scalars['Int']['input']>;
  product: Scalars['String']['input'];
  productKey?: InputMaybe<Scalars['String']['input']>;
  quantity?: Scalars['Int']['input'];
  serialId: Scalars['String']['input'];
  status?: LicenseStatusEnum;
  type?: LicenseTypeEnum;
  /** The vendor ID of the license */
  vendorId: Scalars['String']['input'];
};

export type CreateLicenseResponseType = {
  __typename?: 'CreateLicenseResponseType';
  companyName?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  firmCode?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId?: Maybe<Scalars['String']['output']>;
  licenseId: Scalars['String']['output'];
  licenseServer?: Maybe<Scalars['String']['output']>;
  lock?: Maybe<LockResponseType>;
  name?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  product: Scalars['String']['output'];
  productKey?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  serialId: Scalars['String']['output'];
  status: LicenseStatusEnum;
  type: LicenseTypeEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  uploadUrls: Array<S3MultipartUploadUrlType>;
  /** The vendor ID of the license */
  vendorId: Scalars['String']['output'];
};

export type CreateLockInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePipelineConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: Array<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  licenseIds?: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectIds?: Array<Scalars['String']['input']>;
  projectVersionIds?: Array<Scalars['String']['input']>;
  steps: Array<PipelineStepConfigurationInput>;
  trigger: PipelineTriggerConfigurationCombinedInput;
};

export type CreateProjectAnalysisInput = {
  analysisId: Scalars['String']['input'];
  language?: Language;
  s3ProjectTreeBucketKey: Scalars['String']['input'];
  status?: ProjectAnalysisStatus;
  vendor: Scalars['String']['input'];
};

export type CreateProjectChangeDocumentationInput = {
  compareVersionId: Scalars['String']['input'];
  explanationId: Scalars['String']['input'];
  language?: Language;
  projectId: Scalars['String']['input'];
  status?: ProjectChangeDocumentationStatus;
  tokenAggregatorId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};

export type CreateProjectDocumentationInput = {
  explanationId: Scalars['String']['input'];
  language?: Language;
  projectId: Scalars['String']['input'];
  status?: ProjectDocumentationStatus;
  tokenAggregatorId?: InputMaybe<Scalars['String']['input']>;
  vendor: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};

export type CreateProjectInput = {
  attachedLicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  ideConfigId: Scalars['String']['input'];
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  parts?: InputMaybe<Scalars['Int']['input']>;
  projectType?: ProjectTypeEnum;
  secretId?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type CreateProjectResponseType = {
  __typename?: 'CreateProjectResponseType';
  attachedLicenses?: Maybe<Array<Scalars['String']['output']>>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId: Scalars['String']['output'];
  lastVersionNumber: Scalars['Int']['output'];
  linkMetaData?: Maybe<ProjectLinkMetaDataType>;
  lock?: Maybe<LockResponseType>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
  secretId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
  uploadUrls: Array<S3MultipartUploadUrlType>;
  vendorId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export type CreateProjectVersionInput = {
  commitId?: InputMaybe<Scalars['String']['input']>;
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSize?: InputMaybe<Scalars['BigInt']['input']>;
  parts?: InputMaybe<Scalars['Int']['input']>;
  source: ProjectVersionSourceEnum;
};

export type CreateResourceGroupInput = {
  groupType?: ResourceGroupTypeEnum;
  name: Scalars['String']['input'];
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSecretInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  secretType?: SecretTypeEnum;
  secretValue: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  vaultId: Scalars['String']['input'];
};

export type CreateTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTenantInput = {
  agreeToContact?: InputMaybe<Scalars['Boolean']['input']>;
  appClientId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  companyNameLower?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enforceMfa?: InputMaybe<Scalars['Boolean']['input']>;
  enforceMfaForIdeaas?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  importDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  maxUserRoleExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  twoFactorAuthMethods?: InputMaybe<Array<VerificationMethod>>;
};

export type CreateUserGroupInput = {
  groupType?: ResourceGroupTypeEnum;
  name: Scalars['String']['input'];
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  agreeToContact?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordConfirmation?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  policies: Array<PolicyInput>;
  ssoGroupMapping?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateUserRoleUserLinkInput = {
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateVaultInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateWebhookConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl: Scalars['String']['input'];
  event: WebhookEventsEnum;
  gatewayId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payloadMapping: Scalars['String']['input'];
  secretId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWorkstationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CustomFieldConfigurationType = {
  __typename?: 'CustomFieldConfigurationType';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldId: Scalars['String']['output'];
  fieldType: CustomFieldType;
  helpText?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options: Array<CustomFieldOptionType>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required: Scalars['Boolean']['output'];
  status: CustomFieldStatus;
  validation?: Maybe<CustomFieldValidationType>;
};

export type CustomFieldFilterInput = {
  status?: InputMaybe<CustomFieldStatus>;
};

export type CustomFieldLinkageType = {
  __typename?: 'CustomFieldLinkageType';
  assetType: AssetTypeEnum;
  fieldId: Scalars['String']['output'];
  status: CustomFieldStatus;
};

export type CustomFieldOptionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type CustomFieldOptionType = {
  __typename?: 'CustomFieldOptionType';
  label?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export enum CustomFieldStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unknown = 'UNKNOWN'
}

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  LongText = 'LONG_TEXT',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT',
  Unknown = 'UNKNOWN',
  Url = 'URL'
}

export type CustomFieldValidationInput = {
  allowFutureDate?: InputMaybe<Scalars['Boolean']['input']>;
  allowPastDate?: InputMaybe<Scalars['Boolean']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Float']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomFieldValidationType = {
  __typename?: 'CustomFieldValidationType';
  allowFutureDate?: Maybe<Scalars['Boolean']['output']>;
  allowPastDate?: Maybe<Scalars['Boolean']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
};

export type DefineAssetLinkFromAssetInput = {
  /** The destination ID of the asset link. This is the ID of the asset (resource) to which the link is created. */
  destinationId: Scalars['String']['input'];
  /** The meta data for the asset link. The type is dependent on the asset types to link. */
  metaData?: InputMaybe<AssetMetaDataCombinedInput>;
};

export type DefineAssetLinkToAssetInput = {
  /** The meta data for the asset link. The type is dependent on the asset types to link. */
  metaData?: InputMaybe<AssetMetaDataCombinedInput>;
  /** The source ID of the asset link. This is the ID of the asset (resource) from which the link is created. */
  sourceId: Scalars['String']['input'];
};

export type DeviceBackupLifecycleSettingsResponseType = BaseResponseInterface & {
  __typename?: 'DeviceBackupLifecycleSettingsResponseType';
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Device ID for which this retention limit applies */
  deviceId: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Number of backups to retain for this specific device before cleanup */
  retentionLimit: Scalars['Int']['output'];
  tenantId: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type DeviceConfigType = {
  __typename?: 'DeviceConfigType';
  additionalInputs?: Maybe<Array<FeatureConfigOptionType>>;
  deviceType: DeviceTypeEnum;
  port: Scalars['Int']['output'];
  portForwarding?: Maybe<Array<DevicePortForwardingConfigType>>;
};

export type DeviceConnectivityStatusReportType = {
  __typename?: 'DeviceConnectivityStatusReportType';
  deviceNetcatStatus?: Maybe<NetcatStatusEnum>;
  devicePingStatus?: Maybe<PingStatusEnum>;
  deviceStatus: DeviceInterfaceStatusEnum;
  ftpNetcatStatus?: Maybe<NetcatStatusEnum>;
  ftpPingStatus?: Maybe<PingStatusEnum>;
  ftpStatus?: Maybe<DeviceInterfaceStatusEnum>;
  gatewayId: Scalars['String']['output'];
  reportedAt: Scalars['DateTime']['output'];
  smbNetcatStatus?: Maybe<NetcatStatusEnum>;
  smbPingStatus?: Maybe<PingStatusEnum>;
  smbStatus?: Maybe<DeviceInterfaceStatusEnum>;
};

export type DeviceConnectivityStatusType = {
  __typename?: 'DeviceConnectivityStatusType';
  allGateways: Array<DeviceConnectivityStatusReportType>;
  deviceId: Scalars['String']['output'];
  primaryGateway?: Maybe<DeviceConnectivityStatusReportType>;
};

export type DeviceFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  deviceType?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  ideConfigId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  secretId?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
  vendorId?: InputMaybe<StringFilterInput>;
};

export type DeviceFirmwareInformationDataType = {
  __typename?: 'DeviceFirmwareInformationDataType';
  articleNumber: Scalars['String']['output'];
  configuration?: Maybe<Scalars['String']['output']>;
  deviceName: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  firmwareVersion: Scalars['String']['output'];
  hardwareVersion?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
};

export type DeviceFirmwareInformationResponseType = {
  __typename?: 'DeviceFirmwareInformationResponseType';
  details: Array<DeviceFirmwareInformationDataType>;
  deviceId: Scalars['String']['output'];
  readTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceInformationType = {
  __typename?: 'DeviceInformationType';
  description?: Maybe<Scalars['String']['output']>;
  deviceType: DeviceTypeEnum;
  ethernetCommunication: Array<EthernetCommunicationType>;
  name: Scalars['String']['output'];
  nameAndType?: Maybe<Scalars['String']['output']>;
  originDeviceType?: Maybe<Scalars['String']['output']>;
};

export enum DeviceInterfaceStatusEnum {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Unavailable = 'UNAVAILABLE'
}

export type DeviceLinkMetaDataType = DeviceToDeviceLinkMetaDataType | DeviceToGatewayLinkMetaDataType | ProjectToDeviceLinkMetaDataType;

export type DeviceOtCveResponseType = {
  __typename?: 'DeviceOtCveResponseType';
  advisoryLink?: Maybe<Scalars['String']['output']>;
  affectedVersion?: Maybe<Scalars['String']['output']>;
  constraint?: Maybe<Scalars['String']['output']>;
  cveNumber?: Maybe<Scalars['String']['output']>;
  cveTitle?: Maybe<Scalars['String']['output']>;
  cvssScore?: Maybe<Scalars['Decimal']['output']>;
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  deviceType?: Maybe<Scalars['String']['output']>;
  deviceVersion: Scalars['String']['output'];
  firmwareDeviceName?: Maybe<Scalars['String']['output']>;
  fixedVersion?: Maybe<Scalars['String']['output']>;
  isVulnerable?: Maybe<Scalars['Boolean']['output']>;
  nvdSeverity?: Maybe<Scalars['String']['output']>;
  nvdUrl?: Maybe<Scalars['String']['output']>;
  productArticleNumber?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type DevicePortForwardingConfigType = {
  __typename?: 'DevicePortForwardingConfigType';
  gatewayPort: Scalars['Int']['output'];
  targetPort: Scalars['Int']['output'];
};

export type DeviceResponseType = AssetBaseResponseInterface & {
  __typename?: 'DeviceResponseType';
  accumulatedSyncStatus: AccumulatedDeviceSyncStatusResponseType;
  connectionConfiguration: ConnectionConfigurationType;
  connectivityStatus: DeviceConnectivityStatusType;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  deviceType: DeviceTypeEnum;
  firmwareInformation?: Maybe<DeviceFirmwareInformationResponseType>;
  ftpConfiguration?: Maybe<FtpConfigurationType>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId: Scalars['String']['output'];
  linkMetaData?: Maybe<DeviceLinkMetaDataType>;
  linkedDocuments: PaginatedDocumentResponseType;
  linkedGateways: PaginatedGatewayResponseType;
  linkedParentDevices: PaginatedDeviceResponseType;
  linkedProjects: PaginatedProjectResponseType;
  linkedSubDevices: PaginatedDeviceResponseType;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  secret?: Maybe<SecretResponseType>;
  secretId?: Maybe<Scalars['String']['output']>;
  smbConfiguration?: Maybe<SmbConfigurationType>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};


export type DeviceResponseTypeLinkedDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DeviceResponseTypeLinkedGatewaysArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DeviceResponseTypeLinkedParentDevicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DeviceResponseTypeLinkedProjectsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DeviceResponseTypeLinkedSubDevicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DeviceResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type DeviceRetentionLimitInputType = {
  /** Device ID */
  deviceId: Scalars['String']['input'];
  /** Retention limit for this device */
  retentionLimit: Scalars['Int']['input'];
};

export enum DeviceSyncStatusEnum {
  Error = 'ERROR',
  NotSynced = 'NOT_SYNCED',
  Synced = 'SYNCED',
  Unknown = 'UNKNOWN'
}

export type DeviceSyncStatusResponseType = {
  __typename?: 'DeviceSyncStatusResponseType';
  previousSyncStatus?: Maybe<DeviceSyncStatusEnum>;
  projectId?: Maybe<Scalars['String']['output']>;
  syncErrorMessage?: Maybe<Scalars['String']['output']>;
  syncJobId?: Maybe<Scalars['String']['output']>;
  syncTimestamp?: Maybe<Scalars['DateTime']['output']>;
  syncType: DeviceSyncTypeEnum;
  targetProjectVersionId?: Maybe<Scalars['String']['output']>;
  targetSyncStatus?: Maybe<DeviceSyncStatusEnum>;
};

export enum DeviceSyncTypeEnum {
  DeviceSnapshot = 'DEVICE_SNAPSHOT',
  Ftp = 'FTP',
  Ide = 'IDE',
  Network = 'NETWORK',
  ReadVariableListFromDevice = 'READ_VARIABLE_LIST_FROM_DEVICE',
  Smb = 'SMB'
}

export type DeviceToDeviceLinkMetaDataType = {
  __typename?: 'DeviceToDeviceLinkMetaDataType';
  /** The interface used for the link between the two devices. */
  interface?: Maybe<Scalars['String']['output']>;
  /** The protocol used for the link between the two devices. */
  protocol?: Maybe<Scalars['String']['output']>;
};

export type DeviceToGatewayLinkMetaDataType = {
  __typename?: 'DeviceToGatewayLinkMetaDataType';
  /** A flag indicating if this is the primary gateway for the device. */
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export enum DeviceTypeEnum {
  Agv = 'AGV',
  Cnc = 'CNC',
  Drive = 'DRIVE',
  Hmi = 'HMI',
  IndustrialSwitch = 'INDUSTRIAL_SWITCH',
  Ipc = 'IPC',
  Other = 'OTHER',
  Plc = 'PLC',
  Robot = 'ROBOT',
  Scada = 'SCADA',
  Unknown = 'UNKNOWN'
}

export type DeviceVulnerabilityFilterInput = {
  cveNumber?: InputMaybe<StringFilterInput>;
  deviceId?: InputMaybe<StringFilterInput>;
  deviceName?: InputMaybe<StringFilterInput>;
  deviceType?: InputMaybe<StringFilterInput>;
  nvdSeverity?: InputMaybe<StringFilterInput>;
  productArticleNumber?: InputMaybe<StringFilterInput>;
  vendor?: InputMaybe<StringFilterInput>;
  vendorId?: InputMaybe<StringFilterInput>;
};

export type DocumentFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  documentType?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type DocumentResponseType = AssetBaseResponseInterface & {
  __typename?: 'DocumentResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  documentType: DocumentTypeEnum;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastVersionNumber: Scalars['Int']['output'];
  linkMetaData?: Maybe<DocumentToAssetLinkMetaDataType>;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  versions: PaginatedDocumentVersionResponseType;
};


export type DocumentResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type DocumentResponseTypeVersionsArgs = {
  filter?: InputMaybe<DocumentVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type DocumentToAssetLinkMetaDataType = {
  __typename?: 'DocumentToAssetLinkMetaDataType';
  assetVersionId?: Maybe<Scalars['String']['output']>;
};

export enum DocumentTypeEnum {
  Csv = 'CSV',
  Docx = 'DOCX',
  Html = 'HTML',
  Json = 'JSON',
  Md = 'MD',
  Others = 'OTHERS',
  Pdf = 'PDF',
  Txt = 'TXT',
  Xml = 'XML'
}

export type DocumentVersionDownloadUrlResponseType = {
  __typename?: 'DocumentVersionDownloadURLResponseType';
  documentId: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export type DocumentVersionFileType = {
  __typename?: 'DocumentVersionFileType';
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
};

export type DocumentVersionFilterInput = {
  commitMessage?: InputMaybe<StringFilterInput>;
  commitMessageLower?: InputMaybe<StringFilterInput>;
  creationTimestamp?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
  versionId?: InputMaybe<StringFilterInput>;
};

export type DocumentVersionResponseType = AssetBaseResponseInterface & {
  __typename?: 'DocumentVersionResponseType';
  commitMessage?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  documentFile: DocumentVersionFileType;
  documentId: Scalars['String']['output'];
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  lock?: Maybe<LockResponseType>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type DocumentVersionUploadUrlResponseType = {
  __typename?: 'DocumentVersionUploadURLResponseType';
  documentId: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrls: Array<S3MultipartUploadUrlType>;
  versionId: Scalars['String']['output'];
};

export type EmailContextResponseType = {
  __typename?: 'EmailContextResponseType';
  body: Scalars['String']['output'];
  htmlBody?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type EmailNotificationResponseType = {
  __typename?: 'EmailNotificationResponseType';
  emailContext: EmailContextResponseType;
  recipientEmail: Scalars['String']['output'];
  recipientUserId: Scalars['String']['output'];
};

export type EmailType = {
  __typename?: 'EmailType';
  value: Scalars['String']['output'];
};

export type EndVscodeSessionResponse = {
  __typename?: 'EndVscodeSessionResponse';
  sessionId: Scalars['String']['output'];
  terminatedAt: Scalars['DateTime']['output'];
};

export type EthernetCommunicationType = {
  __typename?: 'EthernetCommunicationType';
  ipAddress: Scalars['String']['output'];
  subnetMask?: Maybe<Scalars['String']['output']>;
};

export type ExplanationResponseType = {
  __typename?: 'ExplanationResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  explanationId: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  language: Language;
  meteringReservationId?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectTreeItemId?: Maybe<Scalars['String']['output']>;
  routineName?: Maybe<Scalars['String']['output']>;
  s3ObjectKey: Scalars['String']['output'];
  status: ExplanationStatus;
  summary?: Maybe<Scalars['String']['output']>;
  targetIndex?: Maybe<Scalars['Int']['output']>;
  targetS3ObjectKey?: Maybe<Scalars['String']['output']>;
  tokenAggregatorId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export enum ExplanationStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  GeneratingDiff = 'GENERATING_DIFF',
  Regenerating = 'REGENERATING',
  Summarizing = 'SUMMARIZING'
}

export type FeatureConfigOptionType = {
  __typename?: 'FeatureConfigOptionType';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  inputOptions: Array<InputOptionType>;
  inputType: InputTypeEnum;
  label: Scalars['String']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  validationRegex?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type FeatureConfigType = {
  __typename?: 'FeatureConfigType';
  feature: FeatureEnum;
  metaData: FeatureMetaDataType;
  options: Array<FeatureConfigOptionType>;
  requiredFeatureFlag?: Maybe<Scalars['String']['output']>;
};

export enum FeatureEnum {
  Deployment = 'DEPLOYMENT',
  DeviceFirmwareUpdate = 'DEVICE_FIRMWARE_UPDATE',
  DevicePasswordUpdate = 'DEVICE_PASSWORD_UPDATE',
  DeviceSnapshot = 'DEVICE_SNAPSHOT',
  DeviceSnapshotRestore = 'DEVICE_SNAPSHOT_RESTORE',
  FtpBackup = 'FTP_BACKUP',
  FtpRestore = 'FTP_RESTORE',
  Ideaas = 'IDEAAS',
  IdeaasCodeGeneration = 'IDEAAS_CODE_GENERATION',
  LicenseValidate = 'LICENSE_VALIDATE',
  ProjectBackup = 'PROJECT_BACKUP',
  ProjectConvert = 'PROJECT_CONVERT',
  ProjectLibraryUpgrade = 'PROJECT_LIBRARY_UPGRADE',
  ProjectMerge = 'PROJECT_MERGE',
  ProjectUpdateOpcUaInterface = 'PROJECT_UPDATE_OPC_UA_INTERFACE',
  ProjectView = 'PROJECT_VIEW',
  ReadVariableListFromDevice = 'READ_VARIABLE_LIST_FROM_DEVICE',
  SmbBackup = 'SMB_BACKUP',
  SmbRestore = 'SMB_RESTORE',
  Unknown = 'UNKNOWN',
  VsCode = 'VS_CODE',
  WriteVariableListToDevice = 'WRITE_VARIABLE_LIST_TO_DEVICE'
}

export type FeatureFlagType = {
  __typename?: 'FeatureFlagType';
  description?: Maybe<Scalars['String']['output']>;
  featureName: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureMetaDataType = {
  __typename?: 'FeatureMetaDataType';
  deviceTypes?: Maybe<Array<DeviceTypeEnum>>;
  featureType: FeatureTypeEnum;
  fileExtensionsToDeviceTypes?: Maybe<Array<FileToDeviceTypeMappingType>>;
  fileToFileExtensions?: Maybe<Array<FileToFileTypeMappingType>>;
  projectFileExtensions?: Maybe<Array<FileExtensionMappingType>>;
};

export enum FeatureTypeEnum {
  DeviceFeature = 'DEVICE_FEATURE',
  LicenseFeature = 'LICENSE_FEATURE',
  ProjectDeviceFeature = 'PROJECT_DEVICE_FEATURE',
  ProjectFeature = 'PROJECT_FEATURE',
  ProjectProjectFeature = 'PROJECT_PROJECT_FEATURE',
  Unknown = 'UNKNOWN'
}

export type FileExplanationResponseType = {
  __typename?: 'FileExplanationResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  explanationId: Scalars['String']['output'];
  language: Language;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  programName?: Maybe<Scalars['String']['output']>;
  projectTreeItemId?: Maybe<Scalars['String']['output']>;
  routineName?: Maybe<Scalars['String']['output']>;
  s3ObjectKey: Scalars['String']['output'];
  status: FileExplanationStatus;
  summary?: Maybe<Scalars['String']['output']>;
  targetS3ObjectKey?: Maybe<Scalars['String']['output']>;
  tokenAggregatorId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export enum FileExplanationStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  GeneratingFileDifferencesExplanation = 'GENERATING_FILE_DIFFERENCES_EXPLANATION',
  GeneratingFileExplanation = 'GENERATING_FILE_EXPLANATION'
}

export type FileExtensionMappingType = {
  __typename?: 'FileExtensionMappingType';
  fileExtension: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
};

export type FileToDeviceTypeMappingType = {
  __typename?: 'FileToDeviceTypeMappingType';
  deviceType: DeviceTypeEnum;
  fileExtension: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
};

export type FileToFileTypeMappingType = {
  __typename?: 'FileToFileTypeMappingType';
  destinationFileExtension: Scalars['String']['output'];
  destinationProjectType: ProjectTypeEnum;
  fileExtension: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
};

export type FileTypeType = {
  __typename?: 'FileTypeType';
  additionalInputs?: Maybe<Array<FeatureConfigOptionType>>;
  description: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
};

export enum FilterOperatorEnum {
  Unknown = 'UNKNOWN',
  BeginsWith = 'begins_with',
  Between = 'between',
  Contains = 'contains',
  ContainsAny = 'contains_any',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  In = 'in_',
  Lt = 'lt',
  Lte = 'lte',
  Ne = 'ne',
  NotContains = 'not_contains'
}

export type ForgotPasswordCodeDeliveryDetailsType = {
  __typename?: 'ForgotPasswordCodeDeliveryDetailsType';
  attributeName: Scalars['String']['output'];
  deliveryMedium: Scalars['String']['output'];
  destination: Scalars['String']['output'];
};

export type ForgotPasswordInput = {
  appClientId?: InputMaybe<Scalars['String']['input']>;
  superTenantId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type ForgotPasswordNextStepType = {
  __typename?: 'ForgotPasswordNextStepType';
  codeDeliveryDetails: ForgotPasswordCodeDeliveryDetailsType;
  resetPasswordStep: Scalars['String']['output'];
};

export type ForgotPasswordResponseType = {
  __typename?: 'ForgotPasswordResponseType';
  isPasswordReset: Scalars['Boolean']['output'];
  nextStep: ForgotPasswordNextStepType;
};

export type FtpConfigurationInput = {
  /** The IP address of the protocol server on the device. */
  ipAddress: Scalars['String']['input'];
  /** The port of the FTP server on the device. Default is 22 (SFTP). */
  port?: Scalars['Int']['input'];
  /** The protocol used by the FTP server on the device. */
  protocol?: InputMaybe<FtpProtocolEnum>;
  /** The root directory of the protocol server on the device. If not set, the root directory is assumed to be the home directory of the user. */
  rootDirectory?: InputMaybe<Scalars['String']['input']>;
  /** The secret ID for the protocol server credentials (username and password). */
  secretId?: InputMaybe<Scalars['String']['input']>;
};

export type FtpConfigurationType = {
  __typename?: 'FtpConfigurationType';
  /** The IP address of the protocol server on the device. */
  ipAddress: Scalars['String']['output'];
  /** The port of the FTP server on the device. Default is 22 (SFTP). */
  port: Scalars['Int']['output'];
  /** The protocol used by the FTP server on the device. */
  protocol?: Maybe<FtpProtocolEnum>;
  /** The root directory of the protocol server on the device. If not set, the root directory is assumed to be the home directory of the user. */
  rootDirectory?: Maybe<Scalars['String']['output']>;
  /** The secret ID for the protocol server credentials (username and password). */
  secretId?: Maybe<Scalars['String']['output']>;
};

export enum FtpProtocolEnum {
  Ftp = 'FTP',
  Sftp = 'SFTP'
}

export type GatewayConfigResponseType = {
  __typename?: 'GatewayConfigResponseType';
  objectVersion?: Maybe<Scalars['Int']['output']>;
  reportedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  values: GlueConfigType;
};

export type GatewayConfigUpdateInput = {
  objectVersion: Scalars['Int']['input'];
  values: GlueConfigInput;
};

export type GatewayFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type GatewayMetadataResponseType = {
  __typename?: 'GatewayMetadataResponseType';
  architecture: ArchEnum;
  isOutdated?: Maybe<Scalars['Boolean']['output']>;
  isOutdatedForMajor?: Maybe<Scalars['Boolean']['output']>;
  latestVersion?: Maybe<Scalars['String']['output']>;
  latestVersionForMajor?: Maybe<Scalars['String']['output']>;
  numCpu?: Maybe<Scalars['Int']['output']>;
  operatingSystem: OperatingSystemEnum;
  operatingSystemAttrs?: Maybe<WindowsAttrsTypeLinuxAttrsType>;
  reportedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type GatewayPublicIpResponseType = {
  __typename?: 'GatewayPublicIpResponseType';
  publicIp: Scalars['String']['output'];
  publicIpLocation?: Maybe<LocationType>;
  reportedAt: Scalars['DateTime']['output'];
};

export type GatewayResponseType = AssetBaseResponseInterface & {
  __typename?: 'GatewayResponseType';
  configDesired?: Maybe<GatewayConfigResponseType>;
  configReported?: Maybe<GatewayConfigResponseType>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  customLocation?: Maybe<LocationType>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gatewayId: Scalars['String']['output'];
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  linkMetaData?: Maybe<DeviceToGatewayLinkMetaDataType>;
  linkedDevices: PaginatedDeviceResponseType;
  linkedDocuments: PaginatedDocumentResponseType;
  linkedTags: PaginatedTagResponseType;
  location?: Maybe<LocationType>;
  lock?: Maybe<LockResponseType>;
  metadata?: Maybe<GatewayMetadataResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  publicIp?: Maybe<GatewayPublicIpResponseType>;
  serviceRegion?: Maybe<ServiceRegion>;
  setupCommands?: Maybe<GatewaySetupResponseType>;
  state?: Maybe<GatewayStateResponseType>;
  updateRequest?: Maybe<GatewayUpdateRequestType>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};


export type GatewayResponseTypeLinkedDevicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type GatewayResponseTypeLinkedDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type GatewayResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type GatewaySetupByMajorType = {
  __typename?: 'GatewaySetupByMajorType';
  major: Scalars['String']['output'];
  osCommands: Array<GatewaySetupType>;
};

export type GatewaySetupResponseType = {
  __typename?: 'GatewaySetupResponseType';
  byMajor: Array<GatewaySetupByMajorType>;
  expiresAt: Scalars['DateTime']['output'];
  osCommands: Array<GatewaySetupType>;
};

export type GatewaySetupType = {
  __typename?: 'GatewaySetupType';
  configurationCommand: Scalars['String']['output'];
  installationCommand: Scalars['String']['output'];
  osName: Scalars['String']['output'];
  osType: OperatingSystemEnum;
};

export enum GatewayStateEnum {
  NotConfigured = 'NOT_CONFIGURED',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type GatewayStateResponseType = {
  __typename?: 'GatewayStateResponseType';
  reportedAt: Scalars['DateTime']['output'];
  state: GatewayStateEnum;
};

export type GatewayUpdateRequestType = {
  __typename?: 'GatewayUpdateRequestType';
  requestedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type GenerateTwoFactorAuthTokenInput = {
  verificationMethod?: Scalars['String']['input'];
};

export type GenerateTwoFactorAuthTokenResponseType = {
  __typename?: 'GenerateTwoFactorAuthTokenResponseType';
  sessionId: Scalars['String']['output'];
};

export type GenericArtifactRequestInput = {
  fileNames: Array<Scalars['String']['input']>;
};

export type GenericArtifactResponseType = {
  __typename?: 'GenericArtifactResponseType';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  presignedUrl: Scalars['String']['output'];
};

export type GitHubIntegrationConfigInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  installationId?: InputMaybe<Scalars['Int']['input']>;
  isOrganization?: Scalars['Boolean']['input'];
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  selectedRepositoryIds?: Array<Scalars['Int']['input']>;
};

export type GitHubIntegrationConfigType = {
  __typename?: 'GitHubIntegrationConfigType';
  installationId?: Maybe<Scalars['Int']['output']>;
  isOrganization: Scalars['Boolean']['output'];
  oauthStatus: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['Int']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  selectedRepositoryIds: Array<Scalars['Int']['output']>;
};

export type GitRepositoryFilterInput = {
  integrationId?: InputMaybe<StringFilterInput>;
  linkedProjectId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
};

export type GitRepositoryResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type GitRepositoryResponseType = GitRepositoryResponseInterface & {
  __typename?: 'GitRepositoryResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  gitInternalRepositoryId: Scalars['Int']['output'];
  gitRepositoryFullName: Scalars['String']['output'];
  gitRepositoryId: Scalars['String']['output'];
  gitRepositoryOwner: Scalars['String']['output'];
  gitRepositoryUrl: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  linkedProjectId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type GithubInstallUrlType = {
  __typename?: 'GithubInstallUrlType';
  authorizationUrl: Scalars['String']['output'];
  flow: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type GlobalBackupLifecycleSettingsResponseType = BaseResponseInterface & {
  __typename?: 'GlobalBackupLifecycleSettingsResponseType';
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Default number of backups to retain per device before cleanup */
  globalRetentionLimit: Scalars['Int']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  tenantId: Scalars['String']['output'];
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type GlueConfigInput = {
  iotTransport?: InputMaybe<Scalars['String']['input']>;
  metaVersion: Scalars['Int']['input'];
  natMode?: InputMaybe<Scalars['String']['input']>;
  proxyAll?: InputMaybe<Scalars['String']['input']>;
  proxyHttp?: InputMaybe<Scalars['String']['input']>;
  proxyHttps?: InputMaybe<Scalars['String']['input']>;
  sslTunnel?: InputMaybe<Scalars['Boolean']['input']>;
  sslTunnelInsecure?: InputMaybe<Scalars['Boolean']['input']>;
  updateAuto?: InputMaybe<Scalars['Boolean']['input']>;
  updatePeriod?: InputMaybe<Scalars['String']['input']>;
  updateUnstable?: InputMaybe<Scalars['Boolean']['input']>;
  webuiBase?: InputMaybe<Scalars['String']['input']>;
  webuiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  webuiPort?: InputMaybe<Scalars['Int']['input']>;
};

export type GlueConfigType = {
  __typename?: 'GlueConfigType';
  iotTransport?: Maybe<Scalars['String']['output']>;
  metaVersion: Scalars['Int']['output'];
  natMode?: Maybe<Scalars['String']['output']>;
  proxyAll?: Maybe<Scalars['String']['output']>;
  proxyHttp?: Maybe<Scalars['String']['output']>;
  proxyHttps?: Maybe<Scalars['String']['output']>;
  sslTunnel?: Maybe<Scalars['Boolean']['output']>;
  sslTunnelInsecure?: Maybe<Scalars['Boolean']['output']>;
  updateAuto?: Maybe<Scalars['Boolean']['output']>;
  updatePeriod?: Maybe<Scalars['String']['output']>;
  updateUnstable?: Maybe<Scalars['Boolean']['output']>;
  webuiBase?: Maybe<Scalars['String']['output']>;
  webuiEnabled?: Maybe<Scalars['Boolean']['output']>;
  webuiPort?: Maybe<Scalars['Int']['output']>;
};

export type GroupDeviceSyncStatusType = {
  __typename?: 'GroupDeviceSyncStatusType';
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  syncStatus: DeviceSyncStatusEnum;
  syncStatusTimestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type GroupedAssetCountResponseType = {
  __typename?: 'GroupedAssetCountResponseType';
  devices: Scalars['Int']['output'];
  documents: Scalars['Int']['output'];
  gateways: Scalars['Int']['output'];
  groupId: Scalars['String']['output'];
  licenses: Scalars['Int']['output'];
  projects: Scalars['Int']['output'];
  subGroups: Scalars['Int']['output'];
  vaults: Scalars['Int']['output'];
};

export type GroupedIdentityCountResponseType = {
  __typename?: 'GroupedIdentityCountResponseType';
  groupId: Scalars['String']['output'];
  userRoles: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type GroupedIntegrationCountResponseType = {
  __typename?: 'GroupedIntegrationCountResponseType';
  count: Scalars['Int']['output'];
  groupId: Scalars['String']['output'];
};

export type GroupedPipelineCountResponseType = {
  __typename?: 'GroupedPipelineCountResponseType';
  count: Scalars['Int']['output'];
  groupId: Scalars['String']['output'];
};

export type HealthResponseType = {
  __typename?: 'HealthResponseType';
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type HubConfigType = {
  __typename?: 'HubConfigType';
  /** Fixed singleton identifier — always 'default' for a given tenant. */
  hubConfigId: Scalars['String']['output'];
  recordingEnabled: Scalars['Boolean']['output'];
  retentionDays: Scalars['Int']['output'];
};

export type IdeConfigResponseType = {
  __typename?: 'IdeConfigResponseType';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  allowedLicenseVersions: Array<Scalars['String']['output']>;
  availableLanguages: Array<IdeLanguageEnum>;
  devices: Array<DeviceConfigType>;
  factoryAgentAvailable: Array<ProgrammingLanguageEnum>;
  features: Array<FeatureConfigType>;
  fileTypes: Array<FileTypeType>;
  ideConfigId: Scalars['String']['output'];
  licenseRequired: Scalars['Boolean']['output'];
  multiDeviceSupport: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  requiredFeatureFlag?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export enum IdeLanguageEnum {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Italian = 'ITALIAN',
  Spanish = 'SPANISH',
  Unknown = 'UNKNOWN'
}

export enum IdeaasVendor {
  Codesys = 'CODESYS',
  Siemens = 'SIEMENS'
}

export type IdentBaseResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type IdentityProviderResponseType = {
  __typename?: 'IdentityProviderResponseType';
  identityProviderId: Scalars['String']['output'];
  identityProviderType: IdentityProviderTypeEnum;
};

export enum IdentityProviderTypeEnum {
  Facebook = 'Facebook',
  Google = 'Google',
  LoginWithAmazon = 'LoginWithAmazon',
  Oidc = 'OIDC',
  Saml = 'SAML',
  SignInWithApple = 'SignInWithApple'
}

export type InputOptionType = {
  __typename?: 'InputOptionType';
  label: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export enum InputTypeEnum {
  Checkbox = 'CHECKBOX',
  Credential = 'CREDENTIAL',
  InputHidden = 'INPUT_HIDDEN',
  InputNumber = 'INPUT_NUMBER',
  InputText = 'INPUT_TEXT',
  RadioButton = 'RADIO_BUTTON',
  Select = 'SELECT',
  Switch = 'SWITCH',
  Unknown = 'UNKNOWN'
}

export type IntegrationFilterInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
};

export type IntegrationResponseInterface = {
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type IntegrationResponseType = IntegrationResponseInterface & {
  __typename?: 'IntegrationResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  integrationId: Scalars['String']['output'];
  integrationType: IntegrationTypeEnum;
  logoUrl?: Maybe<Scalars['String']['output']>;
  metaData: GitHubIntegrationConfigType;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  repositories: PaginatedGitRepositoryResponseType;
  status: IntegrationStatusEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export enum IntegrationStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Installed = 'INSTALLED',
  Uninstalled = 'UNINSTALLED'
}

export enum IntegrationTypeEnum {
  Github = 'GITHUB'
}

export type JobArtifactsResponseType = {
  __typename?: 'JobArtifactsResponseType';
  channel?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type JobFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  deviceIds?: InputMaybe<StringFilterInput>;
  ideConfigId?: InputMaybe<StringFilterInput>;
  jobType?: InputMaybe<StringFilterInput>;
  licenseIds?: InputMaybe<StringFilterInput>;
  projectIds?: InputMaybe<StringFilterInput>;
  projectVersionIds?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
};

export type JobLogType = {
  __typename?: 'JobLogType';
  message: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type JobLogsFilterInput = {
  endTime?: InputMaybe<NumberFilterInput>;
  limit?: InputMaybe<NumberFilterInput>;
  nextToken?: InputMaybe<StringFilterInput>;
  startTime?: InputMaybe<NumberFilterInput>;
};

export type JobLogsResponseType = {
  __typename?: 'JobLogsResponseType';
  logs: Array<JobLogType>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type JobResponseType = BaseResponseInterface & {
  __typename?: 'JobResponseType';
  artifactsAvailable: Scalars['Boolean']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  deviceIds?: Maybe<Array<Scalars['String']['output']>>;
  dlqPublishedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  featureOptions?: Maybe<Scalars['JSON']['output']>;
  finishedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  jobType: FeatureEnum;
  licenseIds?: Maybe<Array<Scalars['String']['output']>>;
  logGroup: Scalars['String']['output'];
  logStream: Scalars['String']['output'];
  metaData?: Maybe<Scalars['JSON']['output']>;
  meteringReservationId?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  pipelineConfigurationId?: Maybe<Scalars['String']['output']>;
  pipelineExecutionId?: Maybe<Scalars['String']['output']>;
  projectIds?: Maybe<Array<Scalars['String']['output']>>;
  projectVersionIds?: Maybe<Array<Scalars['String']['output']>>;
  serviceRegion?: Maybe<ServiceRegion>;
  source?: Maybe<JobSourceEnum>;
  startTimestamp?: Maybe<Scalars['DateTime']['output']>;
  status: JobStatusEnum;
  timeOut?: Maybe<Scalars['Int']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export enum JobSourceEnum {
  Api = 'API',
  Event = 'EVENT',
  Pipeline = 'PIPELINE',
  WebConsole = 'WEB_CONSOLE'
}

export enum JobStatusEnum {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  TimedOut = 'TIMED_OUT'
}

export enum Language {
  Chinese = 'CHINESE',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE'
}

export type LicenseConfigType = {
  __typename?: 'LicenseConfigType';
  inputs: Array<FeatureConfigOptionType>;
};

export type LicenseDownloadUrlResponseType = {
  __typename?: 'LicenseDownloadURLResponseType';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  licenseId: Scalars['String']['output'];
};

export type LicenseFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type LicenseResponseInterface = {
  licenseId: Scalars['String']['output'];
};

export type LicenseResponseType = AssetBaseResponseInterface & LicenseResponseInterface & {
  __typename?: 'LicenseResponseType';
  companyName?: Maybe<Scalars['String']['output']>;
  containerId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  firmCode?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId?: Maybe<Scalars['String']['output']>;
  licenseId: Scalars['String']['output'];
  licenseServer?: Maybe<Scalars['String']['output']>;
  linkedDocuments: PaginatedDocumentResponseType;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  name?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  product: Scalars['String']['output'];
  productKey?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  serialId: Scalars['String']['output'];
  status: LicenseStatusEnum;
  type: LicenseTypeEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  /** The vendor ID of the license */
  vendorId: Scalars['String']['output'];
};


export type LicenseResponseTypeLinkedDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type LicenseResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum LicenseStatusEnum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Requested = 'REQUESTED',
  Uploaded = 'UPLOADED'
}

export enum LicenseTypeEnum {
  Corporate = 'CORPORATE',
  Floating = 'FLOATING',
  Single = 'SINGLE',
  Trial = 'TRIAL',
  Upgrade = 'UPGRADE'
}

export type LightUserResponseType = {
  __typename?: 'LightUserResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemUser?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  source: UserSourceEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type LinkCustomFieldInput = {
  assetType: AssetTypeEnum;
  fieldId: Scalars['String']['input'];
};

export type LinuxAttrsType = {
  __typename?: 'LinuxAttrsType';
  distro: Scalars['String']['output'];
  kernel: Scalars['String']['output'];
  procVersion: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  horizontalAccuracy?: InputMaybe<Scalars['Int']['input']>;
  horizontalConfidenceLevelPercentage?: InputMaybe<Scalars['Int']['input']>;
  latitudeE6: Scalars['Int']['input'];
  longitudeE6: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type LocationType = {
  __typename?: 'LocationType';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  horizontalAccuracy?: Maybe<Scalars['Int']['output']>;
  horizontalConfidenceLevelPercentage?: Maybe<Scalars['Int']['output']>;
  latitudeE6: Scalars['Int']['output'];
  longitudeE6: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
};

export type LockResponseInterface = {
  creationUserId?: Maybe<Scalars['String']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type LockResponseType = LockResponseInterface & {
  __typename?: 'LockResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  service: Scalars['String']['output'];
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type LoginUserInput = {
  appClientId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  superTenantId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type LoginUserResponseType = {
  __typename?: 'LoginUserResponseType';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTermsAndConditions: TermsAndConditionsAcceptanceResponseType;
  activateCustomField: CustomFieldConfigurationType;
  authenticateTwoFactorAuthToken: AuthenticateTwoFactorAuthTokenResponseType;
  bulkCreateDeviceBackupLifecycleSettings: BulkDeviceBackupLifecycleSettingsResponseType;
  bulkDeleteDeviceBackupLifecycleSettings: Array<Scalars['String']['output']>;
  cancelTenantSubscription: BillingResponse;
  completeDocumentVersionMultipartUpload?: Maybe<Scalars['Void']['output']>;
  completeLicenseMultipartUpload?: Maybe<Scalars['Void']['output']>;
  completeProjectVersionMultipartUpload?: Maybe<Scalars['Void']['output']>;
  confirmUser?: Maybe<Scalars['Void']['output']>;
  continueChat: ChatResponseType;
  createAssetLink: AssetLinkResponseType;
  createChangeDocumentation: ProjectChangeDocumentationResponseType;
  createCustomField: CustomFieldConfigurationType;
  createDevice: DeviceResponseType;
  createDeviceBackupLifecycleSettings: DeviceBackupLifecycleSettingsResponseType;
  createDocument: CreateDocumentResponseType;
  createDocumentVersion: DocumentVersionUploadUrlResponseType;
  createExplanation: ExplanationResponseType;
  createFileDifferencesExplanation: FileExplanationResponseType;
  createFileExplanation: FileExplanationResponseType;
  createGateway: GatewayResponseType;
  createGlobalBackupLifecycleSettings: GlobalBackupLifecycleSettingsResponseType;
  createIntegration: IntegrationResponseType;
  createJob: JobResponseType;
  createLicense: CreateLicenseResponseType;
  createLock: LockResponseType;
  createOffboarding: OffboardingResponseType;
  createPipelineConfiguration: PipelineConfigurationResponseType;
  createProject: CreateProjectResponseType;
  createProjectAnalysis: ProjectAnalysisResponseType;
  createProjectAnalysisPresignedUrl?: Maybe<Scalars['String']['output']>;
  createProjectDocumentation: ProjectDocumentationResponseType;
  createProjectVersion: ProjectVersionUploadUrlResponseType;
  createResourceGroup: ResourceGroupResponseType;
  createSecret: SecretResponseType;
  createTag: TagResponseType;
  createTenant: TenantResponseType;
  createTenantSubscription: BillingResponse;
  createUser: UserResponseType;
  createUserGroup: UserGroupResponseType;
  createUserRole: UserRoleResponseType;
  createUserRoleUserLink: UserRoleUserLinkResponseType;
  createVault: VaultResponseType;
  createWebhookConfiguration: WebhookConfigurationResponseType;
  createWorkstation: WorkstationResponseType;
  createWorkstationConnection: WorkstationConnectionType;
  /** @deprecated Deprecated (CONN-123): use createWorkstationConnection / deleteWorkstationConnection instead. */
  createWorkstationDeviceConnection: WorkstationDeviceConnectionType;
  /** @deprecated Deprecated (CONN-123): use createWorkstationConnection / deleteWorkstationConnection instead. */
  createWorkstationDeviceConnectionV2: WorkstationDeviceConnectionV2Type;
  deactivateCustomField: CustomFieldConfigurationType;
  defineAssetLinksFromAsset: PaginatedAssetLinkResponseType;
  defineAssetLinksToAsset: PaginatedAssetLinkResponseType;
  deleteAssetLink: AssetLinkResponseType;
  deleteDevice: DeviceResponseType;
  deleteDeviceBackupLifecycleSettings: DeviceBackupLifecycleSettingsResponseType;
  deleteDocument: DocumentResponseType;
  deleteDocumentVersion: DocumentVersionResponseType;
  deleteGateway: GatewayResponseType;
  deleteGlobalBackupLifecycleSettings: GlobalBackupLifecycleSettingsResponseType;
  deleteIntegration: IntegrationResponseType;
  deleteJob: JobResponseType;
  deleteLicense: LicenseResponseType;
  deleteLock: LockResponseType;
  deleteOffboarding?: Maybe<Scalars['String']['output']>;
  deletePipelineConfiguration: PipelineConfigurationResponseType;
  deletePipelineExecution: PipelineExecutionResponseType;
  deleteProject: ProjectResponseType;
  deleteProjectVersion: ProjectVersionResponseType;
  deleteResourceGroup: ResourceGroupResponseType;
  deleteSecret: SecretResponseType;
  deleteTag: TagResponseType;
  deleteUser: UserResponseType;
  deleteUserGroup: UserGroupResponseType;
  deleteUserRole: UserRoleResponseType;
  deleteUserRoleUserLink?: Maybe<Scalars['Void']['output']>;
  deleteVault: VaultResponseType;
  deleteWebhookConfiguration: WebhookConfigurationResponseType;
  deleteWorkstation: WorkstationResponseType;
  deleteWorkstationConnection: WorkstationConnectionType;
  /** @deprecated Deprecated (CONN-123): use createWorkstationConnection / deleteWorkstationConnection instead. */
  deleteWorkstationDeviceConnection: WorkstationDeviceConnectionType;
  /** @deprecated Deprecated (CONN-123): use createWorkstationConnection / deleteWorkstationConnection instead. */
  deleteWorkstationDeviceConnectionV2: WorkstationDeviceConnectionV2Type;
  downloadArtifactsForJob: JobArtifactsResponseType;
  endVscodeSession: EndVscodeSessionResponse;
  /** Trigger audit logs CSV export */
  exportAuditLogsCsv: AuditLogCsvExportTriggerResponseType;
  forgotPassword: ForgotPasswordResponseType;
  generateTwoFactorAuthToken: GenerateTwoFactorAuthTokenResponseType;
  generateUrlUploadArtifactFiles: Array<GenericArtifactResponseType>;
  getRecordingPlaybackUrl: PlaybackUrlResponseType;
  handleTermsAndConditionsAccepted: BillingResponse;
  heartbeatVscodeSession: VscodeSession;
  linkCustomField: CustomFieldLinkageType;
  loginUser: LoginUserResponseType;
  readIdentityProviderByEmail: IdentityProviderResponseType;
  requestGatewayUpdate: GatewayUpdateRequestType;
  revokeTenantScheduledSubscriptionChange: BillingResponse;
  selectTenant?: Maybe<Scalars['Void']['output']>;
  startChat: ChatResponseType;
  startSession: StartSessionResponseType;
  startVscodeSession: StartVscodeSessionResponse;
  switchTenantPlan: BillingResponse;
  syncIntegration: IntegrationResponseType;
  syncWeakSecretFlags: SyncWeakSecretFlagsResponseType;
  triggerPipelineExecution: PipelineExecutionResponseType;
  unlinkCustomField: CustomFieldLinkageType;
  updateAssetLink: AssetLinkResponseType;
  updateCustomField: CustomFieldConfigurationType;
  updateDevice: DeviceResponseType;
  updateDeviceBackupLifecycleSettings: DeviceBackupLifecycleSettingsResponseType;
  updateDocument: DocumentResponseType;
  updateDocumentVersion: DocumentVersionResponseType;
  updateGateway: GatewayResponseType;
  updateGatewayConfig: GatewayConfigResponseType;
  updateGitRepository: GitRepositoryResponseType;
  updateGlobalBackupLifecycleSettings: GlobalBackupLifecycleSettingsResponseType;
  updateHubConfig: HubConfigType;
  updateIntegration: IntegrationResponseType;
  updateJob: JobResponseType;
  updateLicense: LicenseResponseType;
  updateNotificationReadStatus: NotificationResponseType;
  updatePipelineConfiguration: PipelineConfigurationResponseType;
  updateProject: ProjectResponseType;
  updateProjectVersion: ProjectVersionResponseType;
  updateResourceGroup: ResourceGroupResponseType;
  updateSecret: SecretResponseType;
  updateTag: TagResponseType;
  updateTenant: TenantResponseType;
  updateTenantSubscription: BillingResponse;
  updateUser: UserResponseType;
  updateUserGroup: UserGroupResponseType;
  updateUserRole: UserRoleResponseType;
  updateUserRoleUserLink: UserRoleUserLinkResponseType;
  updateUserUiPreferences: UserUiPreferencesResponseType;
  updateVault: VaultResponseType;
  updateWebhookConfiguration: WebhookConfigurationResponseType;
  updateWorkstation: WorkstationResponseType;
  verifyTotpTwoFactorAuth: AuthenticateTwoFactorAuthTokenResponseType;
};


export type MutationActivateCustomFieldArgs = {
  fieldId: Scalars['String']['input'];
};


export type MutationAuthenticateTwoFactorAuthTokenArgs = {
  input: AuthenticateTwoFactorAuthTokenInput;
};


export type MutationBulkCreateDeviceBackupLifecycleSettingsArgs = {
  input: BulkCreateDeviceBackupLifecycleSettingsInput;
};


export type MutationBulkDeleteDeviceBackupLifecycleSettingsArgs = {
  input: BulkDeleteDeviceBackupLifecycleSettingsInput;
};


export type MutationCancelTenantSubscriptionArgs = {
  params: BillingCancelSubscriptionInput;
};


export type MutationCompleteDocumentVersionMultipartUploadArgs = {
  completeUploadInput: CompleteMultipartUploadInput;
  documentId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationCompleteLicenseMultipartUploadArgs = {
  completeUploadInput: CompleteMultipartUploadInput;
  licenseId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationCompleteProjectVersionMultipartUploadArgs = {
  completeUploadInput: CompleteMultipartUploadInput;
  projectId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationConfirmUserArgs = {
  input: ConfirmUserInput;
};


export type MutationContinueChatArgs = {
  message: ContinueChatInput;
};


export type MutationCreateAssetLinkArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  input: CreateAssetLinkInput;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type MutationCreateChangeDocumentationArgs = {
  explanation: CreateProjectChangeDocumentationInput;
};


export type MutationCreateCustomFieldArgs = {
  customField: CreateCustomFieldInput;
};


export type MutationCreateDeviceArgs = {
  device: CreateDeviceInput;
};


export type MutationCreateDeviceBackupLifecycleSettingsArgs = {
  input: CreateDeviceBackupLifecycleSettingsInput;
};


export type MutationCreateDocumentArgs = {
  document: CreateDocumentInput;
};


export type MutationCreateDocumentVersionArgs = {
  documentId: Scalars['String']['input'];
  documentVersion: CreateDocumentVersionInput;
};


export type MutationCreateExplanationArgs = {
  explanation: CreateExplanationInput;
};


export type MutationCreateFileDifferencesExplanationArgs = {
  explanation: CreateFileDifferencesExplanationInput;
};


export type MutationCreateFileExplanationArgs = {
  explanation: CreateFileExplanationInput;
};


export type MutationCreateGatewayArgs = {
  gateway: CreateGatewayInput;
};


export type MutationCreateGlobalBackupLifecycleSettingsArgs = {
  input: CreateGlobalBackupLifecycleSettingsInput;
};


export type MutationCreateIntegrationArgs = {
  integration: CreateIntegrationInput;
};


export type MutationCreateJobArgs = {
  job: CreateJobInput;
};


export type MutationCreateLicenseArgs = {
  license: CreateLicenseInput;
};


export type MutationCreateLockArgs = {
  lock: CreateLockInput;
};


export type MutationCreatePipelineConfigurationArgs = {
  pipelineConfiguration: CreatePipelineConfigurationInput;
};


export type MutationCreateProjectArgs = {
  project: CreateProjectInput;
};


export type MutationCreateProjectAnalysisArgs = {
  analysis: CreateProjectAnalysisInput;
};


export type MutationCreateProjectAnalysisPresignedUrlArgs = {
  analysisId: Scalars['String']['input'];
};


export type MutationCreateProjectDocumentationArgs = {
  documentation: CreateProjectDocumentationInput;
};


export type MutationCreateProjectVersionArgs = {
  projectId: Scalars['String']['input'];
  projectVersion: CreateProjectVersionInput;
};


export type MutationCreateResourceGroupArgs = {
  resourceGroup: CreateResourceGroupInput;
};


export type MutationCreateSecretArgs = {
  secret: CreateSecretInput;
};


export type MutationCreateTagArgs = {
  tag: CreateTagInput;
};


export type MutationCreateTenantArgs = {
  tenant: CreateTenantInput;
};


export type MutationCreateTenantSubscriptionArgs = {
  params: BillingCreateSubscriptionInput;
};


export type MutationCreateUserArgs = {
  user: CreateUserInput;
};


export type MutationCreateUserGroupArgs = {
  userGroup: CreateUserGroupInput;
};


export type MutationCreateUserRoleArgs = {
  userRole: CreateUserRoleInput;
};


export type MutationCreateUserRoleUserLinkArgs = {
  input: CreateUserRoleUserLinkInput;
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationCreateVaultArgs = {
  vault: CreateVaultInput;
};


export type MutationCreateWebhookConfigurationArgs = {
  webhookConfiguration: CreateWebhookConfigurationInput;
};


export type MutationCreateWorkstationArgs = {
  workstation: CreateWorkstationInput;
};


export type MutationCreateWorkstationConnectionArgs = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationCreateWorkstationDeviceConnectionArgs = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationCreateWorkstationDeviceConnectionV2Args = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationDeactivateCustomFieldArgs = {
  fieldId: Scalars['String']['input'];
};


export type MutationDefineAssetLinksFromAssetArgs = {
  destinationType: AssetTypeEnum;
  input: Array<DefineAssetLinkFromAssetInput>;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type MutationDefineAssetLinksToAssetArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  input: Array<DefineAssetLinkToAssetInput>;
  sourceType: AssetTypeEnum;
};


export type MutationDeleteAssetLinkArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type MutationDeleteDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationDeleteDeviceBackupLifecycleSettingsArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationDeleteDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationDeleteDocumentVersionArgs = {
  documentId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationDeleteGatewayArgs = {
  gatewayId: Scalars['String']['input'];
};


export type MutationDeleteIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationDeleteJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationDeleteLicenseArgs = {
  licenseId: Scalars['String']['input'];
};


export type MutationDeleteLockArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationDeletePipelineConfigurationArgs = {
  pipelineConfigurationId: Scalars['String']['input'];
};


export type MutationDeletePipelineExecutionArgs = {
  pipelineExecutionId: Scalars['String']['input'];
};


export type MutationDeleteProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationDeleteProjectVersionArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type MutationDeleteResourceGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteSecretArgs = {
  secretId: Scalars['String']['input'];
};


export type MutationDeleteTagArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteUserRoleArgs = {
  userRoleId: Scalars['String']['input'];
};


export type MutationDeleteUserRoleUserLinkArgs = {
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationDeleteVaultArgs = {
  vaultId: Scalars['String']['input'];
};


export type MutationDeleteWebhookConfigurationArgs = {
  webhookConfigurationId: Scalars['String']['input'];
};


export type MutationDeleteWorkstationArgs = {
  workstationId: Scalars['String']['input'];
};


export type MutationDeleteWorkstationConnectionArgs = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationDeleteWorkstationDeviceConnectionArgs = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationDeleteWorkstationDeviceConnectionV2Args = {
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
};


export type MutationDownloadArtifactsForJobArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationEndVscodeSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationExportAuditLogsCsvArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<AuditLogFilterInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateTwoFactorAuthTokenArgs = {
  input: GenerateTwoFactorAuthTokenInput;
};


export type MutationGenerateUrlUploadArtifactFilesArgs = {
  request: GenericArtifactRequestInput;
};


export type MutationGetRecordingPlaybackUrlArgs = {
  recordingId: Scalars['String']['input'];
};


export type MutationHeartbeatVscodeSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationLinkCustomFieldArgs = {
  linkage: LinkCustomFieldInput;
};


export type MutationLoginUserArgs = {
  input: LoginUserInput;
};


export type MutationReadIdentityProviderByEmailArgs = {
  appClientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationRequestGatewayUpdateArgs = {
  gatewayId: Scalars['String']['input'];
};


export type MutationRevokeTenantScheduledSubscriptionChangeArgs = {
  params: BillingRevokeScheduledSubscriptionChangeInput;
};


export type MutationSelectTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type MutationStartChatArgs = {
  message: StartChatInput;
};


export type MutationStartSessionArgs = {
  input: StartSessionInput;
};


export type MutationStartVscodeSessionArgs = {
  input: StartVscodeSessionInput;
};


export type MutationSwitchTenantPlanArgs = {
  params: BillingSwitchPlanInput;
};


export type MutationSyncIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type MutationTriggerPipelineExecutionArgs = {
  pipelineConfigurationId: Scalars['String']['input'];
};


export type MutationUnlinkCustomFieldArgs = {
  linkage: LinkCustomFieldInput;
};


export type MutationUpdateAssetLinkArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  input: UpdateAssetLinkInput;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type MutationUpdateCustomFieldArgs = {
  customField: UpdateCustomFieldInput;
  fieldId: Scalars['String']['input'];
};


export type MutationUpdateDeviceArgs = {
  device: UpdateDeviceInput;
  deviceId: Scalars['String']['input'];
};


export type MutationUpdateDeviceBackupLifecycleSettingsArgs = {
  input: UpdateDeviceBackupLifecycleSettingsInput;
};


export type MutationUpdateDocumentArgs = {
  document: UpdateDocumentInput;
  documentId: Scalars['String']['input'];
};


export type MutationUpdateDocumentVersionArgs = {
  documentId: Scalars['String']['input'];
  documentVersion: UpdateDocumentVersionInput;
  versionId: Scalars['String']['input'];
};


export type MutationUpdateGatewayArgs = {
  gateway: UpdateGatewayInput;
  gatewayId: Scalars['String']['input'];
};


export type MutationUpdateGatewayConfigArgs = {
  config: GatewayConfigUpdateInput;
  gatewayId: Scalars['String']['input'];
};


export type MutationUpdateGitRepositoryArgs = {
  gitRepository: UpdateGitRepositoryInput;
  gitRepositoryId: Scalars['String']['input'];
};


export type MutationUpdateGlobalBackupLifecycleSettingsArgs = {
  input: UpdateGlobalBackupLifecycleSettingsInput;
};


export type MutationUpdateHubConfigArgs = {
  input: UpdateHubConfigInput;
};


export type MutationUpdateIntegrationArgs = {
  integration: UpdateIntegrationInput;
  integrationId: Scalars['String']['input'];
};


export type MutationUpdateJobArgs = {
  input: UpdateJobInput;
  jobId: Scalars['String']['input'];
};


export type MutationUpdateLicenseArgs = {
  license: UpdateLicenseInput;
  licenseId: Scalars['String']['input'];
};


export type MutationUpdateNotificationReadStatusArgs = {
  notificationId: Scalars['String']['input'];
  readStatus: Scalars['Boolean']['input'];
};


export type MutationUpdatePipelineConfigurationArgs = {
  input: UpdatePipelineConfigurationInput;
  pipelineConfigurationId: Scalars['String']['input'];
};


export type MutationUpdateProjectArgs = {
  project: UpdateProjectInput;
  projectId: Scalars['String']['input'];
};


export type MutationUpdateProjectVersionArgs = {
  projectId: Scalars['String']['input'];
  projectVersion: UpdateProjectVersionInput;
  versionId: Scalars['String']['input'];
};


export type MutationUpdateResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  resourceGroup: UpdateResourceGroupInput;
};


export type MutationUpdateSecretArgs = {
  secret: UpdateSecretInput;
  secretId: Scalars['String']['input'];
};


export type MutationUpdateTagArgs = {
  name: Scalars['String']['input'];
  tag: UpdateTagInput;
};


export type MutationUpdateTenantArgs = {
  tenant: UpdateTenantInput;
};


export type MutationUpdateTenantSubscriptionArgs = {
  params: BillingUpdateSubscriptionInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserInput;
  userId: Scalars['String']['input'];
};


export type MutationUpdateUserGroupArgs = {
  groupId: Scalars['String']['input'];
  userGroup: UpdateUserGroupInput;
};


export type MutationUpdateUserRoleArgs = {
  userRole: UpdateUserRoleInput;
  userRoleId: Scalars['String']['input'];
};


export type MutationUpdateUserRoleUserLinkArgs = {
  input: UpdateUserRoleUserLinkInput;
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
};


export type MutationUpdateUserUiPreferencesArgs = {
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationUpdateVaultArgs = {
  vault: UpdateVaultInput;
  vaultId: Scalars['String']['input'];
};


export type MutationUpdateWebhookConfigurationArgs = {
  input: UpdateWebhookConfigurationInput;
  webhookConfigurationId: Scalars['String']['input'];
};


export type MutationUpdateWorkstationArgs = {
  workstation: UpdateWorkstationInput;
  workstationId: Scalars['String']['input'];
};


export type MutationVerifyTotpTwoFactorAuthArgs = {
  input: VerifyTotpTwoFactorAuthInput;
};

export enum NetcatStatusEnum {
  Ok = 'OK',
  Refused = 'REFUSED',
  Reset = 'RESET',
  Timeout = 'TIMEOUT',
  Unreachable = 'UNREACHABLE'
}

export type NotificationFilterInput = {
  consoleConfiguration?: InputMaybe<ConsoleConfigurationFilterInput>;
  emailConfiguration?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type NotificationResponseType = {
  __typename?: 'NotificationResponseType';
  consoleConfiguration?: Maybe<ConsoleNotificationResponseType>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  emailConfiguration?: Maybe<EmailNotificationResponseType>;
  notificationId: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  status: NotificationStatus;
  type: NotificationType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export enum NotificationStatus {
  Created = 'CREATED'
}

export enum NotificationType {
  Both = 'BOTH',
  Console = 'CONSOLE',
  Email = 'EMAIL'
}

export type NumberFilterInput = {
  between?: InputMaybe<Array<Scalars['Float']['input']>>;
  doNotIgnoreNullable?: InputMaybe<Array<FilterOperatorEnum>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in_?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type OffboardingFilterInput = {
  dataPurgeTimestamp?: InputMaybe<StringFilterInput>;
  deactivationTimestamp?: InputMaybe<StringFilterInput>;
  notificationRate?: InputMaybe<StringFilterInput>;
  reactivationTimestamp?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
};

export type OffboardingResponseType = {
  __typename?: 'OffboardingResponseType';
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Scheduled data purge time (30 days from now) */
  dataPurgeTimestamp: Scalars['DateTime']['output'];
  /** Scheduled deactivation time (7 days from now) */
  deactivationTimestamp: Scalars['DateTime']['output'];
  notificationRate?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  offboardingId: Scalars['String']['output'];
  reactivationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  status: OffboardingStatus;
  tenantReactivated?: Maybe<Scalars['Boolean']['output']>;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export enum OffboardingStatus {
  DeactivationInitiated = 'DEACTIVATION_INITIATED'
}

export enum OperatingSystemEnum {
  Linux = 'LINUX',
  Rhel = 'RHEL',
  Windows = 'WINDOWS'
}

export type OtCveRecordType = {
  __typename?: 'OtCveRecordType';
  advisoryLink?: Maybe<Scalars['String']['output']>;
  affectedVersions?: Maybe<Scalars['String']['output']>;
  cveNumber?: Maybe<Scalars['String']['output']>;
  cveTitle?: Maybe<Scalars['String']['output']>;
  cvssScore?: Maybe<Scalars['Decimal']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fixedVersions?: Maybe<Scalars['String']['output']>;
  nvdDescription?: Maybe<Scalars['String']['output']>;
  nvdSeverity?: Maybe<Scalars['String']['output']>;
  nvdUrl?: Maybe<Scalars['String']['output']>;
  productArticleNumber: Scalars['String']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
};

export type OtCveResponseType = {
  __typename?: 'OtCveResponseType';
  otCveId: Scalars['String']['output'];
  record: OtCveRecordType;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type OwnerUserResponseType = {
  __typename?: 'OwnerUserResponseType';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PaginatedAssetLinkResponseType = {
  __typename?: 'PaginatedAssetLinkResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<AssetLinkResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedAuditLogResponseType = {
  __typename?: 'PaginatedAuditLogResponseType';
  after?: Maybe<Scalars['JSON']['output']>;
  countCapped: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<AuditLogResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedChatResponseType = {
  __typename?: 'PaginatedChatResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ChatResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedDeviceBackupLifecycleSettingsResponseType = {
  __typename?: 'PaginatedDeviceBackupLifecycleSettingsResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<DeviceBackupLifecycleSettingsResponseType>;
  pages: Scalars['Int']['output'];
};

export type PaginatedDeviceOtCveResponseType = {
  __typename?: 'PaginatedDeviceOtCveResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<DeviceOtCveResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedDeviceResponseType = {
  __typename?: 'PaginatedDeviceResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<DeviceResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedDocumentResponseType = {
  __typename?: 'PaginatedDocumentResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<DocumentResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedDocumentVersionResponseType = {
  __typename?: 'PaginatedDocumentVersionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<DocumentVersionResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedGatewayResponseType = {
  __typename?: 'PaginatedGatewayResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<GatewayResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedGitRepositoryResponseType = {
  __typename?: 'PaginatedGitRepositoryResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<GitRepositoryResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedIntegrationResponseType = {
  __typename?: 'PaginatedIntegrationResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<IntegrationResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedJobResponseType = {
  __typename?: 'PaginatedJobResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<JobResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedLicenseResponseType = {
  __typename?: 'PaginatedLicenseResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<LicenseResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedNotificationResponseType = {
  __typename?: 'PaginatedNotificationResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<NotificationResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedOffboardingResponseType = {
  __typename?: 'PaginatedOffboardingResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<OffboardingResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedPipelineConfigurationResponseType = {
  __typename?: 'PaginatedPipelineConfigurationResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<PipelineConfigurationResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedPipelineExecutionResponseType = {
  __typename?: 'PaginatedPipelineExecutionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<PipelineExecutionResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedProjectResponseType = {
  __typename?: 'PaginatedProjectResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ProjectResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedProjectVersionResponseType = {
  __typename?: 'PaginatedProjectVersionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ProjectVersionResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedResourceGroupAssetResponseType = {
  __typename?: 'PaginatedResourceGroupAssetResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ResourceGroupAssetResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedResourceGroupResponseType = {
  __typename?: 'PaginatedResourceGroupResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<ResourceGroupResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSecretResponseType = {
  __typename?: 'PaginatedSecretResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SecretResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSecretVersionResponseType = {
  __typename?: 'PaginatedSecretVersionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SecretVersionResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSecretVersionUnceiledResponseType = {
  __typename?: 'PaginatedSecretVersionUnceiledResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<SecretVersionUnceiledResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedSessionResponseType = {
  __typename?: 'PaginatedSessionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<SessionResponseType>;
  pages: Scalars['Int']['output'];
};

export type PaginatedTagResponseType = {
  __typename?: 'PaginatedTagResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<TagResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedTenantResponseType = {
  __typename?: 'PaginatedTenantResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<TenantResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedUserGroupResponseType = {
  __typename?: 'PaginatedUserGroupResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<UserGroupResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedUserResponseType = {
  __typename?: 'PaginatedUserResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<UserResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedUserRoleResponseType = {
  __typename?: 'PaginatedUserRoleResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<UserRoleResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedUserRoleUserLinkResponseType = {
  __typename?: 'PaginatedUserRoleUserLinkResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<UserRoleUserLinkResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedVaultResponseType = {
  __typename?: 'PaginatedVaultResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<VaultResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedWebhookConfigurationResponseType = {
  __typename?: 'PaginatedWebhookConfigurationResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<WebhookConfigurationResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedWorkstationConnectionResponseType = {
  __typename?: 'PaginatedWorkstationConnectionResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<WorkstationConnectionType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedWorkstationDeviceConnectionStatusResponseType = {
  __typename?: 'PaginatedWorkstationDeviceConnectionStatusResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<WorkstationDeviceConnectionType>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedWorkstationDeviceConnectionV2StatusResponseType = {
  __typename?: 'PaginatedWorkstationDeviceConnectionV2StatusResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<WorkstationDeviceConnectionV2Type>>;
  pages: Scalars['Int']['output'];
};

export type PaginatedWorkstationResponseType = {
  __typename?: 'PaginatedWorkstationResponseType';
  itemCount: Scalars['Int']['output'];
  items: Array<Maybe<WorkstationResponseType>>;
  pages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginationInputType = {
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export enum PingStatusEnum {
  Ok = 'OK',
  Timeout = 'TIMEOUT'
}

export type PipelineConfigurationFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  deviceIds?: InputMaybe<StringFilterInput>;
  enabled?: InputMaybe<BooleanFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  projectIds?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
};

export type PipelineConfigurationResponseType = BaseResponseInterface & {
  __typename?: 'PipelineConfigurationResponseType';
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceIds: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  licenseIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameLower?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  pipelineConfigurationId: Scalars['String']['output'];
  projectIds: Array<Scalars['String']['output']>;
  projectVersionIds: Array<Scalars['String']['output']>;
  steps: Array<PipelineStepConfigurationType>;
  trigger: PipelineTriggerConfigurationType;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export type PipelineExecutionFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  pipelineConfigurationId?: InputMaybe<StringFilterInput>;
  status?: InputMaybe<StringFilterInput>;
  triggerSource?: InputMaybe<StringFilterInput>;
};

export type PipelineExecutionResponseType = BaseResponseInterface & {
  __typename?: 'PipelineExecutionResponseType';
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Int']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectVersion?: Maybe<Scalars['Int']['output']>;
  pipelineConfigurationId: Scalars['String']['output'];
  pipelineExecutionId: Scalars['String']['output'];
  status: PipelineExecutionStatusEnum;
  steps: Array<PipelineExecutionStepResponseType>;
  triggerSource: PipelineManualTriggerConfigurationTypePipelineScheduledTriggerConfigurationType;
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  updateUserId?: Maybe<Scalars['String']['output']>;
};

export enum PipelineExecutionStatusEnum {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FailedIgnore = 'FAILED_IGNORE',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  TimedOut = 'TIMED_OUT',
  Warning = 'WARNING'
}

export type PipelineExecutionStepResponseType = {
  __typename?: 'PipelineExecutionStepResponseType';
  allowFailure: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: PipelineExecutionStatusEnum;
  targets: Array<TargetExecutionStatusResponseType>;
  type: FeatureEnum;
};

export type PipelineManualTriggerConfigurationType = {
  __typename?: 'PipelineManualTriggerConfigurationType';
  type: PipelineTriggerSourceTypeEnum;
};

export type PipelineManualTriggerConfigurationTypePipelineScheduledTriggerConfigurationType = PipelineManualTriggerConfigurationType | PipelineScheduledTriggerConfigurationType;

export enum PipelineScheduleTypesEnum {
  At = 'AT',
  Cron = 'CRON',
  Rate = 'RATE'
}

export type PipelineScheduledTriggerConfigurationType = {
  __typename?: 'PipelineScheduledTriggerConfigurationType';
  expression: Scalars['String']['output'];
  expressionTimezone?: Maybe<Scalars['String']['output']>;
  scheduleType?: Maybe<PipelineScheduleTypesEnum>;
  type: PipelineTriggerSourceTypeEnum;
};

export type PipelineStepConfigurationInput = {
  allowFailure?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  targetConfiguration: Array<TargetConfigurationInput>;
  type: FeatureEnum;
};

export type PipelineStepConfigurationType = {
  __typename?: 'PipelineStepConfigurationType';
  allowFailure: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetConfiguration: Array<TargetConfigurationType>;
  type: FeatureEnum;
};

export type PipelineTriggerConfigurationCombinedInput = {
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionTimezone?: InputMaybe<Scalars['String']['input']>;
  scheduleType?: InputMaybe<PipelineScheduleTypesEnum>;
  type: PipelineTriggerSourceTypeEnum;
};

export type PipelineTriggerConfigurationType = PipelineManualTriggerConfigurationType | PipelineScheduledTriggerConfigurationType;

export enum PipelineTriggerSourceTypeEnum {
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export enum PlanType {
  ActionBased = 'ACTION_BASED',
  Enterprise = 'ENTERPRISE',
  Individual = 'INDIVIDUAL',
  Initial = 'INITIAL',
  Premium = 'PREMIUM',
  Resale = 'RESALE',
  Standard = 'STANDARD',
  Trial = 'TRIAL'
}

export type PlaybackUrlResponseType = {
  __typename?: 'PlaybackUrlResponseType';
  playbackUrl: Scalars['String']['output'];
  recordingId: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type PolicyInput = {
  action: Array<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  resource: Array<Scalars['String']['input']>;
};

export type PolicyType = {
  __typename?: 'PolicyType';
  action: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  policyId: Scalars['String']['output'];
  resource: Array<Scalars['String']['output']>;
};

export enum ProgrammingLanguageEnum {
  Fbd = 'FBD',
  FFbd = 'F_FBD',
  FLad = 'F_LAD',
  Graph = 'GRAPH',
  Il = 'IL',
  Lad = 'LAD',
  Rll = 'RLL',
  Scl = 'SCL',
  Sfc = 'SFC',
  St = 'ST',
  Stl = 'STL',
  Unknown = 'UNKNOWN'
}

export type ProjectAnalysisResponseType = {
  __typename?: 'ProjectAnalysisResponseType';
  analysisId: Scalars['String']['output'];
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  language: Language;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  s3ProjectTreeBucketKey: Scalars['String']['output'];
  status: ProjectAnalysisStatus;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export enum ProjectAnalysisStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  GeneratingProjectAnalysis = 'GENERATING_PROJECT_ANALYSIS',
  NoItemsFound = 'NO_ITEMS_FOUND'
}

export type ProjectChangeDocumentationResponseType = {
  __typename?: 'ProjectChangeDocumentationResponseType';
  compareVersionId: Scalars['String']['output'];
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  explanationId: Scalars['String']['output'];
  language: Language;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['String']['output'];
  status: ProjectChangeDocumentationStatus;
  summary?: Maybe<Scalars['String']['output']>;
  tokenAggregatorId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export enum ProjectChangeDocumentationStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  GeneratingProjectExplanation = 'GENERATING_PROJECT_EXPLANATION',
  NoItemsChanged = 'NO_ITEMS_CHANGED'
}

export type ProjectDocumentationResponseType = {
  __typename?: 'ProjectDocumentationResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  explanationId: Scalars['String']['output'];
  language: Language;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['String']['output'];
  status: ProjectDocumentationStatus;
  summary?: Maybe<Scalars['String']['output']>;
  tokenAggregatorId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export enum ProjectDocumentationStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  GeneratingProjectDocumentation = 'GENERATING_PROJECT_DOCUMENTATION',
  NoItemsFound = 'NO_ITEMS_FOUND'
}

export type ProjectFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  ideConfigId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  projectType?: InputMaybe<StringFilterInput>;
  secretId?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
  vendorId?: InputMaybe<StringFilterInput>;
};

export type ProjectLinkMetaDataType = ProjectToDeviceLinkMetaDataType | ProjectToProjectLinkMetaDataType;

export type ProjectResponseType = AssetBaseResponseInterface & {
  __typename?: 'ProjectResponseType';
  attachedLicenses?: Maybe<Array<Scalars['String']['output']>>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId: Scalars['String']['output'];
  lastVersionNumber: Scalars['Int']['output'];
  linkMetaData?: Maybe<ProjectLinkMetaDataType>;
  linkedDevices: PaginatedDeviceResponseType;
  linkedDocuments: PaginatedDocumentResponseType;
  linkedParentProjects: PaginatedProjectResponseType;
  linkedSubProjects: PaginatedProjectResponseType;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['String']['output'];
  projectType: ProjectTypeEnum;
  secret?: Maybe<SecretResponseType>;
  secretId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
  versions: PaginatedProjectVersionResponseType;
};


export type ProjectResponseTypeLinkedDevicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ProjectResponseTypeLinkedDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ProjectResponseTypeLinkedParentProjectsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ProjectResponseTypeLinkedSubProjectsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ProjectResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ProjectResponseTypeVersionsArgs = {
  filter?: InputMaybe<ProjectVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type ProjectToDeviceLinkMetaDataType = {
  __typename?: 'ProjectToDeviceLinkMetaDataType';
  /** The IP address of the device within the project. */
  deviceIpAddress?: Maybe<Scalars['String']['output']>;
  /** The name of the device within the project. */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** The subnet mask of the device within the project. */
  deviceSubnet?: Maybe<Scalars['String']['output']>;
  /** The type of the device within the project. */
  deviceType?: Maybe<Scalars['String']['output']>;
  /** Version ID of the target project for the linked device. */
  targetProjectVersionId?: Maybe<Scalars['String']['output']>;
};

export type ProjectToProjectLinkMetaDataType = {
  __typename?: 'ProjectToProjectLinkMetaDataType';
  /** Specific version ID of the destination project. */
  destinationVersionId?: Maybe<Scalars['String']['output']>;
  /** Specific version ID of the source project. */
  sourceVersionId?: Maybe<Scalars['String']['output']>;
};

export enum ProjectTypeEnum {
  Generic = 'GENERIC',
  Library = 'LIBRARY',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN'
}

export type ProjectVersionDownloadUrlResponseType = {
  __typename?: 'ProjectVersionDownloadURLResponseType';
  downloadUrl: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export type ProjectVersionFileType = {
  __typename?: 'ProjectVersionFileType';
  fileExtension: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['BigInt']['output'];
};

export type ProjectVersionFilterInput = {
  commitMessage?: InputMaybe<StringFilterInput>;
  commitMessageLower?: InputMaybe<StringFilterInput>;
  creationTimestamp?: InputMaybe<StringFilterInput>;
  source?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
  versionId?: InputMaybe<StringFilterInput>;
};

export type ProjectVersionResponseInterface = {
  projectId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export type ProjectVersionResponseType = AssetBaseResponseInterface & ProjectVersionResponseInterface & {
  __typename?: 'ProjectVersionResponseType';
  commitId?: Maybe<Scalars['String']['output']>;
  commitMessage?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  deviceInformation?: Maybe<Array<DeviceInformationType>>;
  downloadUrl: Scalars['String']['output'];
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  ideConfigId?: Maybe<Scalars['String']['output']>;
  lock?: Maybe<LockResponseType>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projectFile: ProjectVersionFileType;
  projectId: Scalars['String']['output'];
  source: ProjectVersionSourceEnum;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vendorId?: Maybe<Scalars['String']['output']>;
  versionId: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export enum ProjectVersionSourceEnum {
  Git = 'GIT',
  Ideaas = 'IDEAAS',
  LocalClient = 'LOCAL_CLIENT',
  ProjectBackup = 'PROJECT_BACKUP',
  ProjectGsdImport = 'PROJECT_GSD_IMPORT',
  ProjectLibraryUpgrade = 'PROJECT_LIBRARY_UPGRADE',
  ProjectMerge = 'PROJECT_MERGE',
  ProjectUpdateOpcUaInterface = 'PROJECT_UPDATE_OPC_UA_INTERFACE',
  Upload = 'UPLOAD'
}

export type ProjectVersionUploadUrlResponseType = {
  __typename?: 'ProjectVersionUploadURLResponseType';
  projectId: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
  uploadUrls: Array<S3MultipartUploadUrlType>;
  versionId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  TenantPlaceholder: Scalars['String']['output'];
  UserPlaceholder: Scalars['String']['output'];
  downloadDocumentVersion: DocumentVersionDownloadUrlResponseType;
  downloadLicense: LicenseDownloadUrlResponseType;
  downloadProjectVersion: ProjectVersionDownloadUrlResponseType;
  generateGithubInstallUrl: GithubInstallUrlType;
  /** Health check endpoint */
  health: HealthResponseType;
  /** List all device-specific backup lifecycle settings for the current tenant */
  listDeviceBackupLifecycleSettings: PaginatedDeviceBackupLifecycleSettingsResponseType;
  myVscodeSessions: Array<VscodeSession>;
  /** Get project conversion artifacts */
  projectConversionArtifacts: ArtifactsResponseType;
  readAccumulatedDeviceSyncStatus: AccumulatedDeviceSyncStatusResponseType;
  readAdditionalTenantsForUser: PaginatedTenantResponseType;
  readAllAssetLinksFromAsset: PaginatedAssetLinkResponseType;
  readAllAssetLinksToAsset: PaginatedAssetLinkResponseType;
  /** Read all audit logs */
  readAllAuditLogs: PaginatedAuditLogResponseType;
  readAllChats: PaginatedChatResponseType;
  readAllDeviceVulnerabilities: PaginatedDeviceOtCveResponseType;
  readAllDevices: PaginatedDeviceResponseType;
  readAllDocuments: PaginatedDocumentResponseType;
  readAllGateways: PaginatedGatewayResponseType;
  readAllGitRepositories: PaginatedGitRepositoryResponseType;
  readAllIntegrations: PaginatedIntegrationResponseType;
  /** Get all jobs */
  readAllJobs: PaginatedJobResponseType;
  /** Get all jobs for a pipeline execution */
  readAllJobsForPipelineExecution: PaginatedJobResponseType;
  readAllLicenses: PaginatedLicenseResponseType;
  readAllNotifications: PaginatedNotificationResponseType;
  readAllOffboardings: PaginatedOffboardingResponseType;
  /** Get all pipeline configurations */
  readAllPipelineConfigurations: PaginatedPipelineConfigurationResponseType;
  /** Get all pipeline executions for a configuration */
  readAllPipelineExecutionsForConfiguration: PaginatedPipelineExecutionResponseType;
  readAllProjects: PaginatedProjectResponseType;
  readAllResourceGroups: PaginatedResourceGroupResponseType;
  readAllResourceGroupsForPermissions: Array<ResourceGroupForPermissionResponseType>;
  readAllSecrets: PaginatedSecretResponseType;
  readAllSessionRecordings: Array<SessionRecordingType>;
  readAllSessions: PaginatedSessionResponseType;
  readAllSessionsByTenantId: PaginatedSessionResponseType;
  readAllTags: PaginatedTagResponseType;
  readAllUserGroups: PaginatedUserGroupResponseType;
  readAllUserRoles: PaginatedUserRoleResponseType;
  readAllUsers: PaginatedUserResponseType;
  readAllVaults: PaginatedVaultResponseType;
  /** Get all webhook configurations */
  readAllWebhookConfigurations: PaginatedWebhookConfigurationResponseType;
  readAllWorkstationsForUser: PaginatedWorkstationResponseType;
  /** List all supported webhook model keys */
  readAllowedWebhookModelKeys: Array<Scalars['String']['output']>;
  readAssetLink: AssetLinkResponseType;
  readAssetsForResourceGroup: PaginatedResourceGroupAssetResponseType;
  readAssetsWithoutResourceGroup: PaginatedResourceGroupAssetResponseType;
  /** Read a single audit log by id */
  readAuditLog?: Maybe<AuditLogResponseType>;
  readChangeDocumentation: ProjectChangeDocumentationResponseType;
  readChat: ChatResponseType;
  readCustomFieldSupportedAssetTypes: Array<AssetTypeEnum>;
  readCustomFields: Array<CustomFieldConfigurationType>;
  readCustomFieldsForAssetType: Array<CustomFieldConfigurationType>;
  readDevice: DeviceResponseType;
  /** Get device-specific backup lifecycle settings */
  readDeviceBackupLifecycleSettings?: Maybe<DeviceBackupLifecycleSettingsResponseType>;
  readDeviceConnectivityStatus: DeviceConnectivityStatusType;
  readDeviceFirmwareInformation: DeviceFirmwareInformationResponseType;
  readDeviceSyncStatus: Array<DeviceSyncStatusResponseType>;
  readDevicesByIds: PaginatedDeviceResponseType;
  readDevicesForResourceGroup: PaginatedDeviceResponseType;
  readDocument: DocumentResponseType;
  readDocumentVersionsForDocument: PaginatedDocumentVersionResponseType;
  readDocumentsByIds: PaginatedDocumentResponseType;
  readDocumentsForResourceGroup: PaginatedDocumentResponseType;
  readExplanation: ExplanationResponseType;
  readFileExplanation: FileExplanationResponseType;
  readGateway: GatewayResponseType;
  readGatewayConfigDesired?: Maybe<GatewayConfigResponseType>;
  readGatewayConfigReported?: Maybe<GatewayConfigResponseType>;
  readGatewayMetadata?: Maybe<GatewayMetadataResponseType>;
  readGatewayPublicIp?: Maybe<GatewayPublicIpResponseType>;
  readGatewaySetup?: Maybe<GatewaySetupResponseType>;
  readGatewayState?: Maybe<GatewayStateResponseType>;
  readGatewayUpdateRequest?: Maybe<GatewayUpdateRequestType>;
  readGatewaysByIds: PaginatedGatewayResponseType;
  readGatewaysForResourceGroup: PaginatedGatewayResponseType;
  readGitRepositoriesForIntegration: PaginatedGitRepositoryResponseType;
  readGitRepository: GitRepositoryResponseType;
  /** Get global backup lifecycle settings for the current tenant */
  readGlobalBackupLifecycleSettings?: Maybe<GlobalBackupLifecycleSettingsResponseType>;
  readGroupedAssetCounts: Array<GroupedAssetCountResponseType>;
  readGroupedIdentityCounts: Array<GroupedIdentityCountResponseType>;
  readGroupedIntegrationCounts: Array<GroupedIntegrationCountResponseType>;
  /** Per-group pipeline configuration counts in one query */
  readGroupedPipelineCounts: Array<GroupedPipelineCountResponseType>;
  readHubConfig: HubConfigType;
  readIntegration: IntegrationResponseType;
  /** Get a job by ID */
  readJob: JobResponseType;
  /** Get job logs */
  readJobLogs: JobLogsResponseType;
  /** Get all jobs for a specific device */
  readJobsByDeviceId: PaginatedJobResponseType;
  /** Get all jobs for multiple devices */
  readJobsByDeviceIds: PaginatedJobResponseType;
  /** Get all jobs for a specific project */
  readJobsByProjectId: PaginatedJobResponseType;
  /** Get all jobs for multiple projects */
  readJobsByProjectIds: PaginatedJobResponseType;
  /** Latest execution per pipeline for many pipelines in one query */
  readLatestExecutionsForPipelines: Array<PipelineExecutionResponseType>;
  /** Newest N jobs per project for many projects in one query */
  readLatestJobsByProjectIds: Array<JobResponseType>;
  readLicense: LicenseResponseType;
  readLicensesByIds: PaginatedLicenseResponseType;
  readLicensesForResourceGroup: PaginatedLicenseResponseType;
  readLinkedDevicesForGateway: PaginatedDeviceResponseType;
  readLinkedDevicesForProject: PaginatedDeviceResponseType;
  readLinkedDocumentsForAsset: PaginatedDocumentResponseType;
  readLinkedGatewaysForDevice: PaginatedGatewayResponseType;
  readLinkedParentDevicesForDevice: PaginatedDeviceResponseType;
  readLinkedParentProjectsForProject: PaginatedProjectResponseType;
  readLinkedProjectsForDevice: PaginatedProjectResponseType;
  readLinkedSubDevicesForDevice: PaginatedDeviceResponseType;
  readLinkedSubProjectsForProject: PaginatedProjectResponseType;
  readLinkedTagsForAsset: PaginatedTagResponseType;
  readLock?: Maybe<LockResponseType>;
  readNotification: NotificationResponseType;
  readNotificationsByIds: PaginatedNotificationResponseType;
  readOffboarding: OffboardingResponseType;
  readOtCve: OtCveResponseType;
  /** Get a pipeline configuration by ID */
  readPipelineConfiguration: PipelineConfigurationResponseType;
  /** Get a pipeline execution by ID */
  readPipelineExecution: PipelineExecutionResponseType;
  readProject: ProjectResponseType;
  readProjectAnalysis: ProjectAnalysisResponseType;
  readProjectDocumentation: ProjectDocumentationResponseType;
  readProjectVersionsCreatedAfter: PaginatedProjectVersionResponseType;
  readProjectVersionsForProject: PaginatedProjectVersionResponseType;
  readProjectVersionsForProjects: PaginatedProjectVersionResponseType;
  readProjectsByIds: PaginatedProjectResponseType;
  readProjectsForResourceGroup: PaginatedProjectResponseType;
  readResourceGroup: ResourceGroupResponseType;
  readResourceGroupDevicesSyncStatus: ResourceGroupDevicesSyncStatusType;
  readResourceGroupsByIds: PaginatedResourceGroupResponseType;
  readSecret: SecretResponseType;
  readSecretUnceiled: SecretUnceiledResponseType;
  readSecretVersionsForSecret: PaginatedSecretVersionResponseType;
  readSecretVersionsUnceiledForSecret: PaginatedSecretVersionUnceiledResponseType;
  readSecretsForVault: PaginatedSecretResponseType;
  readSession: SessionResponseType;
  readSessionRecording: SessionRecordingType;
  readSessionRecordingsBySession: Array<SessionRecordingType>;
  readSubGroupsForResourceGroup: PaginatedResourceGroupResponseType;
  readSubGroupsForUserGroup: PaginatedUserGroupResponseType;
  readTag: TagResponseType;
  readTagsForResourceGroup: PaginatedTagResponseType;
  readTenant: TenantResponseType;
  readTermsAndConditionsAcceptance: TermsAndConditionsAcceptanceResponseType;
  readUser: UserResponseType;
  readUserGroup: UserGroupResponseType;
  readUserGroupsByIds: PaginatedUserGroupResponseType;
  readUserRole: UserRoleResponseType;
  readUserRoleUserLinksForUser: PaginatedUserRoleUserLinkResponseType;
  readUserRoleUserLinksForUserRole: PaginatedUserRoleUserLinkResponseType;
  readUserRolesForOwnUser: PaginatedUserRoleResponseType;
  readUserRolesForUser: PaginatedUserRoleResponseType;
  readUserUiPreferences: UserUiPreferencesResponseType;
  readUsersForUserGroup: PaginatedUserResponseType;
  readUsersForUserRole: PaginatedUserResponseType;
  readVault: VaultResponseType;
  /** Get all webhook configurations by gateway */
  readWebhookConfigsForGateway: PaginatedWebhookConfigurationResponseType;
  /** Get all webhook configurations by secret */
  readWebhookConfigsForSecret: PaginatedWebhookConfigurationResponseType;
  /** Get a webhook configuration by ID */
  readWebhookConfiguration: WebhookConfigurationResponseType;
  /** List all supported webhook event types */
  readWebhookEvents: Array<WebhookEventsEnum>;
  readWorkstation: WorkstationResponseType;
  readWorkstationConnections: PaginatedWorkstationConnectionResponseType;
  /** @deprecated Deprecated (CONN-123): use readWorkstationConnections instead. */
  readWorkstationDeviceConnections: PaginatedWorkstationDeviceConnectionStatusResponseType;
  /** @deprecated Deprecated (CONN-123): use readWorkstationConnections instead. */
  readWorkstationDeviceConnectionsV2: PaginatedWorkstationDeviceConnectionV2StatusResponseType;
  readWorkstationMetadata?: Maybe<WorkstationMetadataResponseType>;
  readWorkstationPublicIp?: Maybe<WorkstationPublicIpResponseType>;
  readWorkstationSetup?: Maybe<WorkstationSetupResponseType>;
  readWorkstationState?: Maybe<WorkstationStateResponseType>;
  readWorkstationsByIds: PaginatedWorkstationResponseType;
  readWorkstationsForResourceGroup: PaginatedWorkstationResponseType;
  resalePlans: Array<BillingPlan>;
  /** Resolve a coordinate into an address (city/state/country). */
  reverseGeocode?: Maybe<LocationType>;
  /** Geocode free-text into ranked address suggestions. */
  searchAddress: Array<AddressSuggestionType>;
  subscriptionStatus: TenantSubscriptionStatus;
  tenantEntitlementUsageStats: BillingUsageStats;
  tenantFeatureUsageStats: BillingUsageStats;
  tenantInvoiceData: BillingTenantInvoiceData;
  tenantScheduledSubscriptionChanges: Array<BillingScheduledSubscriptionChange>;
  tenantSubscription: BillingSubscription;
  tenantSubscriptionTermUsage: BillingSubscriptionTermUsage;
  vscodeSession?: Maybe<VscodeSession>;
};


export type QueryDownloadDocumentVersionArgs = {
  documentId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type QueryDownloadLicenseArgs = {
  licenseId: Scalars['String']['input'];
};


export type QueryDownloadProjectVersionArgs = {
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
};


export type QueryGenerateGithubInstallUrlArgs = {
  flow?: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type QueryListDeviceBackupLifecycleSettingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryProjectConversionArtifactsArgs = {
  projectId: Scalars['String']['input'];
  projectVersionId: Scalars['String']['input'];
};


export type QueryReadAccumulatedDeviceSyncStatusArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadAllAssetLinksFromAssetArgs = {
  filter?: InputMaybe<AssetLinkFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type QueryReadAllAssetLinksToAssetArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  filter?: InputMaybe<AssetLinkFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllAuditLogsArgs = {
  after?: InputMaybe<Scalars['JSON']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<AuditLogFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryReadAllChatsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllDeviceVulnerabilitiesArgs = {
  filter?: InputMaybe<DeviceVulnerabilityFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllDevicesArgs = {
  filter?: InputMaybe<DeviceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllDocumentsArgs = {
  filter?: InputMaybe<DocumentFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllGatewaysArgs = {
  filter?: InputMaybe<GatewayFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllGitRepositoriesArgs = {
  filter?: InputMaybe<GitRepositoryFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllIntegrationsArgs = {
  filter?: InputMaybe<IntegrationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllJobsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllJobsForPipelineExecutionArgs = {
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  pipelineExecutionId: Scalars['String']['input'];
};


export type QueryReadAllLicensesArgs = {
  filter?: InputMaybe<LicenseFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllNotificationsArgs = {
  filters?: InputMaybe<NotificationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllOffboardingsArgs = {
  filters?: InputMaybe<OffboardingFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllPipelineConfigurationsArgs = {
  filter?: InputMaybe<PipelineConfigurationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllPipelineExecutionsForConfigurationArgs = {
  filter?: InputMaybe<PipelineExecutionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  pipelineConfigurationId: Scalars['String']['input'];
};


export type QueryReadAllProjectsArgs = {
  filter?: InputMaybe<ProjectFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllResourceGroupsArgs = {
  filter?: InputMaybe<ResourceGroupFilterInput>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllSecretsArgs = {
  filter?: InputMaybe<SecretFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllSessionsArgs = {
  endTimestamp?: InputMaybe<Scalars['String']['input']>;
  hasRecording?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pagination: PaginationInputType;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SessionStatus>>;
};


export type QueryReadAllSessionsByTenantIdArgs = {
  pagination: PaginationInputType;
  statuses?: InputMaybe<Array<SessionStatus>>;
  tenantId: Scalars['String']['input'];
};


export type QueryReadAllTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllUserGroupsArgs = {
  filter?: InputMaybe<UserGroupFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllUserRolesArgs = {
  filter?: InputMaybe<UserRoleFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllVaultsArgs = {
  filter?: InputMaybe<VaultFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllWebhookConfigurationsArgs = {
  filter?: InputMaybe<WebhookConfigurationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllWorkstationsForUserArgs = {
  filter?: InputMaybe<WorkstationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAllowedWebhookModelKeysArgs = {
  webhookEventsEnum: WebhookEventsEnum;
};


export type QueryReadAssetLinkArgs = {
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
};


export type QueryReadAssetsForResourceGroupArgs = {
  filter?: InputMaybe<ResourceGroupAssetTypeFilterInput>;
  groupId: Scalars['String']['input'];
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAssetsWithoutResourceGroupArgs = {
  filter?: InputMaybe<ResourceGroupAssetTypeFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadAuditLogArgs = {
  auditLogId: Scalars['String']['input'];
};


export type QueryReadChangeDocumentationArgs = {
  explanationId: Scalars['String']['input'];
};


export type QueryReadChatArgs = {
  chatId: Scalars['String']['input'];
};


export type QueryReadCustomFieldsArgs = {
  filter?: InputMaybe<CustomFieldFilterInput>;
};


export type QueryReadCustomFieldsForAssetTypeArgs = {
  assetType: AssetTypeEnum;
};


export type QueryReadDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadDeviceBackupLifecycleSettingsArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadDeviceConnectivityStatusArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadDeviceFirmwareInformationArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadDeviceSyncStatusArgs = {
  deviceId: Scalars['String']['input'];
};


export type QueryReadDevicesByIdsArgs = {
  deviceIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadDevicesForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryReadDocumentVersionsForDocumentArgs = {
  documentId: Scalars['String']['input'];
  filter?: InputMaybe<DocumentVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadDocumentsByIdsArgs = {
  documentIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadDocumentsForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadExplanationArgs = {
  explanationId: Scalars['String']['input'];
};


export type QueryReadFileExplanationArgs = {
  explanationId: Scalars['String']['input'];
};


export type QueryReadGatewayArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayConfigDesiredArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayConfigReportedArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayMetadataArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayPublicIpArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewaySetupArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayStateArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewayUpdateRequestArgs = {
  gatewayId: Scalars['String']['input'];
};


export type QueryReadGatewaysByIdsArgs = {
  gatewayIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadGatewaysForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadGitRepositoriesForIntegrationArgs = {
  integrationId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadGitRepositoryArgs = {
  gitRepositoryId: Scalars['String']['input'];
};


export type QueryReadGroupedAssetCountsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};


export type QueryReadGroupedIdentityCountsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};


export type QueryReadGroupedIntegrationCountsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};


export type QueryReadGroupedPipelineCountsArgs = {
  groupIds: Array<Scalars['String']['input']>;
};


export type QueryReadIntegrationArgs = {
  integrationId: Scalars['String']['input'];
};


export type QueryReadJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryReadJobLogsArgs = {
  filter?: InputMaybe<JobLogsFilterInput>;
  jobId: Scalars['String']['input'];
};


export type QueryReadJobsByDeviceIdArgs = {
  deviceId: Scalars['String']['input'];
  filter?: InputMaybe<JobFilterInput>;
  jobTypes: Array<FeatureEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadJobsByDeviceIdsArgs = {
  deviceIds: Array<Scalars['String']['input']>;
  filter?: InputMaybe<JobFilterInput>;
  jobTypes: Array<FeatureEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadJobsByProjectIdArgs = {
  filter?: InputMaybe<JobFilterInput>;
  jobTypes: Array<FeatureEnum>;
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['String']['input'];
};


export type QueryReadJobsByProjectIdsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  jobTypes: Array<FeatureEnum>;
  pagination?: InputMaybe<PaginationInput>;
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryReadLatestExecutionsForPipelinesArgs = {
  pipelineConfigurationIds: Array<Scalars['String']['input']>;
};


export type QueryReadLatestJobsByProjectIdsArgs = {
  filter?: InputMaybe<JobFilterInput>;
  jobTypes: Array<FeatureEnum>;
  limitPerProject?: Scalars['Int']['input'];
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryReadLicenseArgs = {
  licenseId: Scalars['String']['input'];
};


export type QueryReadLicensesByIdsArgs = {
  licenseIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLicensesForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedDevicesForGatewayArgs = {
  gatewayId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedDevicesForProjectArgs = {
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['String']['input'];
};


export type QueryReadLinkedDocumentsForAssetArgs = {
  assetId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedGatewaysForDeviceArgs = {
  deviceId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedParentDevicesForDeviceArgs = {
  deviceId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedParentProjectsForProjectArgs = {
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['String']['input'];
};


export type QueryReadLinkedProjectsForDeviceArgs = {
  deviceId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedSubDevicesForDeviceArgs = {
  deviceId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLinkedSubProjectsForProjectArgs = {
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['String']['input'];
};


export type QueryReadLinkedTagsForAssetArgs = {
  assetId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadLockArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type QueryReadNotificationArgs = {
  notificationId: Scalars['String']['input'];
};


export type QueryReadNotificationsByIdsArgs = {
  notificationIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadOffboardingArgs = {
  offboardingId: Scalars['String']['input'];
};


export type QueryReadOtCveArgs = {
  cveNumber: Scalars['String']['input'];
  productArticleNumber: Scalars['String']['input'];
};


export type QueryReadPipelineConfigurationArgs = {
  pipelineConfigurationId: Scalars['String']['input'];
};


export type QueryReadPipelineExecutionArgs = {
  pipelineExecutionId: Scalars['String']['input'];
};


export type QueryReadProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryReadProjectAnalysisArgs = {
  analysisId: Scalars['String']['input'];
};


export type QueryReadProjectDocumentationArgs = {
  explanationId: Scalars['String']['input'];
};


export type QueryReadProjectVersionsCreatedAfterArgs = {
  creationTimestamp: Scalars['DateTime']['input'];
  filter?: InputMaybe<ProjectVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadProjectVersionsForProjectArgs = {
  filter?: InputMaybe<ProjectVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  projectId: Scalars['String']['input'];
};


export type QueryReadProjectVersionsForProjectsArgs = {
  filter?: InputMaybe<ProjectVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryReadProjectsByIdsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryReadProjectsForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadResourceGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryReadResourceGroupDevicesSyncStatusArgs = {
  filter?: InputMaybe<ResourceGroupDevicesSyncStatusFilterInput>;
  groupId: Scalars['String']['input'];
};


export type QueryReadResourceGroupsByIdsArgs = {
  groupIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadSecretArgs = {
  secretId: Scalars['String']['input'];
};


export type QueryReadSecretUnceiledArgs = {
  secretId: Scalars['String']['input'];
};


export type QueryReadSecretVersionsForSecretArgs = {
  filter?: InputMaybe<SecretFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  secretId: Scalars['String']['input'];
};


export type QueryReadSecretVersionsUnceiledForSecretArgs = {
  filter?: InputMaybe<SecretFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  secretId: Scalars['String']['input'];
};


export type QueryReadSecretsForVaultArgs = {
  filter?: InputMaybe<SecretFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  vaultId: Scalars['String']['input'];
};


export type QueryReadSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryReadSessionRecordingArgs = {
  recordingId: Scalars['String']['input'];
};


export type QueryReadSessionRecordingsBySessionArgs = {
  sessionId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<RecordingStatus>>;
};


export type QueryReadSubGroupsForResourceGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentGroupId: Scalars['String']['input'];
};


export type QueryReadSubGroupsForUserGroupArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentGroupId: Scalars['String']['input'];
};


export type QueryReadTagArgs = {
  name: Scalars['String']['input'];
};


export type QueryReadTagsForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryReadUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryReadUserGroupsByIdsArgs = {
  groupIds: Array<Scalars['String']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadUserRoleArgs = {
  userRoleId: Scalars['String']['input'];
};


export type QueryReadUserRoleUserLinksForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryReadUserRoleUserLinksForUserRoleArgs = {
  userRoleId: Scalars['String']['input'];
};


export type QueryReadUserRolesForOwnUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadUserRolesForUserArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId: Scalars['String']['input'];
};


export type QueryReadUsersForUserGroupArgs = {
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadUsersForUserRoleArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userRoleId: Scalars['String']['input'];
};


export type QueryReadVaultArgs = {
  vaultId: Scalars['String']['input'];
};


export type QueryReadWebhookConfigsForGatewayArgs = {
  gatewayId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReadWebhookConfigsForSecretArgs = {
  pagination?: InputMaybe<PaginationInput>;
  secretId: Scalars['String']['input'];
};


export type QueryReadWebhookConfigurationArgs = {
  webhookConfigurationId: Scalars['String']['input'];
};


export type QueryReadWorkstationArgs = {
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationConnectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationDeviceConnectionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationDeviceConnectionsV2Args = {
  pagination?: InputMaybe<PaginationInput>;
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationMetadataArgs = {
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationPublicIpArgs = {
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationSetupArgs = {
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationStateArgs = {
  workstationId: Scalars['String']['input'];
};


export type QueryReadWorkstationsByIdsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  workstationIds: Array<Scalars['String']['input']>;
};


export type QueryReadWorkstationsForResourceGroupArgs = {
  groupId: Scalars['String']['input'];
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryReverseGeocodeArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QuerySearchAddressArgs = {
  limit?: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};


export type QueryTenantEntitlementUsageStatsArgs = {
  params: BillingEntitlementUsageStatsInput;
};


export type QueryTenantFeatureUsageStatsArgs = {
  params: BillingFeatureUsageStatsInput;
};


export type QueryTenantInvoiceDataArgs = {
  params: BillingTenantInvoiceDataInput;
};


export type QueryTenantSubscriptionTermUsageArgs = {
  params: BillingSubscriptionTermUsageInput;
};


export type QueryVscodeSessionArgs = {
  sessionId: Scalars['String']['input'];
};

export enum RecordingStatus {
  Corrupted = 'CORRUPTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Ready = 'READY',
  Uploading = 'UPLOADING'
}

export type ResourceGroupAssetResponseType = DeviceResponseType | GatewayResponseType | ProjectResponseType;

export type ResourceGroupAssetTypeFilterInput = {
  assetType?: InputMaybe<StringFilterIgnoreDdbInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
};

export type ResourceGroupDevicesSyncStatusFilterInput = {
  deviceSyncStatus?: InputMaybe<StringFilterIgnoreDdbInput>;
};

export type ResourceGroupDevicesSyncStatusType = {
  __typename?: 'ResourceGroupDevicesSyncStatusType';
  devicesSyncStatus: Array<GroupDeviceSyncStatusType>;
  groupSyncStatus: DeviceSyncStatusEnum;
};

export type ResourceGroupFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  parentGroupId?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type ResourceGroupForPermissionResponseType = {
  __typename?: 'ResourceGroupForPermissionResponseType';
  groupId: Scalars['String']['output'];
  parentGroupId?: Maybe<Scalars['String']['output']>;
};

export type ResourceGroupResponseInterface = {
  groupId: Scalars['String']['output'];
  parentGroupId?: Maybe<Scalars['String']['output']>;
};

export type ResourceGroupResponseType = AssetBaseResponseInterface & ResourceGroupResponseInterface & {
  __typename?: 'ResourceGroupResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  devices: PaginatedDeviceResponseType;
  documents: PaginatedDocumentResponseType;
  fullPath: Scalars['String']['output'];
  fullPaths: Array<Scalars['String']['output']>;
  gateways: PaginatedGatewayResponseType;
  group?: Maybe<ResourceGroupResponseType>;
  groupDevicesSyncStatus: ResourceGroupDevicesSyncStatusType;
  groupId: Scalars['String']['output'];
  groupType: ResourceGroupTypeEnum;
  isSystemGroup: Scalars['Boolean']['output'];
  licenses: PaginatedLicenseResponseType;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  parentGroup?: Maybe<ResourceGroupResponseType>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  projects: PaginatedProjectResponseType;
  subGroups: PaginatedResourceGroupResponseType;
  tags: PaginatedTagResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};


export type ResourceGroupResponseTypeDevicesArgs = {
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeGatewaysArgs = {
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeGroupDevicesSyncStatusArgs = {
  filter?: InputMaybe<ResourceGroupDevicesSyncStatusFilterInput>;
};


export type ResourceGroupResponseTypeLicensesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeProjectsArgs = {
  includeSubGroups?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeSubGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ResourceGroupResponseTypeTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum ResourceGroupTypeEnum {
  Asset = 'ASSET',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type S3MultipartCompleteInfoInput = {
  etag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type S3MultipartUploadUrlType = {
  __typename?: 'S3MultipartUploadUrlType';
  partNumber: Scalars['Int']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type SecretFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type SecretResponseInterface = {
  secretId: Scalars['String']['output'];
  vaultId: Scalars['String']['output'];
  weakSecret: Scalars['Boolean']['output'];
};

export type SecretResponseType = AssetBaseResponseInterface & SecretResponseInterface & {
  __typename?: 'SecretResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastVersionNumber: Scalars['Int']['output'];
  linkedDevices: PaginatedDeviceResponseType;
  linkedProjects: PaginatedProjectResponseType;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  secretId: Scalars['String']['output'];
  secretType: SecretTypeEnum;
  secretValue: Scalars['String']['output'];
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  vault: VaultResponseType;
  vaultId: Scalars['String']['output'];
  versions: PaginatedSecretVersionResponseType;
  weakSecret: Scalars['Boolean']['output'];
};

export enum SecretTypeEnum {
  Certificate = 'CERTIFICATE',
  Credential = 'CREDENTIAL',
  Token = 'TOKEN'
}

export type SecretUnceiledResponseType = AssetBaseResponseInterface & SecretResponseInterface & {
  __typename?: 'SecretUnceiledResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastVersionNumber: Scalars['Int']['output'];
  linkedDevices: PaginatedDeviceResponseType;
  linkedProjects: PaginatedProjectResponseType;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  secretId: Scalars['String']['output'];
  secretType: SecretTypeEnum;
  secretValue: Scalars['String']['output'];
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  vault: VaultResponseType;
  vaultId: Scalars['String']['output'];
  versions: PaginatedSecretVersionUnceiledResponseType;
  weakSecret: Scalars['Boolean']['output'];
};

export type SecretVersionResponseType = {
  __typename?: 'SecretVersionResponseType';
  secretId: Scalars['String']['output'];
  secretValue: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Int']['output'];
};

export type SecretVersionUnceiledResponseType = {
  __typename?: 'SecretVersionUnceiledResponseType';
  secretId: Scalars['String']['output'];
  secretValue: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  versionNumber: Scalars['Int']['output'];
};

export enum ServiceRegion {
  EuWest_1 = 'EU_WEST_1',
  UsEast_1 = 'US_EAST_1',
  UsWest_2 = 'US_WEST_2'
}

export type SessionOwnerType = {
  __typename?: 'SessionOwnerType';
  tenantId: Scalars['String']['output'];
  tenantName?: Maybe<Scalars['String']['output']>;
  userEmail: EmailType;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type SessionRecordingFileType = {
  __typename?: 'SessionRecordingFileType';
  fileDownloadUrl: Scalars['String']['output'];
  fileExtension: Scalars['String']['output'];
  fileKey: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fileUploadUrl: Scalars['String']['output'];
};

export type SessionRecordingType = {
  __typename?: 'SessionRecordingType';
  createdAtTimestampMs?: Maybe<Scalars['Long']['output']>;
  creationUserId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  ideConfigId?: Maybe<Scalars['String']['output']>;
  lastGoodMs?: Maybe<Scalars['Int']['output']>;
  playbackUrl?: Maybe<Scalars['String']['output']>;
  plcVendor?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  sessionRecordingFile?: Maybe<SessionRecordingFileType>;
  sessionRecordingId: Scalars['String']['output'];
  status: RecordingStatus;
  thumbnailKey?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAtTimestampMs?: Maybe<Scalars['Long']['output']>;
};

export type SessionResponseType = {
  __typename?: 'SessionResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  hasRecording: Scalars['Boolean']['output'];
  /** Idle time in seconds before timeout. */
  idleTime: Scalars['Int']['output'];
  instanceId: Scalars['String']['output'];
  /** IDE language code, use the standard IETF language tag format. */
  language?: Maybe<Scalars['String']['output']>;
  meteringReservationId?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  reservationId?: Maybe<Scalars['String']['output']>;
  sessionDurationMs?: Maybe<Scalars['Int']['output']>;
  sessionEndTimestamp?: Maybe<Scalars['String']['output']>;
  /** Deprecated: use session_end_timestamp */
  sessionEndTimestampMs?: Maybe<Scalars['Long']['output']>;
  sessionId: Scalars['String']['output'];
  sessionMetadata?: Maybe<Scalars['JSON']['output']>;
  sessionOwner?: Maybe<SessionOwnerType>;
  sessionStartTimestamp?: Maybe<Scalars['String']['output']>;
  /** Deprecated: use session_start_timestamp */
  sessionStartTimestampMs?: Maybe<Scalars['Long']['output']>;
  sessionType: SessionType;
  sessionVisibility: SessionVisibility;
  status: SessionStatus;
  streamingUrl?: Maybe<Scalars['String']['output']>;
  supportedIdes?: Maybe<Array<Scalars['String']['output']>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  versionId?: Maybe<Scalars['String']['output']>;
  websocketChannel?: Maybe<Scalars['String']['output']>;
};

export enum SessionStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Failed = 'FAILED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  Ready = 'READY',
  WarmPool = 'WARM_POOL'
}

export enum SessionType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export enum SessionVisibility {
  Default = 'DEFAULT',
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SmbConfigurationInput = {
  /** The IP address of the protocol server on the device. */
  ipAddress: Scalars['String']['input'];
  /** The port of the SMB server on the device. Default is 445 (SMB). */
  port?: Scalars['Int']['input'];
  /** The protocol used by the SMB server on the device. */
  protocol?: InputMaybe<SmbProtocolEnum>;
  /** The root directory of the protocol server on the device. If not set, the root directory is assumed to be the home directory of the user. */
  rootDirectory?: InputMaybe<Scalars['String']['input']>;
  /** The secret ID for the protocol server credentials (username and password). */
  secretId?: InputMaybe<Scalars['String']['input']>;
};

export type SmbConfigurationType = {
  __typename?: 'SmbConfigurationType';
  /** The IP address of the protocol server on the device. */
  ipAddress: Scalars['String']['output'];
  /** The port of the SMB server on the device. Default is 445 (SMB). */
  port: Scalars['Int']['output'];
  /** The protocol used by the SMB server on the device. */
  protocol?: Maybe<SmbProtocolEnum>;
  /** The root directory of the protocol server on the device. If not set, the root directory is assumed to be the home directory of the user. */
  rootDirectory?: Maybe<Scalars['String']['output']>;
  /** The secret ID for the protocol server credentials (username and password). */
  secretId?: Maybe<Scalars['String']['output']>;
};

export enum SmbProtocolEnum {
  Smb = 'SMB'
}

export type StartChatInput = {
  message: Scalars['String']['input'];
};

export type StartSessionInput = {
  /** IDE language code, use the standard IETF language tag format. */
  language?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};

export type StartSessionResponseType = {
  __typename?: 'StartSessionResponseType';
  sessionId: Scalars['String']['output'];
  streamingUrl: Scalars['String']['output'];
  websocketChannel: Scalars['String']['output'];
};

export type StartVscodeSessionInput = {
  projectId: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  versionId: Scalars['String']['input'];
};

export type StartVscodeSessionResponse = {
  __typename?: 'StartVscodeSessionResponse';
  launchToken: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
  session: VscodeSession;
};

export type StringFilterIgnoreDdbInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  doNotIgnoreNullable?: InputMaybe<Array<FilterOperatorEnum>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ignoreForDdbQuery?: Scalars['Boolean']['input'];
  in_?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsAny?: InputMaybe<Array<Scalars['String']['input']>>;
  doNotIgnoreNullable?: InputMaybe<Array<FilterOperatorEnum>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in_?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type SyncWeakSecretFlagsResponseType = {
  __typename?: 'SyncWeakSecretFlagsResponseType';
  allSecretsSecure: Scalars['Boolean']['output'];
};

export type TagFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type TagResponseInterface = {
  name: Scalars['String']['output'];
};

export type TagResponseType = AssetBaseResponseInterface & TagResponseInterface & {
  __typename?: 'TagResponseType';
  color?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  devices: PaginatedDeviceResponseType;
  documents: PaginatedDocumentResponseType;
  gateways: PaginatedGatewayResponseType;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  projects: PaginatedProjectResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
};


export type TagResponseTypeDevicesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type TagResponseTypeDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type TagResponseTypeGatewaysArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type TagResponseTypeProjectsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type TagToAssetLinkMetaDataType = {
  __typename?: 'TagToAssetLinkMetaDataType';
  assetVersionId?: Maybe<Scalars['String']['output']>;
};

export type TargetConfigurationInput = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  targetMetadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type TargetConfigurationType = {
  __typename?: 'TargetConfigurationType';
  deviceIds?: Maybe<Array<Scalars['String']['output']>>;
  licenseIds?: Maybe<Array<Scalars['String']['output']>>;
  projectIds?: Maybe<Array<Scalars['String']['output']>>;
  projectVersionIds?: Maybe<Array<Scalars['String']['output']>>;
  targetMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type TargetExecutionStatusResponseType = {
  __typename?: 'TargetExecutionStatusResponseType';
  deviceIds?: Maybe<Array<Scalars['String']['output']>>;
  jobId?: Maybe<Scalars['String']['output']>;
  licenseIds?: Maybe<Array<Scalars['String']['output']>>;
  projectIds?: Maybe<Array<Scalars['String']['output']>>;
  projectVersionIds?: Maybe<Array<Scalars['String']['output']>>;
  status: PipelineExecutionStatusEnum;
  targetMetadata?: Maybe<Scalars['JSON']['output']>;
};

export type TenantResponseType = {
  __typename?: 'TenantResponseType';
  additionalTenants: PaginatedTenantResponseType;
  companyName: Scalars['String']['output'];
  companyNameLower?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customLogo?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  enforceMfa?: Maybe<Scalars['Boolean']['output']>;
  enforceMfaForIdeaas?: Maybe<Scalars['Boolean']['output']>;
  existingUser?: Maybe<Scalars['Boolean']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  featureFlags?: Maybe<Array<FeatureFlagType>>;
  importDemoData?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  manageSsoUsersInSda?: Maybe<Scalars['Boolean']['output']>;
  maxUserRoleExpirationDays?: Maybe<Scalars['Int']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  owner: OwnerUserResponseType;
  ownerId: Scalars['String']['output'];
  ssoEnabled?: Maybe<Scalars['Boolean']['output']>;
  tenantId: Scalars['String']['output'];
  twoFactorAuthMethods?: Maybe<Array<VerificationMethod>>;
  uiPreferences?: Maybe<Scalars['JSON']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  users: PaginatedUserResponseType;
  vendors: Array<VendorResponseType>;
};


export type TenantResponseTypeUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type TenantSubscriptionStatus = {
  __typename?: 'TenantSubscriptionStatus';
  cancellationTs?: Maybe<Scalars['Int']['output']>;
  expirationTs?: Maybe<Scalars['Int']['output']>;
  planType?: Maybe<PlanType>;
};

export type TermsAndConditionsAcceptanceResponseInterface = {
  termsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
};

export type TermsAndConditionsAcceptanceResponseType = TermsAndConditionsAcceptanceResponseInterface & {
  __typename?: 'TermsAndConditionsAcceptanceResponseType';
  accepted: Scalars['Boolean']['output'];
  acceptedTimestamp?: Maybe<Scalars['DateTime']['output']>;
  latestTermsAndConditionsVersion: Scalars['Int']['output'];
  latestTermsAndConditionsVersionAccepted: Scalars['Boolean']['output'];
  superTenantId: Scalars['String']['output'];
  termsAndConditionsVersion?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
};

export type UpdateAssetLinkInput = {
  /** The provided meta data will be merged with the existing meta data of the asset link. */
  metaData?: InputMaybe<AssetMetaDataCombinedInput>;
  /** The object version of the asset link to be updated. This is used for optimistic concurrency control. */
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCustomFieldInput = {
  defaultValue?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  helpText?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<CustomFieldOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeviceBackupLifecycleSettingsInput = {
  /** Device ID for which this retention limit applies */
  deviceId?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  /** Number of backups to retain for this specific device before cleanup */
  retentionLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDeviceInput = {
  connectionConfiguration?: InputMaybe<ConnectionConfigurationUpdateInput>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ftpConfiguration?: InputMaybe<FtpConfigurationInput>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  secretId?: InputMaybe<Scalars['String']['input']>;
  smbConfiguration?: InputMaybe<SmbConfigurationInput>;
};

export type UpdateDocumentInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDocumentVersionInput = {
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGatewayInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  customLocation?: InputMaybe<LocationInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  serviceRegion?: InputMaybe<ServiceRegion>;
};

export type UpdateGitRepositoryInput = {
  linkedProjectId?: InputMaybe<Scalars['String']['input']>;
  /** Current version of the object for optimistic locking. */
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGlobalBackupLifecycleSettingsInput = {
  /** Default number of backups to retain per device before cleanup */
  globalRetentionLimit?: InputMaybe<Scalars['Int']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateHubConfigInput = {
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIntegrationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  integrationType?: InputMaybe<IntegrationTypeEnum>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Integration configuration update. The type is determined by the integration_type field. */
  metaData?: InputMaybe<GitHubIntegrationConfigInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Current version of the object for optimistic locking. */
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<IntegrationStatusEnum>;
};

export type UpdateJobInput = {
  artifactsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dlqPublishedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  featureOptions?: InputMaybe<Scalars['JSON']['input']>;
  finishedTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  ideConfigId?: InputMaybe<Scalars['String']['input']>;
  jobType?: InputMaybe<FeatureEnum>;
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  logGroup?: InputMaybe<Scalars['String']['input']>;
  logStream?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  meteringReservationId?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  pipelineConfigurationId?: InputMaybe<Scalars['String']['input']>;
  pipelineExecutionId?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceRegion?: InputMaybe<ServiceRegion>;
  source?: InputMaybe<JobSourceEnum>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<JobStatusEnum>;
  timeOut?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLicenseInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePipelineConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  licenseIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  steps?: InputMaybe<Array<PipelineStepConfigurationInput>>;
  trigger: PipelineTriggerConfigurationCombinedInput;
};

export type UpdateProjectInput = {
  attachedLicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  secretId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectVersionInput = {
  commitId?: InputMaybe<Scalars['String']['input']>;
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateResourceGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSecretInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  secretType?: InputMaybe<SecretTypeEnum>;
  secretValue?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  vaultId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTenantInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameLower?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  enforceMfa?: InputMaybe<Scalars['Boolean']['input']>;
  enforceMfaForIdeaas?: InputMaybe<Scalars['Boolean']['input']>;
  importDemoData?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  maxUserRoleExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  twoFactorAuthMethods?: InputMaybe<Array<VerificationMethod>>;
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  parentGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  agreeToContact?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  privacyAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  policies?: InputMaybe<Array<PolicyInput>>;
  ssoGroupMapping?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserRoleUserLinkInput = {
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVaultInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWebhookConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<WebhookEventsEnum>;
  gatewayId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
  payloadMapping?: InputMaybe<Scalars['String']['input']>;
  secretId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWorkstationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UserFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterIgnoreDdbInput>;
  source?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type UserGroupFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  parentGroupId?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type UserGroupResponseInterface = {
  groupId: Scalars['String']['output'];
};

export type UserGroupResponseType = IdentBaseResponseInterface & UserGroupResponseInterface & {
  __typename?: 'UserGroupResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupType: ResourceGroupTypeEnum;
  isSystemGroup: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  subGroups: PaginatedUserGroupResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  users: PaginatedUserResponseType;
};


export type UserGroupResponseTypeSubGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type UserGroupResponseTypeUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type UserResponseInterface = {
  userId: Scalars['String']['output'];
};

export type UserResponseType = IdentBaseResponseInterface & UserResponseInterface & {
  __typename?: 'UserResponseType';
  agreeToContact?: Maybe<Scalars['Boolean']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemUser?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastLoginTimestamp?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  privacyAccepted?: Maybe<Scalars['Boolean']['output']>;
  source: UserSourceEnum;
  termsAndConditions: TermsAndConditionsAcceptanceResponseType;
  title?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRoles: PaginatedUserRoleResponseType;
};


export type UserResponseTypeUserRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type UserRoleFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type UserRoleResponseInterface = {
  userRoleId: Scalars['String']['output'];
};

export type UserRoleResponseType = IdentBaseResponseInterface & UserRoleResponseInterface & {
  __typename?: 'UserRoleResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  isSystemRole: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  policies: Array<PolicyType>;
  ssoGroupMapping?: Maybe<Array<Scalars['String']['output']>>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<LightUserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userRoleId: Scalars['String']['output'];
  users: PaginatedUserResponseType;
};


export type UserRoleResponseTypeUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type UserRoleUserLinkResponseType = {
  __typename?: 'UserRoleUserLinkResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  expirationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  userRoleId: Scalars['String']['output'];
};

export enum UserSourceEnum {
  Saml = 'SAML',
  Sda = 'SDA',
  Unknown = 'UNKNOWN'
}

export type UserUiPreferencesResponseType = {
  __typename?: 'UserUiPreferencesResponseType';
  uiPreferences?: Maybe<Scalars['JSON']['output']>;
};

export type VaultFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type VaultResponseInterface = {
  vaultId: Scalars['String']['output'];
};

export type VaultResponseType = AssetBaseResponseInterface & VaultResponseInterface & {
  __typename?: 'VaultResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  secrets: PaginatedSecretResponseType;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  vaultId: Scalars['String']['output'];
};


export type VaultResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type VaultResponseTypeSecretsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type VendorResponseType = {
  __typename?: 'VendorResponseType';
  ides?: Maybe<Array<IdeConfigResponseType>>;
  licenseConfig?: Maybe<LicenseConfigType>;
  name: Scalars['String']['output'];
  requiredFeatureFlag?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
};

export enum VerificationMethod {
  Email = 'EMAIL',
  Mfa = 'MFA',
  Unknown = 'UNKNOWN'
}

export type VerifyTotpTwoFactorAuthInput = {
  challenge: Scalars['String']['input'];
};

export enum VpnStateEnum {
  Authenticated = 'AUTHENTICATED',
  Connected = 'CONNECTED',
  Connecting = 'CONNECTING',
  Disconnected = 'DISCONNECTED',
  Refused = 'REFUSED',
  Unknown = 'UNKNOWN'
}

export type VscodeSession = {
  __typename?: 'VscodeSession';
  instanceId?: Maybe<Scalars['String']['output']>;
  lastHeartbeatAt?: Maybe<Scalars['DateTime']['output']>;
  projectId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  state: VscodeSessionState;
  tenantId: Scalars['String']['output'];
  terminatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  versionId: Scalars['String']['output'];
};

export enum VscodeSessionState {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY',
  TimedOut = 'TIMED_OUT'
}

export type WebhookConfigurationFilterInput = {
  gatewayId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  secretId?: InputMaybe<StringFilterInput>;
};

export type WebhookConfigurationResponseType = BaseResponseInterface & {
  __typename?: 'WebhookConfigurationResponseType';
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destinationUrl: Scalars['String']['output'];
  event: WebhookEventsEnum;
  gatewayId: Scalars['String']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameLower?: Maybe<Scalars['String']['output']>;
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  payloadMapping: Scalars['String']['output'];
  secretId?: Maybe<Scalars['String']['output']>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  webhookConfigurationId: Scalars['String']['output'];
};

export enum WebhookEventsEnum {
  DeviceCreated = 'DEVICE_CREATED',
  DeviceDeleted = 'DEVICE_DELETED',
  DeviceUpdated = 'DEVICE_UPDATED',
  ProjectVersionCreated = 'PROJECT_VERSION_CREATED',
  ProjectVersionDeleted = 'PROJECT_VERSION_DELETED',
  ProjectVersionUpdated = 'PROJECT_VERSION_UPDATED'
}

export type WindowsAttrsType = {
  __typename?: 'WindowsAttrsType';
  compositionEditionId?: Maybe<Scalars['String']['output']>;
  currentBuild?: Maybe<Scalars['String']['output']>;
  currentVersion?: Maybe<Scalars['String']['output']>;
  displayVersion?: Maybe<Scalars['String']['output']>;
  editionId?: Maybe<Scalars['String']['output']>;
  installationType?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  registeredOrganization?: Maybe<Scalars['String']['output']>;
  registeredOwner?: Maybe<Scalars['String']['output']>;
  winreVersion?: Maybe<Scalars['String']['output']>;
};

export type WindowsAttrsTypeLinuxAttrsType = LinuxAttrsType | WindowsAttrsType;

export type WorkstationConnectionType = {
  __typename?: 'WorkstationConnectionType';
  connectionId: Scalars['String']['output'];
  deviceConnectivity?: Maybe<DeviceConnectivityStatusReportType>;
  deviceId: Scalars['String']['output'];
  gatewayId?: Maybe<Scalars['String']['output']>;
  gatewayState?: Maybe<GatewayStateResponseType>;
  gatewayVpnState?: Maybe<VpnStateEnum>;
  lastConnectAt?: Maybe<Scalars['DateTime']['output']>;
  lastDisconnectAt?: Maybe<Scalars['DateTime']['output']>;
  status: ConnectionStatusEnum;
  statusReason?: Maybe<ConnectionStatusReasonEnum>;
  user?: Maybe<UserResponseType>;
  userId?: Maybe<Scalars['String']['output']>;
  vpnAccumulatedDurationSeconds: Scalars['Int']['output'];
  workstationId: Scalars['String']['output'];
  workstationState?: Maybe<WorkstationStateResponseType>;
  workstationVpnState: VpnStateEnum;
};

export type WorkstationDeviceConnectionType = {
  __typename?: 'WorkstationDeviceConnectionType';
  connectionId: Scalars['String']['output'];
  connectionReason?: Maybe<Scalars['String']['output']>;
  connectionState: ConnectionState;
  connectionType: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceStatus?: Maybe<ConnectionNodeStatus>;
  gatewayId?: Maybe<Scalars['String']['output']>;
  gatewayStatus?: Maybe<ConnectionNodeStatus>;
  serverId?: Maybe<Scalars['String']['output']>;
  serverStatus?: Maybe<ConnectionNodeStatus>;
  workstationId: Scalars['String']['output'];
  workstationStatus?: Maybe<ConnectionNodeStatus>;
};

export type WorkstationDeviceConnectionV2Type = {
  __typename?: 'WorkstationDeviceConnectionV2Type';
  connectionId: Scalars['String']['output'];
  connectionState?: Maybe<ConnectionV2State>;
  deviceId: Scalars['String']['output'];
  gatewayId?: Maybe<Scalars['String']['output']>;
  workstationId: Scalars['String']['output'];
};

export type WorkstationFilterInput = {
  creationTimestamp?: InputMaybe<StringFilterInput>;
  groupId?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  nameLower?: InputMaybe<StringFilterInput>;
  tag?: InputMaybe<StringFilterIgnoreDdbInput>;
  updateTimestamp?: InputMaybe<StringFilterInput>;
};

export type WorkstationMetadataResponseType = {
  __typename?: 'WorkstationMetadataResponseType';
  architecture: ArchEnum;
  isOutdated?: Maybe<Scalars['Boolean']['output']>;
  isOutdatedForMajor?: Maybe<Scalars['Boolean']['output']>;
  latestVersion?: Maybe<Scalars['String']['output']>;
  latestVersionForMajor?: Maybe<Scalars['String']['output']>;
  numCpu?: Maybe<Scalars['Int']['output']>;
  operatingSystem: OperatingSystemEnum;
  operatingSystemAttrs?: Maybe<WindowsAttrsTypeLinuxAttrsType>;
  reportedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type WorkstationPublicIpResponseType = {
  __typename?: 'WorkstationPublicIpResponseType';
  publicIp: Scalars['String']['output'];
  publicIpLocation?: Maybe<LocationType>;
  reportedAt: Scalars['DateTime']['output'];
};

export type WorkstationResponseType = AssetBaseResponseInterface & {
  __typename?: 'WorkstationResponseType';
  connections: PaginatedWorkstationConnectionResponseType;
  /** Date and time when this object was first created (ISO 8601 format) */
  creationTimestamp?: Maybe<Scalars['DateTime']['output']>;
  creationUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who created this object */
  creationUserId?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier of the user who deleted this object */
  deleteUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated (CONN-123): use the connections field / readWorkstationConnections instead. */
  deviceConnections: PaginatedWorkstationDeviceConnectionStatusResponseType;
  group?: Maybe<ResourceGroupResponseType>;
  groupId?: Maybe<Scalars['String']['output']>;
  linkedTags: PaginatedTagResponseType;
  lock?: Maybe<LockResponseType>;
  metadata?: Maybe<WorkstationMetadataResponseType>;
  name: Scalars['String']['output'];
  /** Version number of the object, used for optimistic locking and change tracking */
  objectVersion?: Maybe<Scalars['Int']['output']>;
  publicIp?: Maybe<WorkstationPublicIpResponseType>;
  setupCommands?: Maybe<WorkstationSetupResponseType>;
  state?: Maybe<WorkstationStateResponseType>;
  /** Date and time when this object was last modified (ISO 8601 format) */
  updateTimestamp?: Maybe<Scalars['DateTime']['output']>;
  updateUser?: Maybe<UserResponseType>;
  /** Unique identifier of the user who last updated this object */
  updateUserId?: Maybe<Scalars['String']['output']>;
  workstationId: Scalars['String']['output'];
};


export type WorkstationResponseTypeLinkedTagsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type WorkstationSetupResponseType = {
  __typename?: 'WorkstationSetupResponseType';
  expiresAt: Scalars['DateTime']['output'];
  osCommands: Array<WorkstationSetupType>;
};

export type WorkstationSetupType = {
  __typename?: 'WorkstationSetupType';
  configurationCommand: Scalars['String']['output'];
  installationCommand: Scalars['String']['output'];
  osName: Scalars['String']['output'];
  osType: OperatingSystemEnum;
};

export enum WorkstationStateEnum {
  NotConfigured = 'NOT_CONFIGURED',
  Offline = 'OFFLINE',
  Online = 'ONLINE'
}

export type WorkstationStateResponseType = {
  __typename?: 'WorkstationStateResponseType';
  reportedAt: Scalars['DateTime']['output'];
  state: WorkstationStateEnum;
};

export type DeviceSyncStatusFragment = { __typename?: 'DeviceSyncStatusResponseType', previousSyncStatus?: DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: DeviceSyncTypeEnum, targetSyncStatus?: DeviceSyncStatusEnum, syncJobId?: string };

export type DeviceFragment = { __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
        | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } };

export type LinkedProjectFromDeviceFragment = { __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
    | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
    | { __typename?: 'ProjectToProjectLinkMetaDataType' }
  , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } };

export type ProjectToDeviceLinkMetaDataFragment = { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string };

export type DeviceConnectivityStatusFragment = { __typename?: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: DeviceInterfaceStatusEnum, devicePingStatus?: PingStatusEnum, deviceNetcatStatus?: NetcatStatusEnum, ftpStatus?: DeviceInterfaceStatusEnum, ftpPingStatus?: PingStatusEnum, ftpNetcatStatus?: NetcatStatusEnum, smbStatus?: DeviceInterfaceStatusEnum, smbPingStatus?: PingStatusEnum, smbNetcatStatus?: NetcatStatusEnum };

export type AccumulatedDeviceSyncStatusFragment = { __typename?: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: DeviceSyncStatusEnum, previousSyncStatus: DeviceSyncStatusEnum, details: Array<{ __typename?: 'DeviceSyncStatusResponseType', previousSyncStatus?: DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: DeviceSyncTypeEnum, targetSyncStatus?: DeviceSyncStatusEnum, syncJobId?: string }> };

export type DeviceFirmwareInformationDetailFragment = { __typename?: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string };

export type DeviceFirmwareInformationFragment = { __typename?: 'DeviceFirmwareInformationResponseType', readTimestamp?: any, details: Array<{ __typename?: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string }> };

export type CreateDeviceMutationVariables = Exact<{
  device: CreateDeviceInput;
}>;


export type CreateDeviceMutation = { __typename?: 'Mutation', createDevice: { __typename?: 'DeviceResponseType', deviceId: string, groupId?: string } };

export type UpdateDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  device: UpdateDeviceInput;
}>;


export type UpdateDeviceMutation = { __typename?: 'Mutation', updateDevice: { __typename: 'DeviceResponseType', groupId?: string, deviceId: string } };

export type DeleteDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type DeleteDeviceMutation = { __typename?: 'Mutation', deleteDevice: { __typename: 'DeviceResponseType', groupId?: string, deviceId: string } };

export type ReadAllDevicesQueryVariables = Exact<{
  filter?: InputMaybe<DeviceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllDevicesQuery = { __typename?: 'Query', readAllDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename?: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDevicesByIdsQueryVariables = Exact<{
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadDevicesByIdsQuery = { __typename?: 'Query', readDevicesByIds: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename?: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDeviceQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ReadDeviceQuery = { __typename?: 'Query', readDevice: { __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
          | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
          | { __typename?: 'ProjectToProjectLinkMetaDataType' }
        , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
            | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
            | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
           }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } } };

export type ReadLinkedProjectsForDeviceQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedProjectsForDeviceQuery = { __typename?: 'Query', readLinkedProjectsForDevice: { __typename?: 'PaginatedProjectResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
        | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadDeviceSyncStatusQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ReadDeviceSyncStatusQuery = { __typename?: 'Query', readDevice: { __typename?: 'DeviceResponseType', accumulatedSyncStatus: { __typename?: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: DeviceSyncStatusEnum, previousSyncStatus: DeviceSyncStatusEnum, details: Array<{ __typename?: 'DeviceSyncStatusResponseType', previousSyncStatus?: DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: DeviceSyncTypeEnum, targetSyncStatus?: DeviceSyncStatusEnum, syncJobId?: string }> } } };

export type ReadDeviceNamesForRoleRowQueryVariables = Exact<{
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadDeviceNamesForRoleRowQuery = { __typename?: 'Query', readDevicesByIds: { __typename?: 'PaginatedDeviceResponseType', items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> } };

export type ReadDeviceConnectivityStatusQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ReadDeviceConnectivityStatusQuery = { __typename?: 'Query', readDeviceConnectivityStatus: { __typename?: 'DeviceConnectivityStatusType', deviceId: string, primaryGateway?: { __typename?: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: DeviceInterfaceStatusEnum, devicePingStatus?: PingStatusEnum, deviceNetcatStatus?: NetcatStatusEnum, ftpStatus?: DeviceInterfaceStatusEnum, ftpPingStatus?: PingStatusEnum, ftpNetcatStatus?: NetcatStatusEnum, smbStatus?: DeviceInterfaceStatusEnum, smbPingStatus?: PingStatusEnum, smbNetcatStatus?: NetcatStatusEnum }, allGateways: Array<{ __typename?: 'DeviceConnectivityStatusReportType', gatewayId: string, reportedAt: any, deviceStatus: DeviceInterfaceStatusEnum, devicePingStatus?: PingStatusEnum, deviceNetcatStatus?: NetcatStatusEnum, ftpStatus?: DeviceInterfaceStatusEnum, ftpPingStatus?: PingStatusEnum, ftpNetcatStatus?: NetcatStatusEnum, smbStatus?: DeviceInterfaceStatusEnum, smbPingStatus?: PingStatusEnum, smbNetcatStatus?: NetcatStatusEnum }> } };

export type ReadDeviceFirmwareInformationQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ReadDeviceFirmwareInformationQuery = { __typename?: 'Query', readDevice: { __typename?: 'DeviceResponseType', firmwareInformation?: { __typename?: 'DeviceFirmwareInformationResponseType', readTimestamp?: any, details: Array<{ __typename?: 'DeviceFirmwareInformationDataType', deviceName: string, deviceType: string, articleNumber: string, firmwareVersion: string, slot?: string, configuration?: string, serialNumber?: string, hardwareVersion?: string }> } } };

export type DocumentFragment = { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type DocumentVersionFragment = { __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } };

export type DocumentLinkedToAssetResponseFragment = { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type LinkedAssetFromDocumentFragment = { __typename?: 'AssetLinkResponseType', destinationId: string, destinationType: AssetTypeEnum, metaData:
    | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
    | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
    | { __typename?: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
    | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
    | { __typename?: 'ProjectToProjectLinkMetaDataType' }
    | { __typename?: 'TagToAssetLinkMetaDataType' }
   };

export type CompleteDocumentMultipartUploadMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  completeUploadInput: CompleteMultipartUploadInput;
  versionId: Scalars['String']['input'];
}>;


export type CompleteDocumentMultipartUploadMutation = { __typename?: 'Mutation', completeDocumentVersionMultipartUpload?: any };

export type CreateDocumentMutationVariables = Exact<{
  document: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'CreateDocumentResponseType', documentId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename?: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CreateDocumentVersionMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentVersion: CreateDocumentVersionInput;
}>;


export type CreateDocumentVersionMutation = { __typename?: 'Mutation', createDocumentVersion: { __typename?: 'DocumentVersionUploadURLResponseType', documentId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename?: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type DeleteDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: { __typename?: 'DocumentResponseType', documentId: string } };

export type UpdateDocumentMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  document: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } } };

export type UpdateDocumentVersionMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  documentVersion: UpdateDocumentVersionInput;
}>;


export type UpdateDocumentVersionMutation = { __typename?: 'Mutation', updateDocumentVersion: { __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } } };

export type DownloadDocumentVersionQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type DownloadDocumentVersionQuery = { __typename?: 'Query', downloadDocumentVersion: { __typename?: 'DocumentVersionDownloadURLResponseType', downloadUrl: string } };

export type ReadDocumentsByIdsQueryVariables = Exact<{
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadDocumentsByIdsQuery = { __typename?: 'Query', readDocumentsByIds: { __typename?: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadDocumentQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type ReadDocumentQuery = { __typename?: 'Query', readDocument: { __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } } };

export type ReadAllDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<DocumentFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllDocumentsQuery = { __typename?: 'Query', readAllDocuments: { __typename?: 'PaginatedDocumentResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadLinkedDocumentsForAssetQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedDocumentsForAssetQuery = { __typename?: 'Query', readLinkedDocumentsForAsset: { __typename?: 'PaginatedDocumentResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DocumentResponseType', documentId: string, name: string, groupId?: string, documentType: DocumentTypeEnum, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedDocumentVersionResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } }> } };

export type ReadLinkedAssetsFromDocumentQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<AssetLinkFilterInput>;
}>;


export type ReadLinkedAssetsFromDocumentQuery = { __typename?: 'Query', readAllAssetLinksFromAsset: { __typename?: 'PaginatedAssetLinkResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'AssetLinkResponseType', destinationId: string, destinationType: AssetTypeEnum, metaData:
        | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
        | { __typename?: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
        | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename?: 'ProjectToProjectLinkMetaDataType' }
        | { __typename?: 'TagToAssetLinkMetaDataType' }
       }> } };

export type ReadVersionsForDocumentQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  filter?: InputMaybe<DocumentVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadVersionsForDocumentQuery = { __typename?: 'Query', readDocumentVersionsForDocument: { __typename?: 'PaginatedDocumentVersionResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'DocumentVersionResponseType', versionNumber: number, documentId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, documentFile: { __typename?: 'DocumentVersionFileType', fileName: string, fileExtension: string, fileSize: any } }> } };

export type ReadDocumentNamesForRoleRowQueryVariables = Exact<{
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadDocumentNamesForRoleRowQuery = { __typename?: 'Query', readDocumentsByIds: { __typename?: 'PaginatedDocumentResponseType', items: Array<{ __typename?: 'DocumentResponseType', name: string, documentId: string }> } };

export type AssetUserInfoFragment = { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean };

export type GatewayFragment = { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
      | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
      | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
     }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } };

export type GatewaySetupTypeFragment = { __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum };

export type GatewaySetupCommandFragment = { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> };

export type GatewayMetadataFragment = { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
    | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
    | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
   };

export type GatewayPublicIpFragment = { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string };

export type GatewayLinkedToDeviceFragment = { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
      | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
      | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
     }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } };

export type GatewayConfigFragment = { __typename?: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename?: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } };

export type SyncedDeviceFragment = { __typename?: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, name: string, vendorId: string, accumulatedSyncStatus: { __typename?: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: DeviceSyncStatusEnum, previousSyncStatus: DeviceSyncStatusEnum, details: Array<{ __typename?: 'DeviceSyncStatusResponseType', previousSyncStatus?: DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: DeviceSyncTypeEnum, targetSyncStatus?: DeviceSyncStatusEnum, syncJobId?: string }> } };

export type DeleteGatewayMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type DeleteGatewayMutation = { __typename?: 'Mutation', deleteGateway: { __typename?: 'GatewayResponseType', groupId?: string, gatewayId: string } };

export type CreateGatewayMutationVariables = Exact<{
  gateway: CreateGatewayInput;
}>;


export type CreateGatewayMutation = { __typename?: 'Mutation', createGateway: { __typename?: 'GatewayResponseType', groupId?: string, gatewayId: string, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, city?: string, state?: string, country?: string } } };

export type UpdateGatewayMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  gateway: UpdateGatewayInput;
}>;


export type UpdateGatewayMutation = { __typename?: 'Mutation', updateGateway: { __typename?: 'GatewayResponseType', gatewayId: string, groupId?: string, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, city?: string, state?: string, country?: string } } };

export type UpdateGatewayConfigMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  config: GatewayConfigUpdateInput;
}>;


export type UpdateGatewayConfigMutation = { __typename?: 'Mutation', updateGatewayConfig: { __typename?: 'GatewayConfigResponseType', objectVersion?: number } };

export type RequestGatewayUpdateMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type RequestGatewayUpdateMutation = { __typename?: 'Mutation', requestGatewayUpdate: { __typename?: 'GatewayUpdateRequestType', requestedAt: any, version: string } };

export type ReadAllGatewaysQueryVariables = Exact<{
  filter?: InputMaybe<GatewayFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllGatewaysQuery = { __typename?: 'Query', readAllGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> } };

export type ReadLinkedDevicesForGatewayQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedDevicesForGatewayQuery = { __typename?: 'Query', readLinkedDevicesForGateway: { __typename?: 'PaginatedDeviceResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename?: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadGatewaysByIdsQueryVariables = Exact<{
  gatewayIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGatewaysByIdsQuery = { __typename?: 'Query', readGatewaysByIds: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
          | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
          | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
         }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> } };

export type ReadGatewayQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type ReadGatewayQuery = { __typename?: 'Query', readGateway: { __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
        | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
        | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
       }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } } };

export type ReadGatewayHealthStatusQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type ReadGatewayHealthStatusQuery = { __typename?: 'Query', readGatewayState?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum } };

export type ReadGatewaysHealthStatusQueryVariables = Exact<{
  gatewayIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGatewaysHealthStatusQuery = { __typename?: 'Query', readGatewaysByIds: { __typename?: 'PaginatedGatewayResponseType', items: Array<{ __typename?: 'GatewayResponseType', gatewayId: string, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum } }> } };

export type ReadGatewayNamesForRoleRowQueryVariables = Exact<{
  gatewayIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGatewayNamesForRoleRowQuery = { __typename?: 'Query', readGatewaysByIds: { __typename?: 'PaginatedGatewayResponseType', items: Array<{ __typename?: 'GatewayResponseType', name: string, gatewayId: string }> } };

export type ReadGatewayConfigQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type ReadGatewayConfigQuery = { __typename?: 'Query', readGatewayConfigReported?: { __typename?: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename?: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } }, readGatewayConfigDesired?: { __typename?: 'GatewayConfigResponseType', objectVersion?: number, reportedAt?: any, requestedAt?: any, values: { __typename?: 'GlueConfigType', metaVersion: number, sslTunnel?: boolean, sslTunnelInsecure?: boolean, updateAuto?: boolean, updateUnstable?: boolean, webuiBase?: string, webuiEnabled?: boolean, webuiPort?: number } } };

export type ReadGatewayUpdateStatusQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type ReadGatewayUpdateStatusQuery = { __typename?: 'Query', readGateway: { __typename?: 'GatewayResponseType', metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, isOutdated?: boolean }, updateRequest?: { __typename?: 'GatewayUpdateRequestType', requestedAt: any, version: string } } };

export type ReadGatewaySetupQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
}>;


export type ReadGatewaySetupQuery = { __typename?: 'Query', readGatewaySetup?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, byMajor: Array<{ __typename?: 'GatewaySetupByMajorType', major: string, osCommands: Array<{ __typename?: 'GatewaySetupType', osType: OperatingSystemEnum, osName: string, installationCommand: string, configurationCommand: string }> }> } };

export type ReadDevicesSyncStatusByGatewayQueryVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadDevicesSyncStatusByGatewayQuery = { __typename?: 'Query', readLinkedDevicesForGateway: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, name: string, vendorId: string, accumulatedSyncStatus: { __typename?: 'AccumulatedDeviceSyncStatusResponseType', syncTimestamp?: any, targetSyncStatus: DeviceSyncStatusEnum, previousSyncStatus: DeviceSyncStatusEnum, details: Array<{ __typename?: 'DeviceSyncStatusResponseType', previousSyncStatus?: DeviceSyncStatusEnum, syncErrorMessage?: string, syncTimestamp?: any, syncType: DeviceSyncTypeEnum, targetSyncStatus?: DeviceSyncStatusEnum, syncJobId?: string }> } }> } };

export type SearchAddressQueryVariables = Exact<{
  text: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAddressQuery = { __typename?: 'Query', searchAddress: Array<{ __typename?: 'AddressSuggestionType', label: string, placeId?: string, location: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, city?: string, state?: string, country?: string } }> };

export type ReverseGeocodeQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type ReverseGeocodeQuery = { __typename?: 'Query', reverseGeocode?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, city?: string, state?: string, country?: string } };

export type ResourceSubGroupFragment = { __typename: 'ResourceGroupResponseType', groupId: string, objectVersion?: number, name: string };

export type GroupTreeItemFragment = { __typename: 'ResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } };

export type SubGroupFragment = { __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any };

export type ResourceGroupFragment = { __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } };

export type ResourceGroupParentChildPairFragment = { __typename?: 'ResourceGroupForPermissionResponseType', groupId: string, parentGroupId?: string };

export type DeleteResourceGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type DeleteResourceGroupMutation = { __typename?: 'Mutation', deleteResourceGroup: { __typename?: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type CreateResourceGroupMutationVariables = Exact<{
  resourceGroup: CreateResourceGroupInput;
}>;


export type CreateResourceGroupMutation = { __typename?: 'Mutation', createResourceGroup: { __typename?: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type UpdateResourceGroupMutationVariables = Exact<{
  groupId: Scalars['String']['input'];
  resourceGroup: UpdateResourceGroupInput;
}>;


export type UpdateResourceGroupMutation = { __typename?: 'Mutation', updateResourceGroup: { __typename?: 'ResourceGroupResponseType', groupId: string, parentGroupId?: string } };

export type ReadResourceGroupByIdQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadResourceGroupByIdQuery = { __typename?: 'Query', readResourceGroup: { __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }, readSubGroupsForResourceGroup: { __typename?: 'PaginatedResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadResourceGroupsToBuildTreeQueryVariables = Exact<{
  filter?: InputMaybe<ResourceGroupFilterInput>;
}>;


export type ReadResourceGroupsToBuildTreeQuery = { __typename?: 'Query', readAllResourceGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', groupId: string, name: string, parentGroupId?: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadAllResourceGroupsQueryVariables = Exact<{
  filter?: InputMaybe<ResourceGroupFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  isRoot?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ReadAllResourceGroupsQuery = { __typename?: 'Query', readAllResourceGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadSubGroupsForResourceGroupQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadSubGroupsForResourceGroupQuery = { __typename?: 'Query', readSubGroupsForResourceGroup: { __typename?: 'PaginatedResourceGroupResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ResourceGroupResponseType', updateTimestamp?: any, creationTimestamp?: any, name: string, parentGroupId?: string, groupId: string, objectVersion?: number, fullPaths: Array<string>, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, subGroups: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'ResourceGroupResponseType', name: string, groupId: string, creationTimestamp?: any, updateTimestamp?: any }> }, groupDevicesSyncStatus: { __typename?: 'ResourceGroupDevicesSyncStatusType', groupSyncStatus: DeviceSyncStatusEnum, devicesSyncStatus: Array<{ __typename?: 'GroupDeviceSyncStatusType', deviceName: string, deviceId: string, syncStatus: DeviceSyncStatusEnum, syncStatusTimestamp?: any, groupId?: string }> } }> } };

export type ReadResourceGroupNamesForRoleRowQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadResourceGroupNamesForRoleRowQuery = { __typename?: 'Query', readResourceGroupsByIds: { __typename?: 'PaginatedResourceGroupResponseType', items: Array<{ __typename?: 'ResourceGroupResponseType', name: string, groupId: string }> } };

export type ReadResourceGroupNameByIdQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadResourceGroupNameByIdQuery = { __typename?: 'Query', readResourceGroup: { __typename?: 'ResourceGroupResponseType', name: string, parentGroupId?: string, fullPaths: Array<string> } };

export type ReadAllResourceGroupsWithoutPermissionChecksQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAllResourceGroupsWithoutPermissionChecksQuery = { __typename?: 'Query', readAllResourceGroupsForPermissions: Array<{ __typename?: 'ResourceGroupForPermissionResponseType', groupId: string, parentGroupId?: string }> };

export type ReadGroupedAssetsCountQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadGroupedAssetsCountQuery = { __typename?: 'Query', readAllDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, readAllProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, readAllGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number }, readAllDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, readAllVaults: { __typename?: 'PaginatedVaultResponseType', itemCount: number }, readAllLicenses: { __typename?: 'PaginatedLicenseResponseType', itemCount: number }, readSubGroupsForResourceGroup: { __typename?: 'PaginatedResourceGroupResponseType', itemCount: number } };

export type ReadUngroupedAssetsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUngroupedAssetsCountQuery = { __typename?: 'Query', readAllDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, readAllProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, readAllGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number }, readAllDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, readAllVaults: { __typename?: 'PaginatedVaultResponseType', itemCount: number }, readAllLicenses: { __typename?: 'PaginatedLicenseResponseType', itemCount: number } };

export type ReadGroupedAssetCountsQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGroupedAssetCountsQuery = { __typename?: 'Query', readGroupedAssetCounts: Array<{ __typename?: 'GroupedAssetCountResponseType', groupId: string, devices: number, projects: number, gateways: number, documents: number, vaults: number, licenses: number, subGroups: number }> };

export type LicenseFragment = { __typename: 'LicenseResponseType', name?: string, groupId?: string, licenseId: string, objectVersion?: number, product: string, productKey?: string, quantity: number, serialId: string, status: LicenseStatusEnum, type: LicenseTypeEnum, ideConfigId?: string, updateTimestamp?: any, creationTimestamp?: any, family?: string, vendorId: string, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type CreateLicenseMutationVariables = Exact<{
  license: CreateLicenseInput;
}>;


export type CreateLicenseMutation = { __typename?: 'Mutation', createLicense: { __typename?: 'CreateLicenseResponseType', uploadId: string, licenseId: string, uploadUrls: Array<{ __typename?: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CompleteLicenseMultipartUploadMutationVariables = Exact<{
  licenseId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  completeUploadInput: CompleteMultipartUploadInput;
}>;


export type CompleteLicenseMultipartUploadMutation = { __typename?: 'Mutation', completeLicenseMultipartUpload?: any };

export type DeleteLicenseMutationVariables = Exact<{
  licenseId: Scalars['String']['input'];
}>;


export type DeleteLicenseMutation = { __typename?: 'Mutation', deleteLicense: { __typename?: 'LicenseResponseType', licenseId: string, groupId?: string } };

export type UpdateLicenseMutationVariables = Exact<{
  licenseId: Scalars['String']['input'];
  license: UpdateLicenseInput;
}>;


export type UpdateLicenseMutation = { __typename?: 'Mutation', updateLicense: { __typename?: 'LicenseResponseType', licenseId: string } };

export type ReadAllLicensesQueryVariables = Exact<{
  filter?: InputMaybe<LicenseFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllLicensesQuery = { __typename?: 'Query', readAllLicenses: { __typename?: 'PaginatedLicenseResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'LicenseResponseType', name?: string, groupId?: string, licenseId: string, objectVersion?: number, product: string, productKey?: string, quantity: number, serialId: string, status: LicenseStatusEnum, type: LicenseTypeEnum, ideConfigId?: string, updateTimestamp?: any, creationTimestamp?: any, family?: string, vendorId: string, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type DownloadLicenseQueryVariables = Exact<{
  licenseId: Scalars['String']['input'];
}>;


export type DownloadLicenseQuery = { __typename?: 'Query', downloadLicense: { __typename?: 'LicenseDownloadURLResponseType', downloadUrl?: string } };

export type ReadLicenseNamesForRoleRowQueryVariables = Exact<{
  licenseIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadLicenseNamesForRoleRowQuery = { __typename?: 'Query', readLicensesByIds: { __typename?: 'PaginatedLicenseResponseType', items: Array<{ __typename?: 'LicenseResponseType', name?: string, licenseId: string }> } };

export type DeleteAssetLinkMutationVariables = Exact<{
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
}>;


export type DeleteAssetLinkMutation = { __typename?: 'Mutation', deleteAssetLink: { __typename?: 'AssetLinkResponseType', destinationId: string, destinationType: AssetTypeEnum, sourceId: string, sourceType: AssetTypeEnum } };

export type LinkDocumentToAssetMutationVariables = Exact<{
  documentId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  assetId: Scalars['String']['input'];
  assetVersionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkDocumentToAssetMutation = { __typename?: 'Mutation', createAssetLink: { __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename?: 'DocumentToAssetLinkMetaDataType', assetVersionId?: string }
      | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
      | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      | { __typename?: 'TagToAssetLinkMetaDataType' }
     } };

export type LinkLibraryToProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  libraryId: Scalars['String']['input'];
}>;


export type LinkLibraryToProjectMutation = { __typename?: 'Mutation', createAssetLink: { __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string } };

export type LinkDeviceToProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  metaData?: InputMaybe<AssetMetaDataCombinedInput>;
}>;


export type LinkDeviceToProjectMutation = { __typename?: 'Mutation', createAssetLink: { __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename?: 'DocumentToAssetLinkMetaDataType' }
      | { __typename?: 'ProjectToDeviceLinkMetaDataType', deviceIpAddress?: string, deviceName?: string, deviceSubnet?: string, deviceType?: string, targetProjectVersionId?: string }
      | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      | { __typename?: 'TagToAssetLinkMetaDataType' }
     } };

export type UpdateDeviceToProjectLinkMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  input: UpdateAssetLinkInput;
}>;


export type UpdateDeviceToProjectLinkMutation = { __typename?: 'Mutation', updateAssetLink: { __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
      | { __typename?: 'DocumentToAssetLinkMetaDataType' }
      | { __typename?: 'ProjectToDeviceLinkMetaDataType', deviceIpAddress?: string, deviceName?: string, deviceSubnet?: string, deviceType?: string, targetProjectVersionId?: string }
      | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      | { __typename?: 'TagToAssetLinkMetaDataType' }
     } };

export type LinkDeviceToGatewayMutationVariables = Exact<{
  gatewayId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LinkDeviceToGatewayMutation = { __typename?: 'Mutation', createAssetLink: { __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
      | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
      | { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }
      | { __typename?: 'DocumentToAssetLinkMetaDataType' }
      | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
      | { __typename?: 'ProjectToProjectLinkMetaDataType' }
      | { __typename?: 'TagToAssetLinkMetaDataType' }
     } };

export type DefineGatewayLinksToDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  input: Array<DefineAssetLinkFromAssetInput> | DefineAssetLinkFromAssetInput;
}>;


export type DefineGatewayLinksToDeviceMutation = { __typename?: 'Mutation', defineAssetLinksFromAsset: { __typename?: 'PaginatedAssetLinkResponseType', itemCount: number, items: Array<{ __typename?: 'AssetLinkResponseType', sourceId: string, destinationId: string, metaData:
        | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }
        | { __typename?: 'DocumentToAssetLinkMetaDataType' }
        | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename?: 'ProjectToProjectLinkMetaDataType' }
        | { __typename?: 'TagToAssetLinkMetaDataType' }
       }> } };

export type ReadAssetLinkQueryVariables = Exact<{
  destinationId: Scalars['String']['input'];
  destinationType: AssetTypeEnum;
  sourceId: Scalars['String']['input'];
  sourceType: AssetTypeEnum;
}>;


export type ReadAssetLinkQuery = { __typename?: 'Query', readAssetLink: { __typename?: 'AssetLinkResponseType', objectVersion?: number } };

export type LockFragment = { __typename?: 'LockResponseType', service: string, creationTimestamp?: any, message?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type CreateLockMutationVariables = Exact<{
  lock: CreateLockInput;
}>;


export type CreateLockMutation = { __typename?: 'Mutation', createLock: { __typename?: 'LockResponseType', resourceId: string, resourceType: string } };

export type DeleteLockMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
  assetType: Scalars['String']['input'];
}>;


export type DeleteLockMutation = { __typename?: 'Mutation', deleteLock: { __typename?: 'LockResponseType', resourceId: string, resourceType: string } };

export type ReadLockQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
  assetType: Scalars['String']['input'];
}>;


export type ReadLockQuery = { __typename?: 'Query', readLock?: { __typename?: 'LockResponseType', service: string, creationTimestamp?: any, message?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ProjectFragment = { __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } };

export type LinkedLibraryFragment = { __typename: 'ProjectResponseType', updateTimestamp?: any, objectVersion?: number, projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, secretId?: string, linkMetaData?:
    | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
    | { __typename?: 'ProjectToProjectLinkMetaDataType', destinationVersionId?: string, sourceVersionId?: string }
  , linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> } };

export type DeviceInformationFragment = { __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> };

export type ProjectVersionFragment = { __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> };

export type CreateProjectMutationVariables = Exact<{
  project: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'CreateProjectResponseType', projectId: string, versionId: string, uploadId: string, groupId?: string, uploadUrls: Array<{ __typename?: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type CompleteProjectMultipartUploadMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
  completeUploadInput: CompleteMultipartUploadInput;
}>;


export type CompleteProjectMultipartUploadMutation = { __typename?: 'Mutation', completeProjectVersionMultipartUpload?: any };

export type DeleteProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', deleteProject: { __typename?: 'ProjectResponseType', projectId: string, groupId?: string } };

export type DeleteProjectVersionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type DeleteProjectVersionMutation = { __typename?: 'Mutation', deleteProjectVersion: { __typename?: 'ProjectVersionResponseType', projectId: string, versionId: string, groupId?: string } };

export type UpdateProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  project: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'ProjectResponseType', projectId: string, groupId?: string } };

export type CreateProjectVersionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  projectVersion: CreateProjectVersionInput;
}>;


export type CreateProjectVersionMutation = { __typename?: 'Mutation', createProjectVersion: { __typename?: 'ProjectVersionUploadURLResponseType', projectId: string, versionId: string, uploadId: string, uploadUrls: Array<{ __typename?: 'S3MultipartUploadUrlType', partNumber: number, uploadUrl: string }> } };

export type UpdateProjectVersionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  projectVersion: UpdateProjectVersionInput;
}>;


export type UpdateProjectVersionMutation = { __typename?: 'Mutation', updateProjectVersion: { __typename?: 'ProjectVersionResponseType', projectId: string, versionId: string } };

export type ReadAllProjectsQueryVariables = Exact<{
  filter?: InputMaybe<ProjectFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllProjectsQuery = { __typename?: 'Query', readAllProjects: { __typename?: 'PaginatedProjectResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type DownloadProjectVersionQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type DownloadProjectVersionQuery = { __typename?: 'Query', downloadProjectVersion: { __typename?: 'ProjectVersionDownloadURLResponseType', downloadUrl: string } };

export type ReadProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ReadProjectQuery = { __typename?: 'Query', readProject: { __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } } };

export type ReadVersionsForProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  filter?: InputMaybe<ProjectVersionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadVersionsForProjectQuery = { __typename?: 'Query', readProjectVersionsForProject: { __typename?: 'PaginatedProjectVersionResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type ReadLinkedLibrariesForProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedLibrariesForProjectQuery = { __typename?: 'Query', readLinkedSubProjectsForProject: { __typename?: 'PaginatedProjectResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'ProjectResponseType', updateTimestamp?: any, objectVersion?: number, projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, secretId?: string, linkMetaData?:
        | { __typename?: 'ProjectToDeviceLinkMetaDataType' }
        | { __typename?: 'ProjectToProjectLinkMetaDataType', destinationVersionId?: string, sourceVersionId?: string }
      , linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> } }> } };

export type ReadLinkedDevicesForProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedDevicesForProjectQuery = { __typename?: 'Query', readLinkedDevicesForProject: { __typename?: 'PaginatedDeviceResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'DeviceResponseType', deviceId: string, deviceType: DeviceTypeEnum, vendorId: string, ideConfigId: string, groupId?: string, name: string, secretId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, description?: string, metaData?: any, linkMetaData?:
        | { __typename?: 'DeviceToDeviceLinkMetaDataType' }
        | { __typename?: 'DeviceToGatewayLinkMetaDataType' }
        | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
      , ftpConfiguration?: { __typename?: 'FtpConfigurationType', secretId?: string, ipAddress: string, port: number, rootDirectory?: string, protocol?: FtpProtocolEnum }, smbConfiguration?: { __typename?: 'SmbConfigurationType', secretId?: string, ipAddress: string, port: number, protocol?: SmbProtocolEnum, rootDirectory?: string }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, linkMetaData?:
            | { __typename?: 'ProjectToDeviceLinkMetaDataType', targetProjectVersionId?: string, deviceName?: string, deviceIpAddress?: string, deviceSubnet?: string, deviceType?: string }
            | { __typename?: 'ProjectToProjectLinkMetaDataType' }
          , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> }, connectionConfiguration: { __typename?: 'ConnectionConfigurationType', gatewayIpAddress?: string, ipAddress: string, port: number, subnetMask?: string }, linkedGateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename: 'GatewayResponseType', name: string, description?: string, gatewayId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, linkMetaData?: { __typename?: 'DeviceToGatewayLinkMetaDataType', primary?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'GatewaySetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'GatewaySetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number }, metadata?: { __typename?: 'GatewayMetadataResponseType', reportedAt: any, version: string, latestVersion?: string, latestVersionForMajor?: string, architecture: ArchEnum, operatingSystem: OperatingSystemEnum, numCpu?: number, isOutdated?: boolean, isOutdatedForMajor?: boolean, operatingSystemAttrs?:
              | { __typename?: 'LinuxAttrsType', distro: string, version: string, kernel: string, procVersion: string }
              | { __typename?: 'WindowsAttrsType', productId: string, productName: string, compositionEditionId?: string, currentBuild?: string, currentVersion?: string, displayVersion?: string, editionId?: string, installationType?: string, registeredOrganization?: string, registeredOwner?: string, winreVersion?: string }
             }, publicIp?: { __typename?: 'GatewayPublicIpResponseType', reportedAt: any, publicIp: string }, state?: { __typename?: 'GatewayStateResponseType', reportedAt: any, state: GatewayStateEnum }, location?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string, horizontalAccuracy?: number, horizontalConfidenceLevelPercentage?: number }, customLocation?: { __typename?: 'LocationType', latitudeE6: number, longitudeE6: number, country?: string, state?: string, city?: string } }> }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadProjectViewerProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  filter?: InputMaybe<ProjectVersionFilterInput>;
}>;


export type ReadProjectViewerProjectQuery = { __typename?: 'Query', readProject: { __typename?: 'ProjectResponseType', name: string, projectId: string, vendorId: string, ideConfigId: string, projectType: ProjectTypeEnum, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', items: Array<{ __typename?: 'ProjectVersionResponseType', versionId: string, creationTimestamp?: any, updateTimestamp?: any, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } } };

export type ReadProjectsByIdsQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadProjectsByIdsQuery = { __typename?: 'Query', readProjectsByIds: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename: 'ProjectResponseType', projectType: ProjectTypeEnum, vendorId: string, name: string, metaData?: any, attachedLicenses?: Array<string>, projectId: string, groupId?: string, description?: string, ideConfigId: string, creationTimestamp?: any, objectVersion?: number, updateTimestamp?: any, secretId?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, versions: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', deviceType: DeviceTypeEnum }> }, linkedSubProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedParentProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number }, linkedDocuments: { __typename?: 'PaginatedDocumentResponseType', itemCount: number } }> } };

export type ReadProjectNamesForRoleRowQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadProjectNamesForRoleRowQuery = { __typename?: 'Query', readProjectsByIds: { __typename?: 'PaginatedProjectResponseType', items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> } };

export type ReadLatestActiveVersionQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ReadLatestActiveVersionQuery = { __typename?: 'Query', readProjectVersionsForProject: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type ReadLatestVersionQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ReadLatestVersionQuery = { __typename?: 'Query', readProjectVersionsForProject: { __typename?: 'PaginatedProjectVersionResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectVersionResponseType', versionNumber: number, projectId: string, versionId: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: ProjectVersionSourceEnum, commitMessage?: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, projectFile: { __typename?: 'ProjectVersionFileType', fileName: string, fileExtension: string, fileSize: any }, deviceInformation?: Array<{ __typename?: 'DeviceInformationType', name: string, deviceType: DeviceTypeEnum, ethernetCommunication: Array<{ __typename?: 'EthernetCommunicationType', ipAddress: string, subnetMask?: string }> }> }> } };

export type TagFragment = { __typename?: 'TagResponseType', name: string };

export type FullTagFragment = { __typename: 'TagResponseType', creationTimestamp?: any, name: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, devices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> }, projects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> }, documents: { __typename?: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentResponseType', name: string, documentId: string }> }, gateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename?: 'GatewayResponseType', name: string, gatewayId: string }> } };

export type CreateTagMutationVariables = Exact<{
  tag: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'TagResponseType', name: string } };

export type DefineAssetTagsMutationVariables = Exact<{
  assetId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  input: Array<DefineAssetLinkToAssetInput> | DefineAssetLinkToAssetInput;
}>;


export type DefineAssetTagsMutation = { __typename?: 'Mutation', defineAssetLinksToAsset: { __typename?: 'PaginatedAssetLinkResponseType', itemCount: number, items: Array<{ __typename?: 'AssetLinkResponseType', sourceType: AssetTypeEnum, sourceId: string, destinationType: AssetTypeEnum, destinationId: string }> } };

export type DeleteTagMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'TagResponseType', name: string } };

export type ReadAllTagsQueryVariables = Exact<{
  filter?: InputMaybe<TagFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllTagsQuery = { __typename?: 'Query', readAllTags: { __typename?: 'PaginatedTagResponseType', pages: number, items: Array<{ __typename?: 'TagResponseType', name: string }> } };

export type ReadAllFullTagsQueryVariables = Exact<{
  filter?: InputMaybe<TagFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllFullTagsQuery = { __typename?: 'Query', readAllTags: { __typename?: 'PaginatedTagResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'TagResponseType', creationTimestamp?: any, name: string, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, devices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> }, projects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> }, documents: { __typename?: 'PaginatedDocumentResponseType', itemCount: number, items: Array<{ __typename?: 'DocumentResponseType', name: string, documentId: string }> }, gateways: { __typename?: 'PaginatedGatewayResponseType', itemCount: number, items: Array<{ __typename?: 'GatewayResponseType', name: string, gatewayId: string }> } }> } };

export type ReadLinkedTagsForAssetQueryVariables = Exact<{
  assetId: Scalars['String']['input'];
  assetType: AssetTypeEnum;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadLinkedTagsForAssetQuery = { __typename?: 'Query', readLinkedTagsForAsset: { __typename?: 'PaginatedTagResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'TagResponseType', name: string }> } };

export type VaultFragment = { __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename?: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename?: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type SecretFragment = { __typename: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename?: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> } };

export type SecretUnceiledFragment = { __typename?: 'SecretUnceiledResponseType', secretId: string, secretValue: string };

export type WeakSecretsFragment = { __typename?: 'VaultResponseType', vaultId: string, secrets: { __typename?: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename?: 'SecretResponseType', secretId: string, weakSecret: boolean }> } };

export type CreateVaultMutationVariables = Exact<{
  vault: CreateVaultInput;
}>;


export type CreateVaultMutation = { __typename?: 'Mutation', createVault: { __typename?: 'VaultResponseType', vaultId: string, name: string, description?: string } };

export type DeleteVaultMutationVariables = Exact<{
  vaultId: Scalars['String']['input'];
}>;


export type DeleteVaultMutation = { __typename?: 'Mutation', deleteVault: { __typename?: 'VaultResponseType', vaultId: string } };

export type CreateSecretMutationVariables = Exact<{
  secret: CreateSecretInput;
}>;


export type CreateSecretMutation = { __typename?: 'Mutation', createSecret: { __typename?: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, name: string, vaultId: string } };

export type DeleteSecretMutationVariables = Exact<{
  secretId: Scalars['String']['input'];
}>;


export type DeleteSecretMutation = { __typename?: 'Mutation', deleteSecret: { __typename?: 'SecretResponseType', secretId: string, vaultId: string } };

export type UpdateVaultMutationVariables = Exact<{
  vaultId: Scalars['String']['input'];
  vault: UpdateVaultInput;
}>;


export type UpdateVaultMutation = { __typename?: 'Mutation', updateVault: { __typename?: 'VaultResponseType', vaultId: string } };

export type UpdateSecretMutationVariables = Exact<{
  secretId: Scalars['String']['input'];
  secret: UpdateSecretInput;
}>;


export type UpdateSecretMutation = { __typename?: 'Mutation', updateSecret: { __typename?: 'SecretResponseType', secretId: string, vaultId: string } };

export type SyncWeakSecretFlagsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncWeakSecretFlagsMutation = { __typename?: 'Mutation', syncWeakSecretFlags: { __typename?: 'SyncWeakSecretFlagsResponseType', allSecretsSecure: boolean } };

export type ReadAllVaultsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<VaultFilterInput>;
}>;


export type ReadAllVaultsQuery = { __typename?: 'Query', readAllVaults: { __typename?: 'PaginatedVaultResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename?: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename?: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadVaultQueryVariables = Exact<{
  vaultId: Scalars['String']['input'];
}>;


export type ReadVaultQuery = { __typename?: 'Query', readVault: { __typename: 'VaultResponseType', vaultId: string, groupId?: string, name: string, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, description?: string, secrets: { __typename?: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename?: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number } }> }, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadSecretsForVaultQueryVariables = Exact<{
  vaultId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<SecretFilterInput>;
}>;


export type ReadSecretsForVaultQuery = { __typename?: 'Query', readSecretsForVault: { __typename?: 'PaginatedSecretResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename?: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> } }> } };

export type ReadSecretQueryVariables = Exact<{
  secretId: Scalars['String']['input'];
}>;


export type ReadSecretQuery = { __typename?: 'Query', readSecret: { __typename: 'SecretResponseType', secretId: string, secretType: SecretTypeEnum, weakSecret: boolean, name: string, username?: string, secretValue: string, objectVersion?: number, vault: { __typename?: 'VaultResponseType', name: string, vaultId: string }, linkedDevices: { __typename?: 'PaginatedDeviceResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceResponseType', name: string, deviceId: string }> }, linkedProjects: { __typename?: 'PaginatedProjectResponseType', itemCount: number, items: Array<{ __typename?: 'ProjectResponseType', name: string, projectId: string }> } } };

export type ReadSecretUnceiledQueryVariables = Exact<{
  secretId: Scalars['String']['input'];
}>;


export type ReadSecretUnceiledQuery = { __typename?: 'Query', readSecretUnceiled: { __typename?: 'SecretUnceiledResponseType', secretId: string, secretValue: string } };

export type ReadAllVaultNamesForPolicyRowQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<VaultFilterInput>;
}>;


export type ReadAllVaultNamesForPolicyRowQuery = { __typename?: 'Query', readAllVaults: { __typename?: 'PaginatedVaultResponseType', items: Array<{ __typename?: 'VaultResponseType', name: string, vaultId: string }> } };

export type ReadWeakSecretsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadWeakSecretsSummaryQuery = { __typename?: 'Query', readAllVaults: { __typename?: 'PaginatedVaultResponseType', itemCount: number, items: Array<{ __typename?: 'VaultResponseType', vaultId: string, secrets: { __typename?: 'PaginatedSecretResponseType', itemCount: number, items: Array<{ __typename?: 'SecretResponseType', secretId: string, weakSecret: boolean }> } }> } };

export type DeviceVulnerabilityFragment = { __typename?: 'DeviceOtCveResponseType', deviceId: string, deviceName: string, deviceType?: string, vendor?: string, deviceVersion: string, firmwareDeviceName?: string, cveNumber?: string, nvdSeverity?: string, affectedVersion?: string, fixedVersion?: string, constraint?: string, productArticleNumber?: string, isVulnerable?: boolean, publishedDate?: string, cvssScore?: any };

export type OtCveRecordFieldsFragment = { __typename?: 'OtCveRecordType', cveNumber?: string, cveTitle?: string, description?: string, nvdDescription?: string, cvssScore?: any, publishDate?: string, productArticleNumber: string, productName?: string, affectedVersions?: string, fixedVersions?: string, advisoryLink?: string, nvdSeverity?: string, nvdUrl?: string };

export type ReadAllDeviceVulnerabilitiesQueryVariables = Exact<{
  filter?: InputMaybe<DeviceVulnerabilityFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllDeviceVulnerabilitiesQuery = { __typename?: 'Query', readAllDeviceVulnerabilities: { __typename?: 'PaginatedDeviceOtCveResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'DeviceOtCveResponseType', deviceId: string, deviceName: string, deviceType?: string, vendor?: string, deviceVersion: string, firmwareDeviceName?: string, cveNumber?: string, nvdSeverity?: string, affectedVersion?: string, fixedVersion?: string, constraint?: string, productArticleNumber?: string, isVulnerable?: boolean, publishedDate?: string, cvssScore?: any }> } };

export type ReadOtCveQueryVariables = Exact<{
  cveNumber: Scalars['String']['input'];
  productArticleNumber: Scalars['String']['input'];
}>;


export type ReadOtCveQuery = { __typename?: 'Query', readOtCve: { __typename?: 'OtCveResponseType', otCveId: string, vendor?: string, record: { __typename?: 'OtCveRecordType', cveNumber?: string, cveTitle?: string, description?: string, nvdDescription?: string, cvssScore?: any, publishDate?: string, productArticleNumber: string, productName?: string, affectedVersions?: string, fixedVersions?: string, advisoryLink?: string, nvdSeverity?: string, nvdUrl?: string } } };

export type ReadDeviceVulnerabilitySummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadDeviceVulnerabilitySummaryQuery = { __typename?: 'Query', readAllDeviceVulnerabilities: { __typename?: 'PaginatedDeviceOtCveResponseType', itemCount: number, items: Array<{ __typename?: 'DeviceOtCveResponseType', deviceId: string }> } };

export type WorkstationPublicIpFragment = { __typename?: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename?: 'LocationType', city?: string, country?: string, state?: string } };

export type WorkstationMetadataFragment = { __typename?: 'WorkstationMetadataResponseType', architecture: ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: OperatingSystemEnum, reportedAt: any, version: string };

export type WorkstationSetupCommandFragment = { __typename?: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> };

export type WorkstationFragment = { __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, metadata?: { __typename?: 'WorkstationMetadataResponseType', architecture: ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename?: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename?: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename?: 'WorkstationStateResponseType', reportedAt: any, state: WorkstationStateEnum } };

export type WorkstationDeviceConnectionFragment = { __typename?: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string };

export type CreateWorkstationMutationVariables = Exact<{
  workstation: CreateWorkstationInput;
}>;


export type CreateWorkstationMutation = { __typename?: 'Mutation', createWorkstation: { __typename?: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type UpdateWorkstationMutationVariables = Exact<{
  workstationId: Scalars['String']['input'];
  workstation: UpdateWorkstationInput;
}>;


export type UpdateWorkstationMutation = { __typename?: 'Mutation', updateWorkstation: { __typename?: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type DeleteWorkstationMutationVariables = Exact<{
  workstationId: Scalars['String']['input'];
}>;


export type DeleteWorkstationMutation = { __typename?: 'Mutation', deleteWorkstation: { __typename?: 'WorkstationResponseType', groupId?: string, workstationId: string } };

export type CreateWorkstationConnectionMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
}>;


export type CreateWorkstationConnectionMutation = { __typename?: 'Mutation', createWorkstationDeviceConnectionV2: { __typename?: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string } };

export type DeleteWorkstationConnectionMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  workstationId: Scalars['String']['input'];
}>;


export type DeleteWorkstationConnectionMutation = { __typename?: 'Mutation', deleteWorkstationDeviceConnectionV2: { __typename?: 'WorkstationDeviceConnectionV2Type', workstationId: string } };

export type ReadAllWorkstationsQueryVariables = Exact<{
  filter?: InputMaybe<WorkstationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllWorkstationsQuery = { __typename?: 'Query', readAllWorkstationsForUser: { __typename?: 'PaginatedWorkstationResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, metadata?: { __typename?: 'WorkstationMetadataResponseType', architecture: ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename?: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename?: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename?: 'WorkstationStateResponseType', reportedAt: any, state: WorkstationStateEnum } }> } };

export type ReadWorkstationHealthStatusQueryVariables = Exact<{
  workstationId: Scalars['String']['input'];
}>;


export type ReadWorkstationHealthStatusQuery = { __typename?: 'Query', readWorkstationState?: { __typename?: 'WorkstationStateResponseType', reportedAt: any, state: WorkstationStateEnum } };

export type ReadWorkstationQueryVariables = Exact<{
  workstationId: Scalars['String']['input'];
}>;


export type ReadWorkstationQuery = { __typename?: 'Query', readWorkstation: { __typename: 'WorkstationResponseType', name: string, description?: string, workstationId: string, groupId?: string, updateTimestamp?: any, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, setupCommands?: { __typename?: 'WorkstationSetupResponseType', expiresAt: any, osCommands: Array<{ __typename?: 'WorkstationSetupType', configurationCommand: string, installationCommand: string, osName: string, osType: OperatingSystemEnum }> }, metadata?: { __typename?: 'WorkstationMetadataResponseType', architecture: ArchEnum, isOutdated?: boolean, isOutdatedForMajor?: boolean, latestVersion?: string, latestVersionForMajor?: string, numCpu?: number, operatingSystem: OperatingSystemEnum, reportedAt: any, version: string }, publicIp?: { __typename?: 'WorkstationPublicIpResponseType', publicIp: string, reportedAt: any, publicIpLocation?: { __typename?: 'LocationType', city?: string, country?: string, state?: string } }, state?: { __typename?: 'WorkstationStateResponseType', reportedAt: any, state: WorkstationStateEnum } } };

export type ReadWorkstationConnectionsQueryVariables = Exact<{
  workstationId: Scalars['String']['input'];
}>;


export type ReadWorkstationConnectionsQuery = { __typename?: 'Query', readWorkstationDeviceConnectionsV2: { __typename?: 'PaginatedWorkstationDeviceConnectionV2StatusResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'WorkstationDeviceConnectionV2Type', connectionId: string, connectionState?: ConnectionV2State, deviceId: string, gatewayId?: string, workstationId: string }> } };

export type AuditLogListItemFragment = { __typename?: 'AuditLogResponseType', eventTimestamp: any, eventType: AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: AuditLogCategory, creationUserId?: string };

export type AuditLogFragment = { __typename?: 'AuditLogResponseType', eventTimestamp: any, eventType: AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: AuditLogCategory, creationUserId?: string, data: any, changes?: Array<{ __typename?: 'ChangeEntryType', field: string, type: ChangeType, added?: any, removed?: any, identifier?: any, changes?: any, item?: any }> };

export type ExportAuditLogsCsvMutationVariables = Exact<{
  filter?: InputMaybe<AuditLogFilterInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ExportAuditLogsCsvMutation = { __typename?: 'Mutation', exportAuditLogsCsv: { __typename?: 'AuditLogCsvExportTriggerResponseType', requestId: string, channel: string, message: string } };

export type ReadAllAuditLogsQueryVariables = Exact<{
  filter?: InputMaybe<AuditLogFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllAuditLogsQuery = { __typename?: 'Query', readAllAuditLogs: { __typename?: 'PaginatedAuditLogResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'AuditLogResponseType', eventTimestamp: any, eventType: AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: AuditLogCategory, creationUserId?: string }> } };

export type ReadAuditLogQueryVariables = Exact<{
  auditLogId: Scalars['String']['input'];
}>;


export type ReadAuditLogQuery = { __typename?: 'Query', readAuditLog?: { __typename?: 'AuditLogResponseType', eventTimestamp: any, eventType: AuditLogEventTypeSource, auditLogId: string, userMessage?: string, category?: AuditLogCategory, creationUserId?: string, data: any, changes?: Array<{ __typename?: 'ChangeEntryType', field: string, type: ChangeType, added?: any, removed?: any, identifier?: any, changes?: any, item?: any }> } };

export type ReadAuditLogsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAuditLogsCountQuery = { __typename?: 'Query', readAllAuditLogs: { __typename?: 'PaginatedAuditLogResponseType', itemCount: number } };

export type BillingTimeIntervalFragment = { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean };

export type BillingTermFragment = { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } };

export type BillingEntitlementFragment = { __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } };

export type BillingProvisionedUsageFragment = { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } };

export type BillingUpfrontProvisionedUsageItemFragment = { __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } };

export type BillingPlanFragment = { __typename?: 'BillingPlan', tier: string, planVersion: string, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }> };

export type BillingSubscriptionFragment = { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> };

export type BillingChangeFragment = { __typename?: 'BillingScheduledSubscriptionChange', cancellation?: boolean, changeTs: number, scheduledSubscriptionChangeKey: string, schedulingPolicy: BillingSubscriptionChangeSchedulingPolicyEnum, creation?: { __typename?: 'BillingScheduledSubscriptionCreation', subscription: { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> } }, planSwitch?: { __typename?: 'BillingScheduledPlanSwitch', subscription: { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> } }, entitlementUpdate?: { __typename?: 'BillingScheduledSubscriptionEntitlementUpdate', entitlement: { __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } } } };

export type BillingMetadataItemFragment = { __typename?: 'BillingMetadataItem', key: string, value: string };

export type BillingFeatureValuesFragment = { __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string };

export type BillingEntitlementUsageFragment = { __typename?: 'BillingEntitlementTermUsage', feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, confirmedUsage: string, period?: BillingPeriodEnum, upfrontQuantity: string };

export type BillingStatsValuesFragment = { __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string };

export type BillingMeteredDataFragment = { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: BillingPeriodEnum, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } };

export type BillingLicensedDataFragment = { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> };

export type SwitchTenantPlanMutationVariables = Exact<{
  params: BillingSwitchPlanInput;
}>;


export type SwitchTenantPlanMutation = { __typename?: 'Mutation', switchTenantPlan: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type UpdateTenantSubscriptionMutationVariables = Exact<{
  params: BillingUpdateSubscriptionInput;
}>;


export type UpdateTenantSubscriptionMutation = { __typename?: 'Mutation', updateTenantSubscription: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type RevokeSubscriptionChangeMutationVariables = Exact<{
  params: BillingRevokeScheduledSubscriptionChangeInput;
}>;


export type RevokeSubscriptionChangeMutation = { __typename?: 'Mutation', revokeTenantScheduledSubscriptionChange: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type CancelSubscriptionMutationVariables = Exact<{
  params: BillingCancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelTenantSubscription: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type CreateSubscriptionMutationVariables = Exact<{
  params: BillingCreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createTenantSubscription: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type HandleTermsAndConditionsAcceptedForBillingMutationVariables = Exact<{ [key: string]: never; }>;


export type HandleTermsAndConditionsAcceptedForBillingMutation = { __typename?: 'Mutation', handleTermsAndConditionsAccepted: { __typename?: 'BillingResponse', status: BillingResponseStatusEnum } };

export type ReadResalePlansQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadResalePlansQuery = { __typename?: 'Query', resalePlans: Array<{ __typename?: 'BillingPlan', tier: string, planVersion: string, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }> }> };

export type ReadSubscriptionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadSubscriptionStatusQuery = { __typename?: 'Query', subscriptionStatus: { __typename?: 'TenantSubscriptionStatus', cancellationTs?: number, expirationTs?: number, planType?: PlanType } };

export type ReadTenantSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadTenantSubscriptionQuery = { __typename?: 'Query', tenantSubscription: { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> } };

export type ReadTenantScheduledSubscriptionChangesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadTenantScheduledSubscriptionChangesQuery = { __typename?: 'Query', tenantScheduledSubscriptionChanges: Array<{ __typename?: 'BillingScheduledSubscriptionChange', cancellation?: boolean, changeTs: number, scheduledSubscriptionChangeKey: string, schedulingPolicy: BillingSubscriptionChangeSchedulingPolicyEnum, creation?: { __typename?: 'BillingScheduledSubscriptionCreation', subscription: { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> } }, planSwitch?: { __typename?: 'BillingScheduledPlanSwitch', subscription: { __typename?: 'BillingSubscription', tier: string, planVersion: string, subscriptionVersion: string, resellerOps?: Array<BillingOperationEnum>, entitlements: Array<{ __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } }>, tierRanking?: { __typename?: 'BillingPlanTierRanking', upsaleTiers: Array<string> }, term: { __typename?: 'BillingTerm', startTs?: number, expirationTs?: number, cancellationTs?: number, duration?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean }, noticePeriod?: { __typename?: 'BillingTimeInterval', seconds?: number, minutes?: number, hours?: number, days?: number, months?: number, years?: number, recurring?: boolean } }, metadata: Array<{ __typename?: 'BillingMetadataItem', key: string, value: string }> } }, entitlementUpdate?: { __typename?: 'BillingScheduledSubscriptionEntitlementUpdate', entitlement: { __typename?: 'BillingEntitlement', enabled: boolean, feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, resellerOps?: Array<BillingOperationEnum>, usageType: BillingUsageTypeEnum, provisionedUsage: { __typename?: 'BillingProvisionedUsage', resellerOps?: Array<BillingOperationEnum>, scope: { __typename?: 'BillingScopeParams', period: BillingPeriodEnum }, upfront: Array<{ __typename?: 'BillingUpfrontProvisionedUsageItem', itemId: string, fixedQuantity?: string, packageSize?: string, resellerOps?: Array<BillingOperationEnum>, proportionalQuantity?: { __typename?: 'BillingProportionalQuantity', dependerFeature: BillingFeatureEnum } }>, expost: { __typename?: 'BillingExpostProvisionedUsage', enabled: boolean, resellerOps?: Array<BillingOperationEnum> } } } } }> };

export type ReadTenantSubscriptionTermUsageQueryVariables = Exact<{
  subscriptionVersion: Scalars['String']['input'];
  termReferenceTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReadTenantSubscriptionTermUsageQuery = { __typename?: 'Query', tenantSubscriptionTermUsage: { __typename?: 'BillingSubscriptionTermUsage', subscriptionVersion: string, termReferenceTs: number, entitlementUsages: Array<{ __typename?: 'BillingEntitlementTermUsage', feature: BillingFeatureEnum, allFeatures: Array<BillingFeatureEnum>, confirmedUsage: string, period?: BillingPeriodEnum, upfrontQuantity: string }> } };

export type ReadTenantFeatureUsageStatsQueryVariables = Exact<{
  feature: BillingFeatureEnum;
  startTs?: InputMaybe<Scalars['Int']['input']>;
  endTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReadTenantFeatureUsageStatsQuery = { __typename?: 'Query', tenantFeatureUsageStats: { __typename?: 'BillingUsageStats', data:
      | { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> }
      | { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: BillingPeriodEnum, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } }
     } };

export type ReadTenantEntitlementUsageStatsQueryVariables = Exact<{
  feature: BillingFeatureEnum;
  startTs?: InputMaybe<Scalars['Int']['input']>;
  endTs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReadTenantEntitlementUsageStatsQuery = { __typename?: 'Query', tenantEntitlementUsageStats: { __typename?: 'BillingUsageStats', data:
      | { __typename: 'BillingUsageStatsLicensedData', timestamps: Array<string>, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }> }
      | { __typename: 'BillingUsageStatsMeteredData', timestamps: Array<string>, period: BillingPeriodEnum, featureValues: Array<{ __typename?: 'BillingUsageStatsFeatureValues', feature: BillingFeatureEnum, values: Array<string>, groupId?: string }>, upfront?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, total?: Array<{ __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string }>, carryover?: { __typename?: 'BillingUsageStatsValues', values: Array<string>, groupId?: string } }
     } };

export type StartSessionFragment = { __typename?: 'StartSessionResponseType', sessionId: string, streamingUrl: string, websocketChannel: string };

export type IdeaasSessionFragment = { __typename?: 'SessionResponseType', sessionId: string, ownerId?: string, creationUserId?: string, creationTimestamp?: any, sessionStartTimestamp?: string, streamingUrl?: string, websocketChannel?: string, status: SessionStatus, objectVersion?: number, projectId?: string, versionId?: string, supportedIdes?: Array<string>, sessionDurationMs?: number, sessionEndTimestampMs?: any, language?: string, idleTime: number };

export type SessionRecordingFileFragment = { __typename?: 'SessionRecordingFileType', fileName: string, fileSize: number, fileExtension: string, fileKey: string };

export type SessionRecordingFragment = { __typename?: 'SessionRecordingType', sessionRecordingId: string, sessionId: string, status: RecordingStatus, duration?: number, createdAtTimestampMs?: any, updatedAtTimestampMs?: any, creationUserId?: string, plcVendor?: string, ideConfigId?: string, thumbnailUrl?: string, playbackUrl?: string, sessionRecordingFile?: { __typename?: 'SessionRecordingFileType', fileName: string, fileSize: number, fileExtension: string, fileKey: string } };

export type PlaybackUrlFragment = { __typename?: 'PlaybackUrlResponseType', recordingId: string, playbackUrl: string, thumbnailUrl?: string };

export type HubConfigFragment = { __typename?: 'HubConfigType', hubConfigId: string, recordingEnabled: boolean, retentionDays: number };

export type CreateIdeaasSessionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateIdeaasSessionMutation = { __typename?: 'Mutation', startSession: { __typename?: 'StartSessionResponseType', sessionId: string, streamingUrl: string, websocketChannel: string } };

export type GetRecordingPlaybackUrlMutationVariables = Exact<{
  recordingId: Scalars['String']['input'];
}>;


export type GetRecordingPlaybackUrlMutation = { __typename?: 'Mutation', getRecordingPlaybackUrl: { __typename?: 'PlaybackUrlResponseType', recordingId: string, playbackUrl: string, thumbnailUrl?: string } };

export type UpdateHubConfigMutationVariables = Exact<{
  recordingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  retentionDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateHubConfigMutation = { __typename?: 'Mutation', updateHubConfig: { __typename?: 'HubConfigType', hubConfigId: string, recordingEnabled: boolean, retentionDays: number } };

export type ReadIdeaasSessionQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type ReadIdeaasSessionQuery = { __typename?: 'Query', readSession: { __typename?: 'SessionResponseType', sessionId: string, ownerId?: string, creationUserId?: string, creationTimestamp?: any, sessionStartTimestamp?: string, streamingUrl?: string, websocketChannel?: string, status: SessionStatus, objectVersion?: number, projectId?: string, versionId?: string, supportedIdes?: Array<string>, sessionDurationMs?: number, sessionEndTimestampMs?: any, language?: string, idleTime: number } };

export type ReadAllIdeaasSessionsQueryVariables = Exact<{
  pagination: PaginationInputType;
  statuses?: InputMaybe<Array<SessionStatus> | SessionStatus>;
  ownerIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  hasRecording?: InputMaybe<Scalars['Boolean']['input']>;
  startTimestamp?: InputMaybe<Scalars['String']['input']>;
  endTimestamp?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReadAllIdeaasSessionsQuery = { __typename?: 'Query', readAllSessions: { __typename?: 'PaginatedSessionResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'SessionResponseType', sessionId: string, ownerId?: string, creationUserId?: string, creationTimestamp?: any, sessionStartTimestamp?: string, streamingUrl?: string, websocketChannel?: string, status: SessionStatus, objectVersion?: number, projectId?: string, versionId?: string, supportedIdes?: Array<string>, sessionDurationMs?: number, sessionEndTimestampMs?: any, language?: string, idleTime: number }> } };

export type ReadAllIdeaasSessionsByTenantIdQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  pagination: PaginationInputType;
  statuses?: InputMaybe<Array<SessionStatus> | SessionStatus>;
}>;


export type ReadAllIdeaasSessionsByTenantIdQuery = { __typename?: 'Query', readAllSessionsByTenantId: { __typename?: 'PaginatedSessionResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'SessionResponseType', sessionId: string, ownerId?: string, creationUserId?: string, creationTimestamp?: any, sessionStartTimestamp?: string, streamingUrl?: string, websocketChannel?: string, status: SessionStatus, objectVersion?: number, projectId?: string, versionId?: string, supportedIdes?: Array<string>, sessionDurationMs?: number, sessionEndTimestampMs?: any, language?: string, idleTime: number }> } };

export type ReadSessionRecordingQueryVariables = Exact<{
  recordingId: Scalars['String']['input'];
}>;


export type ReadSessionRecordingQuery = { __typename?: 'Query', readSessionRecording: { __typename?: 'SessionRecordingType', sessionRecordingId: string, sessionId: string, status: RecordingStatus, duration?: number, createdAtTimestampMs?: any, updatedAtTimestampMs?: any, creationUserId?: string, plcVendor?: string, ideConfigId?: string, thumbnailUrl?: string, playbackUrl?: string, sessionRecordingFile?: { __typename?: 'SessionRecordingFileType', fileName: string, fileSize: number, fileExtension: string, fileKey: string } } };

export type ReadAllSessionRecordingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAllSessionRecordingsQuery = { __typename?: 'Query', readAllSessionRecordings: Array<{ __typename?: 'SessionRecordingType', sessionRecordingId: string, sessionId: string, status: RecordingStatus, duration?: number, createdAtTimestampMs?: any, updatedAtTimestampMs?: any, creationUserId?: string, plcVendor?: string, ideConfigId?: string, thumbnailUrl?: string, playbackUrl?: string, sessionRecordingFile?: { __typename?: 'SessionRecordingFileType', fileName: string, fileSize: number, fileExtension: string, fileKey: string } }> };

export type ReadSessionRecordingsBySessionQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type ReadSessionRecordingsBySessionQuery = { __typename?: 'Query', readSessionRecordingsBySession: Array<{ __typename?: 'SessionRecordingType', sessionRecordingId: string, sessionId: string, status: RecordingStatus, duration?: number, createdAtTimestampMs?: any, updatedAtTimestampMs?: any, creationUserId?: string, plcVendor?: string, ideConfigId?: string, thumbnailUrl?: string, playbackUrl?: string, sessionRecordingFile?: { __typename?: 'SessionRecordingFileType', fileName: string, fileSize: number, fileExtension: string, fileKey: string } }> };

export type ReadHubConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadHubConfigQuery = { __typename?: 'Query', readHubConfig: { __typename?: 'HubConfigType', hubConfigId: string, recordingEnabled: boolean, retentionDays: number } };

export type CreateTenantMutationVariables = Exact<{
  tenant: CreateTenantInput;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'TenantResponseType', tenantId: string, existingUser?: boolean } };

export type ConfirmUserMutationVariables = Exact<{
  input: ConfirmUserInput;
}>;


export type ConfirmUserMutation = { __typename?: 'Mutation', confirmUser?: any };

export type ForgotPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
  appClientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: { __typename?: 'ForgotPasswordResponseType', isPasswordReset: boolean, nextStep: { __typename?: 'ForgotPasswordNextStepType', resetPasswordStep: string } } };

export type ReadIdentityProviderByEmailMutationVariables = Exact<{
  appClientId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
}>;


export type ReadIdentityProviderByEmailMutation = { __typename?: 'Mutation', readIdentityProviderByEmail: { __typename?: 'IdentityProviderResponseType', identityProviderId: string } };

export type FeatureConfigMetadataFragment = { __typename?: 'FeatureMetaDataType', featureType: FeatureTypeEnum, deviceTypes?: Array<DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename?: 'FileExtensionMappingType', projectType: ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename?: 'FileToDeviceTypeMappingType', deviceType: DeviceTypeEnum, fileExtension: string, projectType: ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename?: 'FileToFileTypeMappingType', projectType: ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: ProjectTypeEnum }> };

export type FeatureConfigOptionFragment = { __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> };

export type FeatureConfigFragment = { __typename?: 'FeatureConfigType', feature: FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename?: 'FeatureMetaDataType', featureType: FeatureTypeEnum, deviceTypes?: Array<DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename?: 'FileExtensionMappingType', projectType: ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename?: 'FileToDeviceTypeMappingType', deviceType: DeviceTypeEnum, fileExtension: string, projectType: ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename?: 'FileToFileTypeMappingType', projectType: ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: ProjectTypeEnum }> } };

export type FileTypeFragment = { __typename?: 'FileTypeType', extension: string, description: string, projectType: ProjectTypeEnum, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> };

export type DeviceTypeFragment = { __typename?: 'DeviceConfigType', deviceType: DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> };

export type IdeFragment = { __typename?: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<IdeLanguageEnum>, factoryAgentAvailable: Array<ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename?: 'FeatureConfigType', feature: FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename?: 'FeatureMetaDataType', featureType: FeatureTypeEnum, deviceTypes?: Array<DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename?: 'FileExtensionMappingType', projectType: ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename?: 'FileToDeviceTypeMappingType', deviceType: DeviceTypeEnum, fileExtension: string, projectType: ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename?: 'FileToFileTypeMappingType', projectType: ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename?: 'FileTypeType', extension: string, description: string, projectType: ProjectTypeEnum, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename?: 'DeviceConfigType', deviceType: DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }> };

export type FeatureFlagFragment = { __typename?: 'FeatureFlagType', featureName: string, description?: string, isEnabled: boolean };

export type LicenseConfigFragment = { __typename?: 'LicenseConfigType', inputs: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> };

export type VendorFragment = { __typename?: 'VendorResponseType', name: string, vendorId: string, ides?: Array<{ __typename?: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<IdeLanguageEnum>, factoryAgentAvailable: Array<ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename?: 'FeatureConfigType', feature: FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename?: 'FeatureMetaDataType', featureType: FeatureTypeEnum, deviceTypes?: Array<DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename?: 'FileExtensionMappingType', projectType: ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename?: 'FileToDeviceTypeMappingType', deviceType: DeviceTypeEnum, fileExtension: string, projectType: ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename?: 'FileToFileTypeMappingType', projectType: ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename?: 'FileTypeType', extension: string, description: string, projectType: ProjectTypeEnum, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename?: 'DeviceConfigType', deviceType: DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }> }>, licenseConfig?: { __typename?: 'LicenseConfigType', inputs: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> } };

export type IdentUserInfoFragment = { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean };

export type OwnerUserInfoFragment = { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string };

export type PolicyFragment = { __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string };

export type UserRoleFragment = { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type OwnUserRoleFragment = { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type BaseUserFragment = { __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean };

export type UserFragment = { __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename?: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type BaseTenantFragment = { __typename?: 'TenantResponseType', tenantId: string, companyName: string, owner: { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } };

export type TenantFragment = { __typename?: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, tenantId: string, companyName: string, owner: { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } };

export type UserRoleLinkFragment = { __typename?: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number };

export type TermsAndConditionsAcceptanceFragment = { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any };

export type CreateUserMutationVariables = Exact<{
  user: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserResponseType', userId: string } };

export type LinkRoleToUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type LinkRoleToUserMutation = { __typename?: 'Mutation', createUserRoleUserLink: { __typename?: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type CreateUserRoleMutationVariables = Exact<{
  userRole: CreateUserRoleInput;
}>;


export type CreateUserRoleMutation = { __typename?: 'Mutation', createUserRole: { __typename?: 'UserRoleResponseType', userRoleId: string } };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  user: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserResponseType', userId: string } };

export type DeleteRoleMutationVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteUserRole: { __typename?: 'UserRoleResponseType', userRoleId: string, users: { __typename?: 'PaginatedUserResponseType', items: Array<{ __typename?: 'UserResponseType', userId: string }> } } };

export type RemoveRoleFromUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
}>;


export type RemoveRoleFromUserMutation = { __typename?: 'Mutation', deleteUserRoleUserLink?: any };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'UserResponseType', userId: string } };

export type UpdateUserRoleMutationVariables = Exact<{
  userRoleId: Scalars['String']['input'];
  userRole: UpdateUserRoleInput;
}>;


export type UpdateUserRoleMutation = { __typename?: 'Mutation', updateUserRole: { __typename?: 'UserRoleResponseType', userRoleId: string } };

export type SelectTenantMutationVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type SelectTenantMutation = { __typename?: 'Mutation', selectTenant?: any };

export type UpdateTenantMutationVariables = Exact<{
  tenant: UpdateTenantInput;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, tenantId: string, companyName: string, owner: { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } } };

export type UpdateUserRoleLinkMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  userRoleId: Scalars['String']['input'];
  expirationTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateUserRoleLinkMutation = { __typename?: 'Mutation', updateUserRoleUserLink: { __typename?: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number } };

export type GenerateTwoFactorAuthTokenMutationVariables = Exact<{
  verificationMethod: Scalars['String']['input'];
}>;


export type GenerateTwoFactorAuthTokenMutation = { __typename?: 'Mutation', generateTwoFactorAuthToken: { __typename?: 'GenerateTwoFactorAuthTokenResponseType', sessionId: string } };

export type AuthenticateTwoFactorAuthTokenMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
  challenge: Scalars['String']['input'];
}>;


export type AuthenticateTwoFactorAuthTokenMutation = { __typename?: 'Mutation', authenticateTwoFactorAuthToken: { __typename?: 'AuthenticateTwoFactorAuthTokenResponseType', status: string, sessionId?: string, expiresAt?: any } };

export type VerifyTotpTwoFactorAuthMutationVariables = Exact<{
  challenge: Scalars['String']['input'];
}>;


export type VerifyTotpTwoFactorAuthMutation = { __typename?: 'Mutation', verifyTotpTwoFactorAuth: { __typename?: 'AuthenticateTwoFactorAuthTokenResponseType', status: string, sessionId?: string, expiresAt?: any } };

export type AcceptTermsAndConditionsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptTermsAndConditionsMutation = { __typename?: 'Mutation', acceptTermsAndConditions: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any } };

export type UpdateUserUiPreferencesMutationVariables = Exact<{
  uiPreferences?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateUserUiPreferencesMutation = { __typename?: 'Mutation', updateUserUiPreferences: { __typename?: 'UserUiPreferencesResponseType', uiPreferences?: any } };

export type ReadTenantQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadTenantQuery = { __typename?: 'Query', readTenant: { __typename?: 'TenantResponseType', ownerId: string, ssoEnabled?: boolean, objectVersion?: number, country?: string, industry?: string, enforceMfa?: boolean, enforceMfaForIdeaas?: boolean, twoFactorAuthMethods?: Array<VerificationMethod>, manageSsoUsersInSda?: boolean, maxUserRoleExpirationDays?: number, creationTimestamp?: any, isActive: boolean, metaData?: any, tenantId: string, companyName: string, vendors: Array<{ __typename?: 'VendorResponseType', name: string, vendorId: string, ides?: Array<{ __typename?: 'IdeConfigResponseType', name: string, allowedLicenseVersions: Array<string>, ideConfigId: string, licenseRequired: boolean, multiDeviceSupport: boolean, vendorId: string, requiredFeatureFlag?: string, availableLanguages: Array<IdeLanguageEnum>, factoryAgentAvailable: Array<ProgrammingLanguageEnum>, additionalInformation?: string, features: Array<{ __typename?: 'FeatureConfigType', feature: FeatureEnum, requiredFeatureFlag?: string, options: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }>, metaData: { __typename?: 'FeatureMetaDataType', featureType: FeatureTypeEnum, deviceTypes?: Array<DeviceTypeEnum>, projectFileExtensions?: Array<{ __typename?: 'FileExtensionMappingType', projectType: ProjectTypeEnum, fileExtension: string }>, fileExtensionsToDeviceTypes?: Array<{ __typename?: 'FileToDeviceTypeMappingType', deviceType: DeviceTypeEnum, fileExtension: string, projectType: ProjectTypeEnum }>, fileToFileExtensions?: Array<{ __typename?: 'FileToFileTypeMappingType', projectType: ProjectTypeEnum, fileExtension: string, destinationFileExtension: string, destinationProjectType: ProjectTypeEnum }> } }>, fileTypes: Array<{ __typename?: 'FileTypeType', extension: string, description: string, projectType: ProjectTypeEnum, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }>, devices: Array<{ __typename?: 'DeviceConfigType', deviceType: DeviceTypeEnum, port: number, additionalInputs?: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> }> }>, licenseConfig?: { __typename?: 'LicenseConfigType', inputs: Array<{ __typename?: 'FeatureConfigOptionType', description: string, label: string, value: string, required?: boolean, validationRegex?: string, inputType: InputTypeEnum, defaultValue?: any, inputOptions: Array<{ __typename?: 'InputOptionType', value: any, label: string }> }> } }>, featureFlags?: Array<{ __typename?: 'FeatureFlagType', featureName: string, description?: string, isEnabled: boolean }>, owner: { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } } };

export type ReadAllUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllUsersQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedUserResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename?: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } }> } };

export type ReadUsersCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUsersCountQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedUserResponseType', itemCount: number } };

export type ReadAllRolesQueryVariables = Exact<{
  filter?: InputMaybe<UserRoleFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllRolesQuery = { __typename?: 'Query', readAllUserRoles: { __typename?: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ReadUserQuery = { __typename?: 'Query', readUser: { __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename?: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } } };

export type ReadTermsAndConditionsAcceptanceQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadTermsAndConditionsAcceptanceQuery = { __typename?: 'Query', readTermsAndConditionsAcceptance: { __typename?: 'TermsAndConditionsAcceptanceResponseType', accepted: boolean, termsAndConditionsVersion?: number, latestTermsAndConditionsVersion: number, latestTermsAndConditionsVersionAccepted: boolean, acceptedTimestamp?: any } };

export type ReadUserUiPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUserUiPreferencesQuery = { __typename?: 'Query', readUserUiPreferences: { __typename?: 'UserUiPreferencesResponseType', uiPreferences?: any } };

export type ReadRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type ReadRoleQuery = { __typename?: 'Query', readUserRole: { __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadUsersForRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadUsersForRoleQuery = { __typename?: 'Query', readUsersForUserRole: { __typename?: 'PaginatedUserResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean, userRoles: { __typename?: 'PaginatedUserRoleResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, users: { __typename?: 'PaginatedUserResponseType', itemCount: number, items: Array<{ __typename?: 'UserResponseType', userId: string, firstName: string, lastName: string, companyName?: string, email: string, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, source: UserSourceEnum, groupId?: string, jobTitle?: string, isSystemUser?: boolean }> }, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } }> } };

export type ReadTenantsForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadTenantsForUserQuery = { __typename?: 'Query', readAdditionalTenantsForUser: { __typename?: 'PaginatedTenantResponseType', items: Array<{ __typename?: 'TenantResponseType', tenantId: string, companyName: string, owner: { __typename?: 'OwnerUserResponseType', firstName: string, lastName: string, email: string } }> } };

export type ReadUserRoleLinksForUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ReadUserRoleLinksForUserQuery = { __typename?: 'Query', readUserRoleUserLinksForUser: { __typename?: 'PaginatedUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadUserRoleLinksForRoleQueryVariables = Exact<{
  userRoleId: Scalars['String']['input'];
}>;


export type ReadUserRoleLinksForRoleQuery = { __typename?: 'Query', readUserRoleUserLinksForUserRole: { __typename?: 'PaginatedUserRoleUserLinkResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'UserRoleUserLinkResponseType', expirationTimestamp?: any, userId: string, userRoleId: string, objectVersion?: number }> } };

export type ReadPoliciesForUserQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type ReadPoliciesForUserQuery = { __typename?: 'Query', readUserRolesForUser: { __typename?: 'PaginatedUserRoleResponseType', items: Array<{ __typename?: 'UserRoleResponseType', policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }> }> } };

export type ReadPoliciesForOwnUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadPoliciesForOwnUserQuery = { __typename?: 'Query', readUserRolesForOwnUser: { __typename?: 'PaginatedUserRoleResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'UserRoleResponseType', name: string, isSystemRole: boolean, creationTimestamp?: any, updateTimestamp?: any, objectVersion?: number, userRoleId: string, description?: string, ssoGroupMapping?: Array<string>, groupId?: string, policies: Array<{ __typename?: 'PolicyType', name: string, action: Array<string>, resource: Array<string>, description?: string }>, creationUser?: { __typename?: 'LightUserResponseType', firstName: string, lastName: string, userId: string, email: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadGroupedIdentitiesCountQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadGroupedIdentitiesCountQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedUserResponseType', itemCount: number }, readAllUserRoles: { __typename?: 'PaginatedUserRoleResponseType', itemCount: number } };

export type ReadUngroupedIdentitiesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUngroupedIdentitiesCountQuery = { __typename?: 'Query', readAllUsers: { __typename?: 'PaginatedUserResponseType', itemCount: number }, readAllUserRoles: { __typename?: 'PaginatedUserRoleResponseType', itemCount: number } };

export type ReadGroupedIdentityCountsQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGroupedIdentityCountsQuery = { __typename?: 'Query', readGroupedIdentityCounts: Array<{ __typename?: 'GroupedIdentityCountResponseType', groupId: string, users: number, userRoles: number }> };

export type IntegrationUserInfoFragment = { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean };

export type IntegrationFragment = { __typename: 'IntegrationResponseType', name: string, integrationId: string, groupId?: string, description?: string, integrationType: IntegrationTypeEnum, status: IntegrationStatusEnum, creationUserId?: string, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, metaData: { __typename?: 'GitHubIntegrationConfigType', installationId?: number, oauthStatus: string, isOrganization: boolean, ownerName?: string, ownerId?: number, ownerType?: string } };

export type GitRepositoryFragment = { __typename?: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string };

export type CreateIntegrationMutationVariables = Exact<{
  integration: CreateIntegrationInput;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', createIntegration: { __typename?: 'IntegrationResponseType', integrationId: string } };

export type UpdateIntegrationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
  integration: UpdateIntegrationInput;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateIntegration: { __typename?: 'IntegrationResponseType', integrationId: string, groupId?: string } };

export type DeleteIntegrationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type DeleteIntegrationMutation = { __typename?: 'Mutation', deleteIntegration: { __typename?: 'IntegrationResponseType', integrationId: string } };

export type SyncIntegrationMutationVariables = Exact<{
  integrationId: Scalars['String']['input'];
}>;


export type SyncIntegrationMutation = { __typename?: 'Mutation', syncIntegration: { __typename?: 'IntegrationResponseType', integrationId: string } };

export type UpdateGitRepositoryMutationVariables = Exact<{
  gitRepositoryId: Scalars['String']['input'];
  gitRepository: UpdateGitRepositoryInput;
}>;


export type UpdateGitRepositoryMutation = { __typename?: 'Mutation', updateGitRepository: { __typename?: 'GitRepositoryResponseType', gitRepositoryId: string } };

export type ReadAllIntegrationsQueryVariables = Exact<{
  filter?: InputMaybe<IntegrationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllIntegrationsQuery = { __typename?: 'Query', readAllIntegrations: { __typename?: 'PaginatedIntegrationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'IntegrationResponseType', name: string, integrationId: string, groupId?: string, description?: string, integrationType: IntegrationTypeEnum, status: IntegrationStatusEnum, creationUserId?: string, creationTimestamp?: any, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, metaData: { __typename?: 'GitHubIntegrationConfigType', installationId?: number, oauthStatus: string, isOrganization: boolean, ownerName?: string, ownerId?: number, ownerType?: string } }> } };

export type GenerateGithubInstallUrlQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
  flow?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateGithubInstallUrlQuery = { __typename?: 'Query', generateGithubInstallUrl: { __typename?: 'GithubInstallUrlType', authorizationUrl: string, state: string, flow: string } };

export type ReadAllGitRepositoriesQueryVariables = Exact<{
  filter?: InputMaybe<GitRepositoryFilterInput>;
}>;


export type ReadAllGitRepositoriesQuery = { __typename?: 'Query', readAllGitRepositories: { __typename?: 'PaginatedGitRepositoryResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string }> } };

export type ReadAllIntegrationNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAllIntegrationNamesQuery = { __typename?: 'Query', readAllIntegrations: { __typename?: 'PaginatedIntegrationResponseType', items: Array<{ __typename?: 'IntegrationResponseType', name: string, integrationId: string }> } };

export type ReadGitHubRepositoryQueryVariables = Exact<{
  gitRepositoryId: Scalars['String']['input'];
}>;


export type ReadGitHubRepositoryQuery = { __typename?: 'Query', readGitRepository: { __typename?: 'GitRepositoryResponseType', gitRepositoryId: string, name: string, integrationId: string, objectVersion?: number, gitRepositoryUrl: string } };

export type ReadGroupedIntegrationsCountQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadGroupedIntegrationsCountQuery = { __typename?: 'Query', readAllIntegrations: { __typename?: 'PaginatedIntegrationResponseType', itemCount: number } };

export type ReadUngroupedIntegrationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUngroupedIntegrationsCountQuery = { __typename?: 'Query', readAllIntegrations: { __typename?: 'PaginatedIntegrationResponseType', itemCount: number } };

export type ReadGroupedIntegrationCountsQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGroupedIntegrationCountsQuery = { __typename?: 'Query', readGroupedIntegrationCounts: Array<{ __typename?: 'GroupedIntegrationCountResponseType', groupId: string, count: number }> };

export type GlobalBackupLifecycleSettingsFragment = { __typename?: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type DeviceBackupLifecycleSettingsFragment = { __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type CreateGlobalBackupLifecycleSettingsMutationVariables = Exact<{
  globalRetentionLimit: Scalars['Int']['input'];
}>;


export type CreateGlobalBackupLifecycleSettingsMutation = { __typename?: 'Mutation', createGlobalBackupLifecycleSettings: { __typename?: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type UpdateGlobalBackupLifecycleSettingsMutationVariables = Exact<{
  globalRetentionLimit: Scalars['Int']['input'];
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateGlobalBackupLifecycleSettingsMutation = { __typename?: 'Mutation', updateGlobalBackupLifecycleSettings: { __typename?: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type DeleteGlobalBackupLifecycleSettingsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteGlobalBackupLifecycleSettingsMutation = { __typename?: 'Mutation', deleteGlobalBackupLifecycleSettings: { __typename?: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type CreateDeviceBackupLifecycleSettingsMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  retentionLimit: Scalars['Int']['input'];
}>;


export type CreateDeviceBackupLifecycleSettingsMutation = { __typename?: 'Mutation', createDeviceBackupLifecycleSettings: { __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type UpdateDeviceBackupLifecycleSettingsMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  retentionLimit: Scalars['Int']['input'];
  objectVersion?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateDeviceBackupLifecycleSettingsMutation = { __typename?: 'Mutation', updateDeviceBackupLifecycleSettings: { __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type DeleteDeviceBackupLifecycleSettingsMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type DeleteDeviceBackupLifecycleSettingsMutation = { __typename?: 'Mutation', deleteDeviceBackupLifecycleSettings: { __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type BulkCreateDeviceBackupLifecycleSettingsMutationVariables = Exact<{
  input: BulkCreateDeviceBackupLifecycleSettingsInput;
}>;


export type BulkCreateDeviceBackupLifecycleSettingsMutation = { __typename?: 'Mutation', bulkCreateDeviceBackupLifecycleSettings: { __typename?: 'BulkDeviceBackupLifecycleSettingsResponseType', failedDeviceIds: Array<string>, succeeded: Array<{ __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type BulkDeleteDeviceBackupLifecycleSettingsMutationVariables = Exact<{
  input: BulkDeleteDeviceBackupLifecycleSettingsInput;
}>;


export type BulkDeleteDeviceBackupLifecycleSettingsMutation = { __typename?: 'Mutation', bulkDeleteDeviceBackupLifecycleSettings: Array<string> };

export type ReadGlobalBackupLifecycleSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadGlobalBackupLifecycleSettingsQuery = { __typename?: 'Query', readGlobalBackupLifecycleSettings?: { __typename?: 'GlobalBackupLifecycleSettingsResponseType', tenantId: string, globalRetentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadDeviceBackupLifecycleSettingsQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ReadDeviceBackupLifecycleSettingsQuery = { __typename?: 'Query', readDeviceBackupLifecycleSettings?: { __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ListDeviceBackupLifecycleSettingsQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ListDeviceBackupLifecycleSettingsQuery = { __typename?: 'Query', listDeviceBackupLifecycleSettings: { __typename?: 'PaginatedDeviceBackupLifecycleSettingsResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'DeviceBackupLifecycleSettingsResponseType', tenantId: string, deviceId: string, retentionLimit: number, objectVersion?: number, creationUserId?: string, updateUserId?: string, creationTimestamp?: any, updateTimestamp?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type JobUserInfoFragment = { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean };

export type TargetConfigurationFragment = { __typename?: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any };

export type PipelineStepFragment = { __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: FeatureEnum, targetConfiguration: Array<{ __typename?: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> };

export type PipelineConfigurationFragment = { __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: FeatureEnum, targetConfiguration: Array<{ __typename?: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
    | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
    | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, scheduleType?: PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
  , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type TargetExecutionStatusFragment = { __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> };

export type PipelineExecutionStepFragment = { __typename: 'PipelineExecutionStepResponseType', type: FeatureEnum, name?: string, status: PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> };

export type PipelineExecutionFragment = { __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: PipelineExecutionStatusEnum, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
    | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
    | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, expression: string, scheduleType?: PipelineScheduleTypesEnum }
  , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: FeatureEnum, name?: string, status: PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> };

export type JobFragment = { __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type JobLogFragment = { __typename?: 'JobLogType', message: string, timestamp: string };

export type CreatePipelineConfigurationMutationVariables = Exact<{
  pipelineConfiguration: CreatePipelineConfigurationInput;
}>;


export type CreatePipelineConfigurationMutation = { __typename?: 'Mutation', createPipelineConfiguration: { __typename?: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type UpdatePipelineConfigurationMutationVariables = Exact<{
  pipelineConfigurationId: Scalars['String']['input'];
  input: UpdatePipelineConfigurationInput;
}>;


export type UpdatePipelineConfigurationMutation = { __typename?: 'Mutation', updatePipelineConfiguration: { __typename?: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type DeletePipelineConfigurationMutationVariables = Exact<{
  pipelineConfigurationId: Scalars['String']['input'];
}>;


export type DeletePipelineConfigurationMutation = { __typename?: 'Mutation', deletePipelineConfiguration: { __typename?: 'PipelineConfigurationResponseType', pipelineConfigurationId: string } };

export type TriggerPipelineExecutionMutationVariables = Exact<{
  pipelineConfigurationId: Scalars['String']['input'];
}>;


export type TriggerPipelineExecutionMutation = { __typename?: 'Mutation', triggerPipelineExecution: { __typename?: 'PipelineExecutionResponseType', pipelineExecutionId: string } };

export type CreateConversionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
}>;


export type CreateConversionMutation = { __typename?: 'Mutation', createJob: { __typename?: 'JobResponseType', jobId: string } };

export type DeleteJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'JobResponseType', jobId: string, deviceIds?: Array<string> } };

export type DeletePipelineExecutionMutationVariables = Exact<{
  pipelineExecutionId: Scalars['String']['input'];
}>;


export type DeletePipelineExecutionMutation = { __typename?: 'Mutation', deletePipelineExecution: { __typename?: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string } };

export type DownloadArtifactsForJobMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type DownloadArtifactsForJobMutation = { __typename?: 'Mutation', downloadArtifactsForJob: { __typename?: 'JobArtifactsResponseType', channel?: string, message?: string } };

export type CreateDeviceJobMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
  jobType: FeatureEnum;
  projectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  featureOptions?: InputMaybe<Scalars['JSON']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateDeviceJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type CreateJobMutationVariables = Exact<{
  jobType: FeatureEnum;
  deviceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectVersionIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  featureOptions?: InputMaybe<Scalars['JSON']['input']>;
  metaData?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadAllPipelinesQueryVariables = Exact<{
  filter?: InputMaybe<PipelineConfigurationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllPipelinesQuery = { __typename?: 'Query', readAllPipelineConfigurations: { __typename?: 'PaginatedPipelineConfigurationResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: FeatureEnum, targetConfiguration: Array<{ __typename?: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
        | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
        | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, scheduleType?: PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
      , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadPipelineExecutionsForPipelineQueryVariables = Exact<{
  pipelineConfigurationId: Scalars['String']['input'];
  filter?: InputMaybe<PipelineExecutionFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadPipelineExecutionsForPipelineQuery = { __typename?: 'Query', readAllPipelineExecutionsForConfiguration: { __typename?: 'PaginatedPipelineExecutionResponseType', itemCount: number, pages: number, items: Array<{ __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: PipelineExecutionStatusEnum, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
        | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
        | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, expression: string, scheduleType?: PipelineScheduleTypesEnum }
      , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: FeatureEnum, name?: string, status: PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> }> } };

export type ReadPipelineQueryVariables = Exact<{
  pipelineConfigurationId: Scalars['String']['input'];
}>;


export type ReadPipelineQuery = { __typename?: 'Query', readPipelineConfiguration: { __typename: 'PipelineConfigurationResponseType', description?: string, objectVersion?: number, name: string, enabled: boolean, pipelineConfigurationId: string, creationTimestamp?: any, updateTimestamp?: any, groupId?: string, steps: Array<{ __typename: 'PipelineStepConfigurationType', name?: string, description?: string, allowFailure: boolean, type: FeatureEnum, targetConfiguration: Array<{ __typename?: 'TargetConfigurationType', deviceIds?: Array<string>, licenseIds?: Array<string>, projectIds?: Array<string>, projectVersionIds?: Array<string>, targetMetadata?: any }> }>, trigger:
      | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
      | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, scheduleType?: PipelineScheduleTypesEnum, expression: string, expressionTimezone?: string }
    , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadAllJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllJobsQuery = { __typename?: 'Query', readAllJobs: { __typename?: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByDeviceIdsQueryVariables = Exact<{
  deviceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  jobTypes: Array<FeatureEnum> | FeatureEnum;
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadJobsByDeviceIdsQuery = { __typename?: 'Query', readJobsByDeviceIds: { __typename?: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  jobTypes: Array<FeatureEnum> | FeatureEnum;
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadJobsByProjectIdQuery = { __typename?: 'Query', readJobsByProjectId: { __typename?: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadJobsByProjectIdsQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  jobTypes: Array<FeatureEnum> | FeatureEnum;
  filter?: InputMaybe<JobFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadJobsByProjectIdsQuery = { __typename?: 'Query', readJobsByProjectIds: { __typename?: 'PaginatedJobResponseType', itemCount: number, pages: number, items: Array<{ __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadLatestJobsByProjectIdsQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  jobTypes: Array<FeatureEnum> | FeatureEnum;
  filter?: InputMaybe<JobFilterInput>;
  limitPerProject: Scalars['Int']['input'];
}>;


export type ReadLatestJobsByProjectIdsQuery = { __typename?: 'Query', readLatestJobsByProjectIds: Array<{ __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> };

export type ReadPipelineExecutionQueryVariables = Exact<{
  pipelineExecutionId: Scalars['String']['input'];
}>;


export type ReadPipelineExecutionQuery = { __typename?: 'Query', readPipelineExecution: { __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: PipelineExecutionStatusEnum, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
      | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
      | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, expression: string, scheduleType?: PipelineScheduleTypesEnum }
    , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: FeatureEnum, name?: string, status: PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> } };

export type ReadJobQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type ReadJobQuery = { __typename?: 'Query', readJob: { __typename?: 'JobResponseType', jobId: string, jobType: FeatureEnum, status: JobStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string>, projectVersionIds?: Array<string>, objectVersion?: number, creationTimestamp?: any, updateTimestamp?: any, pipelineExecutionId?: string, pipelineConfigurationId?: string, startTimestamp?: any, duration?: number, finishedTimestamp?: any, errorMessage?: string, artifactsAvailable: boolean, metaData?: any, source?: JobSourceEnum, featureOptions?: any, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } } };

export type ReadJobLogsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
  filter?: InputMaybe<JobLogsFilterInput>;
}>;


export type ReadJobLogsQuery = { __typename?: 'Query', readJobLogs: { __typename?: 'JobLogsResponseType', nextToken?: string, logs: Array<{ __typename?: 'JobLogType', message: string, timestamp: string }> } };

export type ReadPipelineNamesForPolicyRowQueryVariables = Exact<{
  filter?: InputMaybe<PipelineConfigurationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadPipelineNamesForPolicyRowQuery = { __typename?: 'Query', readAllPipelineConfigurations: { __typename?: 'PaginatedPipelineConfigurationResponseType', items: Array<{ __typename?: 'PipelineConfigurationResponseType', name: string, pipelineConfigurationId: string }> } };

export type ReadGroupedPipelinesCountQueryVariables = Exact<{
  groupId: Scalars['String']['input'];
}>;


export type ReadGroupedPipelinesCountQuery = { __typename?: 'Query', readAllPipelineConfigurations: { __typename?: 'PaginatedPipelineConfigurationResponseType', itemCount: number } };

export type ReadUngroupedPipelinesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUngroupedPipelinesCountQuery = { __typename?: 'Query', readAllPipelineConfigurations: { __typename?: 'PaginatedPipelineConfigurationResponseType', itemCount: number } };

export type ReadGroupedPipelineCountsQueryVariables = Exact<{
  groupIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadGroupedPipelineCountsQuery = { __typename?: 'Query', readGroupedPipelineCounts: Array<{ __typename?: 'GroupedPipelineCountResponseType', groupId: string, count: number }> };

export type ReadLatestExecutionsForPipelinesQueryVariables = Exact<{
  pipelineConfigurationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReadLatestExecutionsForPipelinesQuery = { __typename?: 'Query', readLatestExecutionsForPipelines: Array<{ __typename: 'PipelineExecutionResponseType', pipelineConfigurationId: string, pipelineExecutionId: string, name?: string, duration: number, status: PipelineExecutionStatusEnum, creationTimestamp?: any, updateTimestamp?: any, triggerSource:
      | { __typename?: 'PipelineManualTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum }
      | { __typename?: 'PipelineScheduledTriggerConfigurationType', type: PipelineTriggerSourceTypeEnum, expression: string, scheduleType?: PipelineScheduleTypesEnum }
    , creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, updateUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean }, steps: Array<{ __typename: 'PipelineExecutionStepResponseType', type: FeatureEnum, name?: string, status: PipelineExecutionStatusEnum, allowFailure: boolean, targets: Array<{ __typename: 'TargetExecutionStatusResponseType', jobId?: string, status: PipelineExecutionStatusEnum, projectIds?: Array<string>, deviceIds?: Array<string>, licenseIds?: Array<string> }> }> }> };

export type NotificationUserInfoFragment = { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean };

export type NotificationFragment = { __typename?: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename?: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } };

export type WebhookConfigurationFragment = { __typename?: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } };

export type CreateWebhookConfigurationMutationVariables = Exact<{
  webhookConfiguration: CreateWebhookConfigurationInput;
}>;


export type CreateWebhookConfigurationMutation = { __typename?: 'Mutation', createWebhookConfiguration: { __typename?: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateWebhookConfigurationMutationVariables = Exact<{
  webhookConfigurationId: Scalars['String']['input'];
  webhookConfiguration: UpdateWebhookConfigurationInput;
}>;


export type UpdateWebhookConfigurationMutation = { __typename?: 'Mutation', updateWebhookConfiguration: { __typename?: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type DeleteWebhookConfigurationMutationVariables = Exact<{
  webhookConfigurationId: Scalars['String']['input'];
}>;


export type DeleteWebhookConfigurationMutation = { __typename?: 'Mutation', deleteWebhookConfiguration: { __typename?: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateNotificationReadStatusMutationVariables = Exact<{
  notificationId: Scalars['String']['input'];
  readStatus: Scalars['Boolean']['input'];
}>;


export type UpdateNotificationReadStatusMutation = { __typename?: 'Mutation', updateNotificationReadStatus: { __typename?: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename?: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } } };

export type ReadAllNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllNotificationsQuery = { __typename?: 'Query', readAllNotifications: { __typename?: 'PaginatedNotificationResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename?: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } }> } };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename?: 'Query', readAllNotifications: { __typename?: 'PaginatedNotificationResponseType', itemCount: number } };

export type ReadAllWebhookConfigurationsQueryVariables = Exact<{
  filter?: InputMaybe<WebhookConfigurationFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ReadAllWebhookConfigurationsQuery = { __typename?: 'Query', readAllWebhookConfigurations: { __typename?: 'PaginatedWebhookConfigurationResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename?: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadAllowedWebhookModelKeysQueryVariables = Exact<{
  webhookEventsEnum: WebhookEventsEnum;
}>;


export type ReadAllowedWebhookModelKeysQuery = { __typename?: 'Query', readAllowedWebhookModelKeys: Array<string> };

export type ReadWebhookEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadWebhookEventsQuery = { __typename?: 'Query', readWebhookEvents: Array<WebhookEventsEnum> };

export type OffboardingFragment = { __typename?: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number };

export type CreateOffboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOffboardingMutation = { __typename?: 'Mutation', createOffboarding: { __typename?: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number } };

export type DeleteOffboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteOffboardingMutation = { __typename?: 'Mutation', deleteOffboarding?: string };

export type ReadOffboardingQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadOffboardingQuery = { __typename?: 'Query', readAllOffboardings: { __typename?: 'PaginatedOffboardingResponseType', pages: number, itemCount: number, items: Array<{ __typename?: 'OffboardingResponseType', offboardingId: string, deactivationTimestamp: any, dataPurgeTimestamp: any, tenantReactivated?: boolean, objectVersion?: number }> } };

export type ExplanationFragment = { __typename?: 'ExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: ExplanationStatus };

export type FileExplanationFragment = { __typename?: 'FileExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: FileExplanationStatus };

export type ChangeDocumentationFragment = { __typename?: 'ProjectChangeDocumentationResponseType', explanationId: string, explanation?: string, status: ProjectChangeDocumentationStatus };

export type MessageFragment = { __typename?: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> };

export type ChatFragment = { __typename?: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename?: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> }> };

export type ProjectDocumentationFragment = { __typename?: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: ProjectDocumentationStatus, explanation?: string, summary?: string, language: Language };

export type ProjectAnalysisFragment = { __typename?: 'ProjectAnalysisResponseType', analysisId: string, language: Language, vendor: string, s3ProjectTreeBucketKey: string, status: ProjectAnalysisStatus, creationTimestamp?: any };

export type CreateExplanationMutationVariables = Exact<{
  explanation: CreateExplanationInput;
}>;


export type CreateExplanationMutation = { __typename?: 'Mutation', createExplanation: { __typename?: 'ExplanationResponseType', explanationId: string } };

export type StartChatMutationVariables = Exact<{
  message: StartChatInput;
}>;


export type StartChatMutation = { __typename?: 'Mutation', startChat: { __typename?: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename?: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type ContinueChatMutationVariables = Exact<{
  message: ContinueChatInput;
}>;


export type ContinueChatMutation = { __typename?: 'Mutation', continueChat: { __typename?: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename?: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type CreateChangeDocumentationMutationVariables = Exact<{
  explanation: CreateProjectChangeDocumentationInput;
}>;


export type CreateChangeDocumentationMutation = { __typename?: 'Mutation', createChangeDocumentation: { __typename?: 'ProjectChangeDocumentationResponseType', explanationId: string, status: ProjectChangeDocumentationStatus } };

export type CreateFileExplanationMutationVariables = Exact<{
  explanation: CreateFileExplanationInput;
}>;


export type CreateFileExplanationMutation = { __typename?: 'Mutation', createFileExplanation: { __typename?: 'FileExplanationResponseType', explanationId: string } };

export type CreateFileDifferencesExplanationMutationVariables = Exact<{
  explanation: CreateFileDifferencesExplanationInput;
}>;


export type CreateFileDifferencesExplanationMutation = { __typename?: 'Mutation', createFileDifferencesExplanation: { __typename?: 'FileExplanationResponseType', explanationId: string } };

export type CreateProjectDocumentationMutationVariables = Exact<{
  documentation: CreateProjectDocumentationInput;
}>;


export type CreateProjectDocumentationMutation = { __typename?: 'Mutation', createProjectDocumentation: { __typename?: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: ProjectDocumentationStatus, explanation?: string, summary?: string, language: Language } };

export type CreateProjectAnalysisMutationVariables = Exact<{
  analysis: CreateProjectAnalysisInput;
}>;


export type CreateProjectAnalysisMutation = { __typename?: 'Mutation', createProjectAnalysis: { __typename?: 'ProjectAnalysisResponseType', analysisId: string, language: Language, vendor: string, s3ProjectTreeBucketKey: string, status: ProjectAnalysisStatus, creationTimestamp?: any } };

export type CreateProjectAnalysisPresignedUrlMutationVariables = Exact<{
  analysisId: Scalars['String']['input'];
}>;


export type CreateProjectAnalysisPresignedUrlMutation = { __typename?: 'Mutation', createProjectAnalysisPresignedUrl?: string };

export type ReadExplanationQueryVariables = Exact<{
  explanationId: Scalars['String']['input'];
}>;


export type ReadExplanationQuery = { __typename?: 'Query', readExplanation: { __typename?: 'ExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: ExplanationStatus } };

export type ReadChatQueryVariables = Exact<{
  chatId: Scalars['String']['input'];
}>;


export type ReadChatQuery = { __typename?: 'Query', readChat: { __typename?: 'ChatResponseType', chatId: string, history?: Array<{ __typename?: 'ChatMessageResponseType', creationTimestamp?: any, userId: string, message: string, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> }> } };

export type ReadAllChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadAllChatsQuery = { __typename?: 'Query', readAllChats: { __typename?: 'PaginatedChatResponseType', items: Array<{ __typename?: 'ChatResponseType', chatId: string, creationTimestamp?: any, creationUserId?: string, history?: Array<{ __typename?: 'ChatMessageResponseType', message: string, messageId: string, userId: string, chatId: string, creationTimestamp?: any, choices?: Array<{ __typename?: 'ChoiceType', question: string, answers: Array<string> }> }> }> } };

export type ReadChangeDocumentationQueryVariables = Exact<{
  explanationId: Scalars['String']['input'];
}>;


export type ReadChangeDocumentationQuery = { __typename?: 'Query', readChangeDocumentation: { __typename?: 'ProjectChangeDocumentationResponseType', explanationId: string, explanation?: string, status: ProjectChangeDocumentationStatus } };

export type ReadFileExplanationQueryVariables = Exact<{
  explanationId: Scalars['String']['input'];
}>;


export type ReadFileExplanationQuery = { __typename?: 'Query', readFileExplanation: { __typename?: 'FileExplanationResponseType', explanationId: string, explanation?: string, summary?: string, status: FileExplanationStatus } };

export type ReadProjectDocumentationQueryVariables = Exact<{
  explanationId: Scalars['String']['input'];
}>;


export type ReadProjectDocumentationQuery = { __typename?: 'Query', readProjectDocumentation: { __typename?: 'ProjectDocumentationResponseType', explanationId: string, vendor: string, projectId: string, versionId: string, status: ProjectDocumentationStatus, explanation?: string, summary?: string, language: Language } };

export type ReadProjectAnalysisQueryVariables = Exact<{
  analysisId: Scalars['String']['input'];
}>;


export type ReadProjectAnalysisQuery = { __typename?: 'Query', readProjectAnalysis: { __typename?: 'ProjectAnalysisResponseType', analysisId: string, language: Language, vendor: string, s3ProjectTreeBucketKey: string, status: ProjectAnalysisStatus, creationTimestamp?: any } };

export type StartVscodeSessionFragment = { __typename?: 'StartVscodeSessionResponse', redirectUrl: string, launchToken: string, session: { __typename?: 'VscodeSession', sessionId: string, state: VscodeSessionState, projectId: string, versionId: string } };

export type VscodeSessionFragment = { __typename?: 'VscodeSession', sessionId: string, state: VscodeSessionState, projectId: string, versionId: string };

export type CreateVscodeSessionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  versionId: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateVscodeSessionMutation = { __typename?: 'Mutation', startVscodeSession: { __typename?: 'StartVscodeSessionResponse', redirectUrl: string, launchToken: string, session: { __typename?: 'VscodeSession', sessionId: string, state: VscodeSessionState, projectId: string, versionId: string } } };

export type ReadVscodeSessionQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type ReadVscodeSessionQuery = { __typename?: 'Query', vscodeSession?: { __typename?: 'VscodeSession', sessionId: string, state: VscodeSessionState, projectId: string, versionId: string } };
